function setAdminApi(path) {

    let global = '/api_cms/';
    return global + path;
}

const api = {
    wenda: {
        query: '/api_cms/busiQuestionnaire/query',
        info: '/api_cms/busiQuestionnaire/edit/',
        save: '/api_cms/busiQuestionnaire/save',
        delete: '/api_cms/busiQuestionnaire/delete/'
    },
    questionnaire: {
        getQuestions: '/api_cms/question/getQuestionDetailById/',
        getOssUrl: '/api_cms/question/getOssUrl',
        submitQuestions: '/api_cms/questionAnswerDetail/saveQuestionDetailForApp'
    },
    juheye: {
        query: '/api_cms/busiContentPolymer/query',
        saveAll: '/api_cms/busiContentPolymer/saveAll',
        saveList: '/api_cms/busiContentPolymer/saveList',
        delete: '/api_cms/busiContentPolymer/delete',
        published: '/api_cms/busiContentPolymer/published',
        abolished: '/api_cms/busiContentPolymer/abolished',
        update: '/api_cms/busiContentPolymer/save',
        estate: '/api_cms/busiContentHouse/findByName?name=',
        getPolymerTags: '/api_cms/busiOprationTag/getPolymerTags'
    },


    login: '/api/login', // 登录
    logout: '/api/logout', // 登出
    getUserPermissions: '/api/menu/public/loadAllUserSource', // 获取用户权限
    getUser: '/api/user/login',
    getUserInfo: '/api/fwAccount/getLoginUserInfo',
    saveLog: '/api/log/saveLog',// 记录操作日志
    getUserCols: '/api/fwUserColumn/getCustom',//获取当前用户自定义列
    /**********************************1、busi start***************************************************/
    busiContentStore: {
        queryPage: "/api_cms/busiContentStore/query",
        queryPageNopig: "/api_cms/busiContentStore/queryNopig",
        add: "/api_cms/busiContentStore/add",
        edit: "/api_cms/busiContentStore/update",
        delete: "/api_cms/busiContentStore/delete",
        getStoreById: "/api_cms/busiContentStore/getStoreById",
        isRecommendById: '/api_cms/busiContentStore/isRecommendById', // 根据id是否推荐到首页
        enableIssueStatus: '/api_cms/busiContentStore/enableIssueStatus',
        disableIssueStatus: '/api_cms/busiContentStore/disableIssueStatus',
        pigeonhole: '/api_cms/busiContentStore/pigeonhole',//归档
        submitAudit: '/api_cms/busiContentStore/submitAudit', // 提交审核
        getOrgName: '/api_cms/busiContentStore/getOrgName',
        getAllOrgName: '/api_cms/busiContentStore/getAllOrgName',
        getAll: '/api_cms/busiContentStore/getAll', // 获取所有的门店信息
        setTags: '/api_cms/busiContentStore/addTags',
        getOrgCode: '/api_cms/busiContentStore/getOrgCode',
        findByName: '/api_cms/busiContentStore/findStoreByName',//根据设计师姓名模糊查询
        orgId: "/api_cms/busiContentStore/getOrgIdById",//获取orgId
    },

    //标签管理
    busiOprationTag: {
        queryPage: "/api_cms/busiOprationTag/query",
        add: "/api_cms/busiOprationTag/add",
        edit: "/api_cms/busiOprationTag/edit",
        delete: "/api_cms/busiOprationTag/delete",
        queryByParent: "/api_cms/busiOprationTag/getListByParentId",
        getListByRelationObject: "/api_cms/busiOprationTag/getListByRelationObject",
        //getAllLeaf: "/api_cms/busiOprationTag/getAllLeaf",
        active: "/api_cms/busiOprationTag/active",
        saveRelationObject: "/api_cms/busiOprationTag/saveRelationObject"
    },

    // 目标管理
    targetManage: {
        groupTargeList: "/api_busi/bizTargetManage/query",//集团目标列表
        groupAddNew: "/api_busi/bizTargetManage/addNew",//新增集团目标
        groupUpdate: "/api_busi/bizTargetManage/update",//修改集团目标
        groupUpdateStatus: "/api_busi/bizTargetManage/updateStatus/",//集团目标提交/重置,数据的id  和 状态值 如果是提交按钮就传1 重置按钮 就传0
        companyList: "/api_busi/bizTargetCompany/getAllList/",//分公司列表展示页
        getOne: "/api_busi/bizTargetCompany/getOne/",//分公司获取单条信息
        companySave: "/api_busi/bizTargetCompany/saveOne ",//保存单条分公司数据
        companyAudit: "/api_busi/bizTargetCompany/audit/",//确认或提交审核接口
        saveTargetManage: "/api_busi/bizTargetCompany/saveTargetManage",//点击目标制定 之后的保存
        addNewCompany: "/api_busi/bizTargetCompany/addNewCompany/",//添加组织
        resetStatus: "/api_busi/bizTargetCompany/resetStatus/",//重置确认,type 为 1 是重置确认的状态,type 为 2 是重置审批流程的状态
        getUnit: "/api_busi/bizTargetManage/getUnit/",//根据年与类型获取单位
        getOrgListByUser: '/api/fwAccount/getOrgListByUser',//获取视野内目标类型
        getProjectList: '/api_busi/bizTargetProjectAction/getProjectTarget/',//根据年份、月份、目标类型、分公司id查找对应的项目计划
        getCompanyData: '/api_busi/bizTargetProjectAction/findCompanyData/',
        getAllProject: '/api_busi/bizTargetProjectAction/queryServicePage/',
        addProject: '/api_busi/bizTargetProjectAction/save',//添加项目
        deleteProject: '/api_busi/bizTargetProjectAction/delete/',//删除项目
    },
    dynamicTarget: {
        getProjectMonth: '/api_busi/bizTargetDynamicDetail/findDynamicData',//左侧月份数据接口
        getProjectByMonth: '/api_busi/bizTargetDynamicDetail/getTargetDetail',//获取右边项目的接口
        submitMonth: '/api_busi/bizTargetDynamicDetail/reportConfirmStatus',//项目管家提报接口
        deleteProject: '/api_busi/bizTargetDynamicDetail/deleteDynamicTarget/',//删除单个项目接口
        getServicePage: '/api_busi/bizTargetDynamicDetail/queryServicePage/',//点击月份中添加的按钮 获取服务单的接口
        saveService: '/api_busi/bizTargetDynamicDetail/save',//选择服务单后 的 保存接口
        getTargetMonth: '/api_busi/bizTargetDynamic/findDynamicData',//左侧 获取月份 和 计划维护人员的接口
        resetTargetStatus: '/api_busi/bizTargetDynamicDetail/NonReportConfirmStatus',//重置 项目管家提报数据的接口
        submitAudit: '/api_busi/bizTargetDynamic/audit/',//提交审批流 接口
        resetStopTime: '/api_busi/bizTargetDynamic/resetStopTime/',//重置提交截止时间
        getFLowPage: '/api_busi/bizTargetDynamic/getOneTarget/',//页面获取数据的接口
        flowComplate: '/api_busi/bizTargetDynamic/complete/',//审批流页面操作审批的接口
        update: '/api_busi/bizTargetDynamicDetail/update',//单个项目保存修改
        getAllByLevel: '/api_busi/bizSettingTargetType/getAllByLevel',//获取所有的一级目标类型
        resetTargetFlow: '/api_busi/bizTargetDynamic/resetAudit',//重置 审批流程
        delDelayLog: '/api_busi/bizTargetDynamicDelay/queryPage',//查询删除日志 接口
        getOrgByType: '/api_busi/bizTargetDynamic/getOrg',//动态目标为交房类型的组织列表
        updateTime: '/api_busi/bizTargetDynamicDetail/updateTime/',//动态目标为交房类型的时间保存
    },
    deliveryTargetReach:{
        list: '/api_busi/deliveryTargetReach/list', // 分页获取数据
        detail: '/api_busi/deliveryTargetReach/detail', // 新增

    },
    reportTempAction:{
        list:'/api_busi/bizReportTempAction/page',
        add:'/api_busi/bizReportTempAction/add',
        query:'/api_busi/bizReportTempAction/queryOne',
        edit:'/api_busi/bizReportTempAction/edit',
        start:'/api_busi/bizReportTempAction/updateStatus',
        delete:'/api_busi/bizReportTempAction/delete',
        variety:'/api_busi/configComputeVariable/getAllStartByType',
    },
    personTarget: {
        getCompanys: "/api_busi/bizTargetCompany/getOneCompany",//获取分公司目标数据
        getRoles: "/api_busi/bizTargetRole/getRoleData",//获取 角色目标的数据
        addNewRole: "/api_busi/bizTargetRole/addNewRole",//添加新的 岗位数据 接口
        saveRoleTarget: "/api_busi/bizTargetRole/saveRoleTarget",//保存 岗位数据 编辑的时候用
        submitRoleTarget: "/api_busi/bizTargetRole/submitRoleTarget",//提交 岗位数据
        resetRoleTarget: "/api_busi/bizTargetRole/resetRoleTarget",//重置 岗位数据
        getRoleCodeList: "/api_busi/bizTargetRole/getRoleCodeList/{year}/{targetType}/{orgId}",//获取 岗位下拉选择的数据
        getPeople: "/api_busi/bizTargetPeople/query",//分页查询 人员目标接口
        savePeopleTarget: "/api_busi/bizTargetPeople/savePeopleTarget",//人员目标编辑时候 的保存数据
        submitPeopleTarget: "/api_busi/bizTargetPeople/submitPeopleTarget",//人员目标 提交 数据
        resetPeopleTarget: "/api_busi/bizTargetPeople/resetPeopleTarget",//人员目标重置数据
        deletePeopleTarget: "/api_busi/bizTargetPeople/deletePeopleTarget",//人员目标删除数据
        getAcctIdList: "/api_busi/bizTargetPeople/getAcctIdList",//添加人员的时候获取过滤的人员id列表
        saveAcctIdList: "/api_busi/bizTargetPeople/saveAcctIdList",//添加人员目标接口
        getPeopleSummary: "/api_busi/bizTargetPeople/getSumData",//获取人员列表合计行

    },
    //案例管理
    busiContentCase: {
        queryPage: "/api_cms/busiContentCase/query", //分页查询
        queryPageNopig: "/api_cms/busiContentCase/queryNopig",//无归档
        export: "/api_cms/busiContentCase/export",//导出
        getBusiContentCaseByid: "/api_cms/busiContentCase/getBusiContentCase",       //获取到编辑对象
        delete: "/api_cms/busiContentCase/delete",   //删除
        add: "/api_cms/busiContentCase/add",         //新增
        update: "/api_cms/busiContentCase/update",   //修改
        release: "/api_cms/busiContentCase/releaseCase",   //发布
        cancelRelease: "/api_cms/busiContentCase/cancelRelease",   //取消发布
        audit: "/api_cms/busiContentCase/auditCase",   //提交审核
        choice: "/api_cms/busiContentCase/choiceCase", //精选案例
        tags: "/api_cms/busiContentCase/findCaseByTags",//标签筛选
        addTags: "/api_cms/busiContentCase/addTags",//打标签
        recommend: "/api_cms/busiContentCase/recommend",//推荐到pc首页
        recommendToApp: "/api_cms/busiContentCase/recommendToApp",//推荐到app首页
        caseEnable: "/api_cms/busiContentCase/caseEnable",//启用
        caseDisable: "/api_cms/busiContentCase/caseDisable",//禁用
        pigeonhole: "/api_cms/busiContentCase/pigeonhole",//归档
        orgId: "/api_cms/busiContentCase/getOrgIdById",//获取orgId
    },
    //业主证言
    busiOwnerTestimony: {
        query: "/api_cms/busiOwnerTestimony/query", //分页查询
        delete: "/api_cms/busiOwnerTestimony/delete",   //删除
        add: "/api_cms/busiOwnerTestimony/add",         //新增
        edit: "/api_cms/busiOwnerTestimony/edit",   //修改
        published: "/api_cms/busiOwnerTestimony/published",   //上架
        abolished: "/api_cms/busiOwnerTestimony/abolished",   //下架
    },

    // U8接口
    u8AndPrana: {
        sysCustomer: "/api_busi/u8AndPrana/interactive"
    },
    // 操作日志接口
    fwActionLog: {
        query: "/api/fwActionLog/query",
        add: '/api/fwActionLog/add',
    },

    // 二维码管理
    qrCode: {
        queryPage: "/api_cms/busiContentQr/query", //分页查询
        add: "/api_cms/busiContentQr/add", //新增
        getById: "/api_cms/busiContentQr/getBusiContentQr", //根据id获取数据
    },
    u8VendorAction: {
        page: "/api_nc/u8VendorAction/page",
    },
    projReadyApplyPurchase: {
        byId: "/api_proj/projReadyApplyPurchase/byId",
        proMarComplete: "/api_proj/projReadyApplyPurchase/proMarComplete",
        xyComplete: "/api_proj/projReadyApplyPurchase/xyComplete",
    },
    //申购单
    ProjApplyPurchase: {
        queryPage: "/api_proj/projApplyPurchase/query",
        queryForExport: "/api_proj/projApplyPurchase/queryForExport",
        edit: "/api_proj/projApplyPurchase/edit",

    },
    // 申购单详情
    projApplyPurchaseDetail: {
        queryPage: "/api_proj/projApplyPurchaseDetail/query",
        findAllProjApplyPurchaseDetailByPurId: "/api_proj/projApplyPurchaseDetail/findAllProjApplyPurchaseDetailByPurId",//查询申购单详情
    },

    // 出库单
    ProjOutTreasury: {
        queryPage: "/api_proj/projOutTreasury/query",
    },
    // 出库明细
    projOutTreasuryDetail: {
        findOutTreasuryDetailByPurchaseId: "/api_proj/projOutTreasuryDetails/findOutTreasuryDetailByPurchaseId",
    },
    // 退货明细
    ProjReturnBillDetails: {
        findReturnBillDetailsByPurchaseId: "/api_proj/projReturnBillDetails/findReturnBillDetailsByPurchaseId"
    },
    busiProject: {
        queryName: "/api_cms/busiProject/findByName",
        queryCode: "/api_cms/busiProject/findByCode",
        queryPage: "/api_cms/busiProject/queryPage",//查询所有
        addData: "/api_cms/busiProject/add",//新增
        query: '/api_cms/busiProject/queryOne', // 查询一条信息
        update: '/api_cms/busiProject/edit',//修改项目
        delete: '/api_cms/busiProject/delete',//删除项目
        getProjectCode: '/api_cms/busiProject/getCode',//获取项目编号
    },
    workOrder: {
        initByServiceId: "/api_busi/bizCustomerWorkOrder/getByServiceId",//添加工单时初始化页面数据
        getOrderCode: "/api_busi/bizCustomerWorkOrderDetail/createOrderCode",//新增工单时获取工单dto 带出工单编号
        saveOrder: "/api_busi/bizCustomerWorkOrder/saveWorkOrder",//保存工单
        saveOrderNew: '/api_busi/bizCustomerWorkOrder/saveWorkOrderNew',//保存工单（新）
        completeKFZG: "/api_busi/bizCustomerWorkOrderDetail/completeKFZG",//工单客服主管审批
        completeKFJL: "/api_busi/bizCustomerWorkOrderDetail/completeKFJL",//工单客服经理审批
        closeKFZG: "/api_busi/bizCustomerWorkOrderCloseRecord/completeKFZG",//结案客服主管审批
        closeKFJL: "/api_busi/bizCustomerWorkOrderCloseRecord/completeKFJL",//结案客服经理审批
        queryOne: "/api_busi/bizCustomerWorkOrderDetail/getByDetailId",//通过工单id查询详情
        saveFollowRecord: "/api_busi/bizCustomerWorkOrderFollowRecord/saveFollowRecord",//保存跟进记录
        saveEndRecord: "/api_busi/bizCustomerWorkOrderCloseRecord/saveCloseRecord",//保存结案记录
        getFirstDic: "/api_busi/bizWorkOrderMoldConfig/getClassifyByLevel",//获得投诉类型dic
        getSecondDic: "/api_busi/bizWorkOrderMoldConfig/getCategoryById",//获得投诉对象dic
        getThirdDic: "/api_busi/bizWorkOrderMoldType/getTypeByConfigId",//获得归档父级dic
        getFourthDic: "/api_busi/bizWorkOrderMoldProperty/getPropertyByTypeId",//获得归档子级dic
        getPurchaseDetails: "/api_busi/BizOrderPurchaseDetail/getPurchaseDetailListByPurchaseId",//通过采购单获取明细
        submitOrder: "/api_busi/bizCustomerWorkOrderDetail/audit",//提交工单(已保存) /{id}
        submitEndRecord: "/api_busi/bizCustomerWorkOrderCloseRecord/audit",//提交结案记录(已保存) /{id}
        submitOrderNS: "/api_busi/bizCustomerWorkOrderDetail/saveAndSubmit",//提交工单(未保存)
        submitEndRecordNS: "/api_busi/bizCustomerWorkOrderCloseRecord/saveAndSubmit",//提交结案记录(未保存)
        getDeliveryDetails: "/api_busi/BizOrderSendDetailAction/queryBySendId",//通过送货单获取明细
        saveOrderDetail: "/api_busi/bizCustomerWorkOrderDetail/saveOrderDetail",//详情内保存工单
        saveOrderDetailNew: "/api_busi/bizCustomerWorkOrderDetail/saveOrderDetailNew",//详情内保存工单（新）
        submitOrderDetail: "/api_busi/bizCustomerWorkOrderDetail/saveAndSubmitDetail",//详情页提交工单
        getServicePersons: "/api_busi/bizCustomerWorkOrderDetail/getAllPerson",//查询服务单上的人员
        getNewServicePersons: "/api_busi/bizCustomerWorkOrderDetail/getNewAllPerson",//查询服务单上的人员(新 详情页用)
    },
    workOrderConfig: {
        getViewTool: "/api_busi/bizWorkOrderMoldConfig/getViewTool",//获得左侧菜单列表
        getClassifyByLevel: "/api_busi/bizWorkOrderMoldConfig/getClassifyByLevel",//获得配置项
        createClassify: "/api_busi/bizWorkOrderMoldConfig/createNewClassify",//新增二级分类
        query: "/api_busi/bizWorkOrderMoldType/query",//查询右侧列表
        addFileType: "/api_busi/bizWorkOrderMoldType/save",//新增问题归档类型
        getClassifyDetail: "/api_busi/bizWorkOrderMoldType/getTypeAndProperty",//获得二级分类详情 包括字典项等
        deleteClassify: "/api_busi/bizWorkOrderMoldConfig/deleteClassify",//删除二级分类
        modifyClassify: "/api_busi/bizWorkOrderMoldConfig/updateClassify",//修改二级分类
        delTypes: "/api_busi/bizWorkOrderMoldType/deleteType",//批量删除
        copyType: "/api_busi/bizWorkOrderMoldType/copyType",//复制归档类型
        judgeDelete: "/api_busi/bizWorkOrderMoldProperty/deleteProperty",//删除字典项时的校验
        getSonCategory: "/api_busi/bizWorkOrderMoldConfig/getCategoryById",//获得某个投诉类型下所有的二级分类
    },
    bizHomeDelivery: {
        findByProjectId: '/api_busi/bizHomeDeliveryAction/findByProjectId',
        reset:'/api_busi/bizHomeDeliveryAction/reset'
    },
    projProjectInfo: {
        queryPage: "/api_proj/projProjectInfo/query",//查询所有
        export: "/api_proj/projProjectInfo/export",//查询所有
        queryjs: "/api_proj/projProjectInfo/queryjs",//查询所有
        findById: "/api_proj/projProjectInfo/edit",
        getProjIdByServiceId: "/api_proj/projProjectInfo/getProjIdByServiceId",//根据服务订单查询项目id
        abnormalProj: "/api_proj/projProjectInfo/abnormalProj",// 异常完工
        getProjManagerSettlement: "/api_proj/projProjectInfo/getProjManagerSettlement",//根据模板Id获取主材和基装的属性项
        getProjProjectInfoDtos: "/api_proj/projProjectInfo/getProjProjectInfoDtos",//获取工程项目信息
        getProjByCode: "/api_proj/projProjectInfo/getProjectInfoByCode",//根据项目编码获取工程项目信息
        getProjPeople: "/api_proj/projectBizApi/getDispatchByBasicContractId",
        changeDesignCenter: '/api_proj/projProjectInfo/changeDesignCenter',//转设计中心
        getProjectBaseInfo: '/api_proj/projProjectInfo/getProjectBaseInfo',
        pushSatisfactionQuestionnaire: '/api_proj/projProjectInfo/pushSatisfactionQuestionnaire',
        changeToNewPlanInfo: '/api_proj/projProjectInfo/changeToNewPlanInfo',
        queryOne: '/api_proj/ProjPlanChangeTimeAction/queryOne',//获取动态计划变更信息
        getByPlanId: '/api_proj/ProjPlanDetailVersionAction/getByPlanId',//根据planid获取履历信息
        getByVersion: '/api_proj/ProjPlanDetailVersionAction/getByVersion',//更具version和planId获取计划信息

    },
    projProjectInfoExt: {
        save: "/api_proj/projProjectInfoExt/add",
        edit: "/api_proj/projProjectInfoExt/edit",
    },
    //工程质检
    projQualityCheck: {
        save: "/api_proj/projQuality/add",
    },
    projProjectConstructionPlanExcute: {
        finishEnclosureCheck: '/api_proj/projQualityAndConsPlanExecute/finishEnclosureCheck',
        appendFinish: '/api_proj/projQualityAndConsPlanExecute/appendFinish',
        saveQualityCheck: '/api_proj/projQualityAndConsPlanExecute/saveQualityCheck',
        updateQualityCheck: "/api_proj/projQualityAndConsPlanExecute/updateQualityCheck",//超级权限更改数据
        updateCustomerFile: "/api_proj/projQualityAndConsPlanExecute/updateCustomerFile",//超级权限更改数据
        startCheck: '/api_proj/projQualityAndConsPlanExecute/startCheck', // 开工校验
        finishCheck: '/api_proj/projQualityAndConsPlanExecute/finishCheck', // 完工校验
        applyCheck: '/api_proj/projQualityAndConsPlanExecute/applyCheck', // 申请验收校验
        queryPage: "/api_proj/projQualityAndConsPlanExecute/queryExecute",//查询所有
        queryPageLand: "/api_proj/projQualityAndConsPlanExecute/queryPageLand",//查询所有
        saveApplyCheck: "/api_proj/projQualityAndConsPlanExecute/saveApplyCheck",
        getCheckStatus: '/api_proj/projQualityAndConsPlanExecute/getCheckStatus',
        addExecuteMsg: '/api_proj/projQualityAndConsPlanExecute/addExecuteMsg', // POST
        addExecuteChild: '/api_proj/projQualityAndConsPlanExecute/addExecuteChild', // POST
        findProjProjectInfoByOrderId: '/api_proj/projQualityAndConsPlanExecute/findProjProjectInfoByOrderId',
        completeById: '/api_proj/projQualityAndConsPlanExecute/completeById',// 提交 get
        getProjectNowStage: '/api_proj/projQualityAndConsPlanExecute/getProjectNowStage',// 提交 get
        childComplete: '/api_proj/projQualityAndConsPlanExecute/childComplete',// 提交 get
        checkStageFineshed: '/api_proj/projQualityAndConsPlanExecute/getStageCheck',// 检验阶段验收完成情况(竣工使用)
        getCanConstructionAccptanceInto: '/api_proj/projQualityAndConsPlanExecute/getCanConstructionAccptanceInto',// 判断拆改建验收是否可以录入
        getCanConstructionCanApply: '/api_proj/projQualityAndConsPlanExecute/detail/applyCheck',// 判断拆改建验收是否可以录入
        getOperatingReservesCheck: '/api_proj/projQualityAndConsPlanExecute/getOperatingReservesCheck',//查开工准备待验收的收据
        specialSubitem: '/api_proj/projQualityAndConsPlanExecute/specialSubitem',//特殊子项info
        getCPlanInfoById: '/api_proj/projQualityAndConsPlanExecute/getCPlanInfoById',//查看子项info
        getAllChildInfo: '/api_proj/projQualityAndConsPlanExecute/getAllChildInfo',//查看子项该大阶段下子项info
    },
    //拆改建验收
    projProjectCivilEngineeringExcute: {
        queryPage: '/api_proj/projProjectCivilEngineeringExcute/query',//查询拆改建验收
    },
    projProjectPlanMaterialDetial: {
        save: '/api_proj/projProjectPlanMaterialDetial/addOne',
        update: '/api_proj/projProjectPlanMaterialDetial/update',
        queryPage: "/api_proj/projProjectPlanMaterialDetial/query",//查询所有
    },
    projProjectPlan: {
        byProjectId: '/api_proj/projProjectPlan/byProjectId',
        submitDeliveryTime: '/api_proj/projProjectPlan/submitDeliveryTime',
        updateDeliveryTime: '/api_proj/projProjectPlan/updateDeliveryTime',
        deliveryTimeComplete: '/api_proj/projProjectPlan/deliveryTimeComplete',
    },
    /**
     * 质检拆改建信息
     */
    projProjectQuatity: {
        queryPage: "/api_proj/projQualityAndConsPlanExecute/queryQuality",//查询所有 //type 1:质检，2:拆改建
        exportQuality: "/api_proj/projQualityAndConsPlanExecute/exportQuality",
        findAllProjQuality: "/api_proj/projQualityAndConsPlanExecute/getAllProjectQuality",//查询所有的质检和拆改建信息
        findProjQuality: "/api_proj/projQualityAndConsPlanExecute/getProjQuality",//查询质检信息
        findProjQualityCivil: "/api_proj/projQualityAndConsPlanExecute/getProjQualityCivil",//查询拆改建信息
        findProjQualityByType: "/api_proj/projQualityAndConsPlanExecute/getProjQualityByType",//查询通过类型查询 //type 1:质检，2:拆改建
        /* findProjQualityByProjectId: "/api_proj/projQualityAndConsPlanExecute/getProjQualityByProjectId",// 根据项目id查询质检信息
     findProjQualityCivilByProjectId: "/api_proj/projQualityAndConsPlanExecute/findProjQualityCivilByProjectId",// 根据项目id查询拆改建信息*/
        getCanAddCheck: "/api_proj/projQualityAndConsPlanExecute/getCanAddCheck",//获取项目是否可以验收录入
        getCanChangeStatus: "/api_proj/projQualityAndConsPlanExecute/getCanChangeStatus",//获取数据的状态
        getProjLastQuality: "/api_proj/projQualityAndConsPlanExecute/getProjLastQuality",//获取最近一条质检信息
        get: '/api_proj/projQualityAndConsPlanExecute/edit',//根据id获取质检记录
        complete: '/api_proj/projQualityAndConsPlanExecute/complete',//审批流接口
        getAuxiliaryMaterial: '/api_proj/projQualityAndConsPlanExecute/getAuxiliaryMaterial',//查询辅材验收清单（根据type）
        exportAuxiliaryMaterial: '/api_proj/projQualityAndConsPlanExecute/exportAuxiliaryMaterial',//导出pdf辅材验收清单（根据type）
        getPanoramicInfo: '/api_proj/projProjectInfo/findPanorama', //根据项目id获取360全景信息
        resetPanoramic: '/api_proj/projProjectInfo/resetPanorama',//根据项目id重置360全景信息
    },
    bizContractOutputValueRecord:{
        query:'/api_busi/bizContractOutputValueRecordAction/queryAll'
    },
    /**
     * 项目计划信息
     */
    projProjectConstructionPlan: {
        queryPage: "/api_proj/projProjectConstructionPlan/query",//查询所有 //type 1:质检，2:拆改建
        findAllConstructionByProjectId: '/api_proj/projProjectConstructionPlan/getAllConstructionByProjectId', //   获取所有的项目计划信息 get
        findConstructionCodesByProjectId: '/api_proj/projProjectConstructionPlan/getConstructionCodesByProjectId', //   获取所有的项目计划一级大项 get
        constructionByProjectIdAndCodes: '/api_proj/projProjectConstructionPlan/constructionByProjectIdAndCodes', //   根基项目id 计划父code数组 post
        findConstructionByProjectIdAndCode: '/api_proj/projProjectConstructionPlan/getConstructionByProjectIdAndCode', //  根基项目id 计划父code get
        findConstructionByParentId: '/api_proj/projProjectConstructionPlan/findConstructionByParentId', //  根基项目id 计划父code get
        getConstructionPlanTreeByProjectId: '/api_proj/projProjectConstructionPlan/getProjProjectConstructionPlanProjId',// 根据项目ID获取施工计划树形数据
        getMaterialPlanTreeByProjectId: '/api_proj/projProjectConstructionPlan/getMaterialPlanTreeByProjectId',//根据项目ID以施工阶段为维度的获取材料计划树形数据
        getMaterialPlanTreeHouseAreaByProjectId: '/api_proj/projProjectConstructionPlan/getMaterialPlanTreeHouseAreaByProjectId',//根据项目ID以施工阶段为维度的获取材料计划树形数据
        getCanSwitchMaterialPlanByProjectId: '/api_proj/projProjectConstructionPlan/getCanSwitchMaterialPlanByProjectId',//根据项目ID 判断是否可以切换数据展现纬度
        deleteById: '/api_proj/projProjectConstructionPlan/delete',// 删除施工计划 get
        deleteByIds: '/api_proj/projProjectConstructionPlan/delete',// 批量删除施工计划 post
        addProjProjectConstructionPlan: '/api_proj/projProjectConstructionPlan/addProjProjectConstructionPlan',// 保存施工计划 post
        appendProjProjectConstructionPlan: '/api_proj/projProjectConstructionPlan/appendProjProjectConstructionPlan',// 添加施工计划 post
        submitExamine: '/api_proj/projProjectConstructionPlan/submitExamine',// 提交 post
        submitChangeExamine: '/api_proj/projProjectConstructionPlan/submitChangeExamine',// 提交变更审核 post
        getModelRemoveConstructionPlan: '/api_proj/projProjectConstructionPlan/getModelRemoveConstructionPlan',// 获取施工计划模板数据排除当前项目的施工计划 get
        getModelRemoveDataPlan: '/api_proj/projProjectConstructionPlan/getModelRemoveDataPlan',// 获取施工计划模板数据排除子项new get
        getResult: '/api_proj/projProjectConstructionPlan/getResult',// 获取施工总进度 get
        planAuditStatus: '/api_proj/projProjectConstructionPlan/planAuditStatus',// 获取施工计划审核状态判断是否可以执行施工计划 get
        queryPlan: '/api_proj/projProjectConstructionPlan/queryPlan',// 获取项目计划
        getProjectPlanClassOne: '/api_proj/projProjectConstructionPlan/getProjectPlanClassOne',//根据项目id获取施工计划列表页
        getPlanMsg: '/api_proj/projProjectConstructionPlan/getPlanMsg',//根据项目id获取开工或者完工信息
        getHisVersions: '/api_proj/projProjectConstructionPlan/getHisVersions',//根据项目id获取版本信息列表{projectId}
        getHisVersion: '/api_proj/projProjectConstructionPlan/getHisVersion',//根据项目id获取版本信息列表{projectId}/{version}
        judgeTpl: '/api_proj/projProjectConstructionPlan/judgeTpl',//判断是否显示模板框是否显示
        judgeHasPlan: '/api_proj/projProjectConstructionPlan/judgeHasPlan',//判断是否存在施工计划
    },

    projProjectPauseAndRestart: {
        add: "/api_proj/projProjectPauseAndRestart/add",//报存停工复工信息
        query: "/api_proj/projProjectPauseAndRestart/query",// 信息分页

    },
    projConsignee: {
        query: "/api_proj/projConsignee/query", //查询收货人信息
    },
    /**
     * 项目变更信息
     */
    projProjectChange: {
        // 项目变更列表
        queryPage: "/api_proj/projProjectChargeChange/query",
        queryCanChange: "/api_busi/bizFinanceProjectPayment/judgePaymentExist/",// {projectId}/{thirdCode}
        materialChange: "/api_busi/app/biz/service/offer/getGoodDetailByServiceId/",
        projectChange: "/api_proj/app/proj/change/getChaneByProjectId",
        queryById: "/api_proj/projProjectChargeChange/edit",
        add: "/api_proj/projProjectChargeChange/add",
        // 已弃用
        queryRateByBaseContractId: '/api_busi/bizOrderBudgetDetailAction/getBudgetDetailByBaseContractId', ///getByBaseContractId/{baseContractId} 通过基装合同id查找 所有的费率表信息
        queryRateByBaseServiceId: '/api_busi/bizOrderBudgetDetailAction/getBudgetDetailByServiceId', ///getByBaseContractId/{baseContractId} 通过基装合同id查找 所有的费率表信息
        queryRateById: '/api_busi/bizOrderBudgetDetailAction/edit', // /edit/{id} 通过id查找费率表信息
        getChargeRateAll: '/api_proj/projProjectChargeChange/getChargeRateAll', // /getChargeRateAll/{projectId}/{rateId} 根基项目付款周期 项目id 费率表
        getChargeRateByProjectId: '/api_proj/projProjectChargeChange/getChargeRateByProjectId', // /getChargeRateByProjectId/{projectId}/{stage} 根基项目付款周期 项目stage
        getChargeRateByStage: '/api_proj/projProjectChargeChange/getChargeRateByStage', ///getChargeRateByStage/{projectId}/{rateId}/{stage} 根基项目付款周期 项目id 费率表
        apply: '/api_proj/projProjectChargeChange/apply/', ///getChargeRateByStage/{projectId}/{rateId}/{stage} 根基项目付款周期 项目id 费率表
        getChaneByProjectId: '/api_proj/projProjectChargeChange/getChaneByProjectId',
        queryBizOrderBudgetByOrderServiceBase: '/api_busi/bizOrderBudgetAction/getBizOrderBudgetByOrderServiceBase', ///getBizOrderBudgetByOrderServiceBase/{baseContractId} 通过基装合同id查找 预算信息






    },
    projProjectChangeDetailHistory: {
        getVersions: "/api_proj/projProjectChargeChangeDetailHistory/getVersions", // 获取历史记录的版本信息
        getHistoryDetail: "/api_proj/projProjectChargeChangeDetailHistory/getHistoryDetail" // 获取历史记录的版本信息
    },
    projProjectDispatch: {
        // 分配人员
        queryPage: "/api_proj/projProjectDispatch/query",
        // 已分配人员信息
        queryDispatchedPeople: "/api_proj/projProjectDispatch/projectPeople",
        queryDispatchedPeopleIds: "/api_proj/projProjectDispatch/projectPeopleIds",
        dispatch: '/api_proj/projProjectDispatch/add',
        queryHis: '/api_proj/projProjectPeopleChange/queryAllHis', // get projectId // 获取项目的转单履历人员信息
        queryPeople: '/api_proj/projProjectDispatch/queryAllPeople', // get projectId 获取项目分配的所有人员 详情页使用
        findPeopleByProjectId: '/api_proj/projProjectDispatch/findPeopleByProjectId',
    },
    projProjectKickoff: {
        queryPage: "/api_proj/projProjectKickoff/query",//报存停工复工信息
        queryForEngineer: "/api_proj/projProjectKickoff/queryForEngineer",//查询拆改建
        exportForEngineer: "/api_proj/projProjectKickoff/exportForEngineer",//导出拆改建
        add: "/api_proj/projProjectKickoff/add",//报存停工复工信息
        edit: "/api_proj/projProjectKickoff/edit",
        update: "/api_proj/projProjectKickoff/update",
        submitShengHe: "/api_proj/projProjectKickoff/submitShengHe",
        queryApplyAttachId: "/api_proj/projProjectKickoff/queryApplyAttachId",
        submitHouse: "/api_proj/projProjectKickoff/submitHouse",
    },
    //拆改建
    projProjectCivilEngineering: {
        queryPage: "/api_proj/projProjectCivilEngineering/query",//报存停工复工信息
        add: "/api_proj/projProjectCivilEngineering/add",//报存停工复工信息
        edit: "/api_proj/projProjectCivilEngineering/edit",
        update: "/api_proj/projProjectCivilEngineering/update",
        getById: "/api_proj/projProjectCivilEngineering/getById",
        findStatusByProject: "/api_proj/projProjectCivilEngineering/findStatusByProject",
    },
    projProjectReportCheck: {
        findProjectReport: "/api_proj/projProjectReportCheck/getProjectReport",//查询该项目下所有的项目汇报信息 get method restApi
        findProjectInspection: "/api_proj/projProjectReportCheck/getProjectInspection",//查询该项目下所有的工程巡检  get method restApi
        findProjectCheckAppearance: "/api_proj/projProjectReportCheck/getProjectCheckAppearance",//查询该项目下所有的场容巡检  get method restApi
        findProjectCheckAll: "/api_proj/projProjectReportCheck/getProjectCheckAll",//查询该项目下所有的项目汇报信息  get method restApi
        findProjectCheckByType: "/api_proj/projProjectReportCheck/getProjectCheckByType",//查询该项目下所有的汇报巡检信息 通过类型   类型(1:场容巡检,2:工程巡检,3:项目汇报)  get method restApi
        saveOrUpdateProjectCheckByType: "/api_proj/projProjectReportCheck/saveOrUpdateProjectCheckByType",//通过类型进行保存或者修改巡检信息   类型(1:场容巡检,2:工程巡检,3:项目汇报)  get method restApi
        query: '/api_proj/projProjectReportCheck/query',//分页查询项目汇报信息
        add: '/api_proj/projProjectReportCheck/add',//增加项目汇报信息
        delete: '/api_proj/projProjectReportCheck/delete',//删除项目汇报信息
        get: '/api_proj/projProjectReportCheck/edit',//获取单个项目汇报信息
        export: '/api_proj/projProjectReportCheck/export',
    },
    projProjectAuxiliaryMaterials: {
        queryPage: "/api_proj/projProjectAuxiliaryMaterials/queryPage",//查询所有
        export: "/api_proj/projProjectAuxiliaryMaterials/export",//导出
        findAllByProjectId: "/api_proj/projProjectAuxiliaryMaterials/findAllByProjectId",
        findAllByProjectIdFont: "/api_proj/projProjectAuxiliaryMaterials/findAllByProjectIdFont",
        findAllByProjectIdChecks: "/api_proj/projProjectAuxiliaryMaterials/findAllByProjectIdChecks",
        add: "/api_proj/projProjectAuxiliaryMaterials/add",//查询该项目下所有的项目汇报信息
        getProjectAuxiliaryMaterialsGoods: "/api_proj/projProjectAuxiliaryMaterials/getProjectAuxiliaryMaterialsGoods",//查询项目有没有下过申购单
        getMaterialCostByProjectId: '/api_proj/projProjectAuxiliaryMaterials/getAuxiliaryCostByProjectId', // Get
        getBizOrderServicePeopleCost: '/api_busi/bizOrderServiceAction/getBizOrderServicePeopleCost', // Get 人工成本
        getBizOrderServiceOtherCost: '/api_busi/bizOrderServiceAction/getBizOrderServiceOtherCost', // Get 其他成本
    },
    vCostManagementAction: {
        query: "/api_proj/vCostManagementAction/query",
        export: "/api_proj/vCostManagementAction/export"
    },

    assessmentAction: {
        query: "/api_proj/projAssessment/query",
        getProjectTime: "/api_proj/projAssessment/getProjectTime",
        byId: "/api_proj/projAssessment/getProjAssessmentById",
        computeSub: "/api_proj/projAssessment/computeSub",
        computeNotSub: "/api_proj/projAssessment/computeNotSub",
        computeCostingAccount: "/api_proj/projAssessment/computeCostingAccount",//非分包成本核算计算
        computeOfficeSub:"/api_proj/projAssessment/computeOfficeSub",//分包成本核算计算
        computeMaterial: '/api_proj/projAssessment/computeMaterial',
        saveOupdate: '/api_proj/projAssessment/updateAssessment',//保存
        saveAndSubmit: '/api_proj/projAssessment/saveAndSubmit',
        getAssmentFlow: '/api_proj/projAssessment/getDetailsByAssId',
        getProFlow: '/api_proj/projAssessment/complete',
        getDetails: '/api_proj/projAssessment/getDetails',
        byProjectId: '/api_proj/projAssessment/getProjAssessmentByProject',
        getRate: '/api_proj/projProfitMarginTarget/getProfitDto',//通过年份和分公司id获取利润率
        getList: '/api_proj/projProfitMarginTarget/query',//获取列表
        del: '/api_proj/projProfitMarginTarget/delete',//删除
        save: '/api_proj/projProfitMarginTarget/save',//保存
        resetting: '/api_proj/projAssessment/restartAssessment',//重置
        reset: '/api_proj/projAssessment/resetApproval',//（ first/second） 成本核算  一二阶段的重置
    },

    vCostManagementReportAction: {
        query: "/api_proj/vCostManagementReportAction/query",
    },
    busiCommodity: {
        queryPage: "/api_cms/busiCommodity/queryPage",//查询所有
        addData: "/api_cms/busiCommodity/add",//新增
        update: "/api_cms/busiCommodity/edit",//修改
        delete: "/api_cms/busiCommodity/delete",//删除
        start: "/api_cms/busiCommodity/startById",//属性状态启用
        shut: "/api_cms/busiCommodity/shutById",//属性状态停用
        getId: "/api_cms/busiCommodity/getId"//详情
    },
    busiCommodityItem: {
        queryPage: "/api_cms/busiCommodityItem/queryPage",//查询所有
        addData: "/api_cms/busiCommodityItem/add",//新增
        update: "/api_cms/busiCommodityItem/edit",//修改
        delete: "/api_cms/busiCommodityItem/delete",//删除
        getId: "/api_cms/busiCommodityItem/getID",//详情
        start: "/api_cms/busiCommodityItem/startById",//属性状态启用
        shut: "/api_cms/busiCommodityItem/shutById",//属性状态停用
    }
    ,
    busiContentDesigner: {
        queryData: '/api_cms/busiContentDesigner/query', // 查询
        queryDataNopig: '/api_cms/busiContentDesigner/queryNopig', // 查询
        addData: '/api_cms/busiContentDesigner/add', // 新增
        delete: '/api_cms/busiContentDesigner/deleteIds', // 删除
        query: '/api_cms/busiContentDesigner/getBusiContentDesignerById', // 根据设计师id查设计师
        groomByIdApp: '/api_cms/busiContentDesigner/groomByIdApp', // 根据id是否推荐到首页app
        groomByIdPc: '/api_cms/busiContentDesigner/groomByIdPc', // 根据id是否推荐到首页pc
        updateData: '/api_cms/busiContentDesigner/update', //修改
        submitAudit: '/api_cms/busiContentDesigner/submitAudit', // 提交审核
        designerPublic: '/api_cms/busiContentDesigner/publicDesigner', // 发布设计师
        removePublicDesigner: '/api_cms/busiContentDesigner/removePublic', // 取消发布设计师
        pigeonhole: '/api_cms/busiContentDesigner/pigeonhole',//归档
        findHouseByDesignerId: '/api_cms/busiContentDesigner/findHouseByDesifnerId',// 获取设计师的楼盘信息
        addTags: "/api_cms/busiContentDesigner/addTags",//标签添加
        checkDesignerPhone: '/api_cms/busiContentDesigner/checkDesignerPhone', // 检验手机号
        a: '/api_cms/busiContentDesigner/ceshi',
        findByName: '/api_cms/busiContentDesigner/findDesignerByName',//根据设计师姓名模糊查询
        bindAccount: '/api_cms/busiContentDesigner/bindAccount', // 设计师绑定商务App账户
        bindCustomer: '/api_cms/busiContentDesigner/bindCustomer', // 设计师绑定客户App账户
        orgId: "/api_cms/busiContentDesigner/getOrgIdById",//获取orgId
    },
    busiContentActive: {
        queryData: '/api_cms/busiContentActive/query', // 查询
        addData: '/api_cms/busiContentActive/add', // 新增
        edit: '/api_cms/busiContentActive/edit', // 修改 POST
        getById: '/api_cms/busiContentActive/edit',// 根据id获取数据 GET
        delete: '/api_cms/busiContentActive/delete', // 删除
        changeGroom: '/api_cms/busiContentActive/changeGroom', // 修改审核状态
        changePublic: '/api_cms/busiContentActive/changePublic', // 修改发布状态
        changeIsQr: '/api_cms/busiContentActive/changeIsQr', // 生成二维码
        addPrice: '/api_cms/busiContentActive/addPrice', // 维护活动的费用
        queryDataCheck: '/api_cms/busiContentActive/queryCheck' // 查询
    },
    busiContentActiveArrival: {},
    busiContentActiveDiscount: {},
    busiContentActiveResult: {
        queryData: '/api_cms/busiContentActiveResult/query', // 查询
        changeIsArrival: '/api_cms/busiContentActiveResult/changeIsArrival', // 确认客户到场
        add: '/api_cms/busiContentActiveResult/addCusIds', // 新增数据
        findResultByActiveId: '/api_cms/busiContentActiveResult/findResultByActiveId', // 根据活动id获取是否有绑定的客户
        deleteById: '/api_cms/busiContentActiveResult/delete', // 删除绑定活动的客户资源
    },
    busiShareStat: {
        queryData: '/api_cms/busiShareStat/query', // 分页查询
    },
    busiShareSuggestion: {
        queryData: '/api_cms/busiShareSuggestion/query', // 分页获取数据
        writeResult: '/api_cms/busiShareSuggestion/writeResult', // 填写处理结果
    },
    //楼盘基本信息展示
    //楼盘基本信息展示
    busiContentHouse: {
        queryPage: "/api_cms/busiContentHouse/query", // 查询
        add: "/api_cms/busiContentHouse/add", // 新增
        edit: "/api_cms/busiContentHouse/getBusiContentHouseById", // 根据id获取楼盘信息
        delete: "/api_cms/busiContentHouse/delete", // 删除
        update: "/api_cms/busiContentHouse/update", //修改
        findByName: "/api_cms/busiContentHouse/findByName", // 楼盘名称模糊搜索
        findByHouseCode: "/api_cms/busiContentHouse/findByHouseCode", // 楼盘编码模糊搜索
        homeSubmitAudit: "/api_cms/busiContentHouse/homeSubmitAudit", // 提交审核
        homeSubmitReset: "/api_cms/busiContentHouse/homeSubmitReset", // 重置
        busiContentHouseByHousecode: "/api_cms/busiContentHouse/busiContentHouseByHousecode", //根据楼盘编码模糊搜索,获取该楼盘下的户型种类子表明细
        houseDistributionMap: "/api_cms/busiContentHouse/houseDistributionMap",
        saveHouseOrgId: "/api_cms/busiContentHouse/saveHouseOrgId",
        export: "/api_cms/busiContentHouse/export",
    },
    busiContentHome: {
        queryPage: "/api_cms/busiContentHome/query", // 查询
        add: "/api_cms/busiContentHome/add", // 新增
        edit: "/api_cms/busiContentHome/getHomeById", // 根据id获取楼盘信息
        delete: "/api_cms/busiContentHome/delete", // 删除
        batchDelete: "/api_cms/busiContentHome/batchDelete", // 批量删除
        update: "/api_cms/busiContentHome/update", //修改
        export: "/api_cms/busiContentHome/export",//导出
    },
    // 消息模板
    busiMessageTemplate: {
        queryPage: "/api_cms/busiMessageTemplate/query", // 查询
        add: "/api_cms/busiMessageTemplate/add", // 新增
        edit: "/api_cms/busiMessageTemplate/edit", // 编辑
        delete: "/api_cms/busiMessageTemplate/delete", // 删除
        update: "/api_cms/busiMessageTemplate/update", // 修改保存
    },

    BusiMessage: {
        queryPageUser: "/api_cms/busiMessage/queryUser", // 登陆也用户消息分页查询
        queryPage: "/api_cms/busiMessage/query", // 查询
        queryUser: "/api_cms/busiMessage/getMessage", // 查询用户消息
        backUpdateIsReadBusiMessage: "/api_cms/busiMessage/backUpdateIsReadBusiMessage", //后台修改消息为已读
        getCount: "/api_cms/busiMessage/busiMessage/getCount",
        getMessage: "/api_cms/busiMessage/getMessage", // get请求
    },
    //前台楼盘信息展示
    //前台楼盘信息展示
    busiContentHouseFront: {
        queryPage: "/api_cms/busiContentHouseFront/query", // 查询
        queryPageNopig: "/api_cms/busiContentHouseFront/queryNopig",//归档查询
        add: "/api_cms/busiContentHouseFront/add", // 新增
        edit: "/api_cms/busiContentHouseFront/getBusiContentHouseFrontByid", // 根据id查询楼盘信息
        delete: "/api_cms/busiContentHouseFront/delete", // 删除
        update: "/api_cms/busiContentHouseFront/update", // 修改
        homePageById: "/api_cms/busiContentHouseFront/homePageById", // app推荐到首页
        homePageByIdPc: "/api_cms/busiContentHouseFront/homePageByIdPc", // pc推荐到首页
        homeFrontSubmitAudit: "/api_cms/busiContentHouseFront/homeFrontSubmitAudit", // 提交审核
        houseFrontRelease: "/api_cms/busiContentHouseFront/houseFrontRelease", // 发布
        houseFrontCancelRelease: "/api_cms/busiContentHouseFront/houseFrontCancelRelease", // 取消发布
        pigeonhole: '/api_cms/busiContentHouseFront/pigeonhole',//归档
        findVagueByName: "/api_cms/busiContentHouseFront/findVagueByName", // 楼盘名称模糊搜索
        findByName: "/api_cms/busiContentHouseFront/findByName", // 根据楼盘名称查询当前楼盘信息
        findByHouseCode: "/api_cms/busiContentHouseFront/findByHouseCode",
        setTags: '/api_cms/busiContentHouseFront/addTags',
        saveFrontHouseOrgId: "/api_cms/busiContentHouseFront/saveFrontHouseOrgId",
        orgId: "/api_cms/busiContentHouseFront/getOrgIdById",//获取orgId
    },
    //工地管理
    //工地管理
    busiContentWorksite: {
        queryPage: "/api_cms/busiContentWorksite/query", // 查询
        pigeonhole: "/api_cms/busiContentWorksite/pigeonhole", // 查询
        queryPageNopig: "/api_cms/busiContentWorksite/queryNopig", // 查询
        add: "/api_cms/busiContentWorksite/add", //新增
        edit: "/api_cms/busiContentWorksite/edit", // 编辑回显
        update: "/api_cms/busiContentWorksite/update", // 修改
        delete: "/api_cms/busiContentWorksite/delete", // 删除
        statusWorksiteSubmitAudit: "/api_cms/busiContentWorksite/statusWorksiteSubmitAudit", // 提交审核
        statusWorksiteRelease: "/api_cms/busiContentWorksite/statusWorksiteRelease", // 发布
        statusWorksiteCancelRelease: "/api_cms/busiContentWorksite/statusWorksiteCancelRelease", // 取消发布
        setTags: '/api_cms/busiContentWorksite/addTags',
        findByName: '/api_cms/busiContentWorksite/findWorksiteByName',//根据工地姓名模糊查询
        orgId: "/api_cms/busiContentWorksite/getOrgIdById",//获取orgId
    },
    //官网免费设计管理
    busiFreeDesign: {
        add: '/api_cms/busiFreeDesign/add',
        query: '/api_cms/busiFreeDesign/query',
        delete: '/api_cms/busiFreeDesign/delete',
        getOrgName: '/api_cms/busiFreeDesign/getOrgName',
        update: '/api_cms/busiFreeDesign/edit',
        edit: '/api_cms/busiFreeDesign/edit',// 根据id获取单条数据的接口
    },
    //装修测试问卷管理
    testQuestion: {
        queryPage: "/api_cms/testQuestion/query", // 查询
        add: "/api_cms/testQuestion/add",
        edit: "/api_cms/testQuestion/edit",
        delete: "/api_cms/testQuestion/delete",
        submitAudit: '/api_cms/testQuestion/submitAudit', // 提交审核
        enableIssueStatus: '/api_cms/testQuestion/enableIssueStatus',
        disableIssueStatus: '/api_cms/testQuestion/disableIssueStatus',
        getById: '/api_cms/testQuestion/getById'
    },
    //装修测试题目管理
    testQuestionDetail: {
        queryPage: "/api_cms/testQuestionDetail/query", // 查询
        add: "/api_cms/testQuestionDetail/add",
        edit: "/api_cms/testQuestionDetail/edit",
        delete: "/api_cms/testQuestionDetail/delete",
        getById: "/api_cms/testQuestionDetail/getById"
    },
    bizCustomerResourcesTransformation: {
        getList: "/api_cms/bizCustomerResourcesTransformation/getList",
        getHistoryList: "/api_cms/bizCustomerResourcesTransformation/getHistoryList"
    },
    busiCustomerOrderAvailableRecord: {
        getById: "/api_cms/busiCustomerOrderAvailableRecord/getById",
        complete: "/api_cms/busiCustomerOrderAvailableRecord/complete",
        getHistoryList: "/api_cms/busiCustomerOrderAvailableRecord/getHistoryList"
    },
    //装修测试答题人管理
    testQuestionAnswer: {
        queryPage: "/api_cms/testAnswer/query", // 查询
        add: "/api_cms/testAnswer/add",
        edit: "/api_cms/testAnswer/edit",
        delete: "/api_cms/testAnswer/delete",
        getById: "/api_cms/testAnswer/getById"
    },
    //装修测试题目答案明细管理
    testQuestionAnswerDetail: {
        queryPage: "/api_cms/testAnswerDetail/query", // 查询
        add: "/api_cms/testAnswerDetail/add",
        edit: "/api_cms/testAnswerDetail/edit",
        delete: "/api_cms/testAnswerDetail/delete",
        getById: "/api_cms/testAnswerDetail/getById",
        getBusiTopicListById: "/api_cms/testAnswerDetail/getBusiTopicListById"
    },
    //问卷管理
    questionProject: {
        queryPage: "/api_cms/questionProject/query", // 查询
        add: "/api_cms/questionProject/add",
        edit: "/api_cms/questionProject/edit",
        delete: "/api_cms/questionProject/delete",
        submitAudit: '/api_cms/questionProject/submitAudit', // 提交审核
        enableIssueStatus: '/api_cms/questionProject/enableIssueStatus',
        disableIssueStatus: '/api_cms/questionProject/disableIssueStatus',
        getById: '/api_cms/questionProject/getById',
        setSendRules: "/api_cms/questionProject/setSendRules",
        getAllBusiOprationQuestionDto: '/api_cms/questionProject/getAllBusiOprationQuestionDto',
        copy: '/api_cms/questionProject/copy'
    },
    //问卷管理
    question: {
        queryPage: "/api_cms/question/query", // 查询
        add: "/api_cms/question/add",
        edit: "/api_cms/question/edit",
        delete: "/api_cms/question/delete",
        submitAudit: '/api_cms/question/submitAudit', // 提交审核
        enableIssueStatus: '/api_cms/question/enableIssueStatus',
        disableIssueStatus: '/api_cms/question/disableIssueStatus',
        getById: '/api_cms/question/getById',
        setSendRules: "/api_cms/question/setSendRules",
        getAllBusiOprationQuestionDto: '/api_cms/question/getAllBusiOprationQuestionDto',
        copy: '/api_cms/question/copy'
    },
    //题目管理
    topic: {
        queryPage: "/api_cms/questionDetail/query", // 查询
        add: "/api_cms/questionDetail/add",
        edit: "/api_cms/questionDetail/edit",
        delete: "/api_cms/questionDetail/delete",
        getById: "/api_cms/questionDetail/getById",
        getQuestionDetailListByQuestionId: "/api_cms/questionDetail/getQuestionDetailListByQuestionId"
    },
    //答案管理
    answer: {
        queryPage: "/api_cms/questionAnswer/query", // 查询
        add: "/api_cms/questionAnswer/add",
        edit: "/api_cms/questionAnswer/edit",
        delete: "/api_cms/questionAnswer/delete",
        check: "/api_cms/questionAnswer/judgeHadAnswered",
        allAnswer: "/api_cms/questionAnswer/getAllAnswerDetailPage",
        isFinish: '/api_cms/questionAnswer/isFinish'
    },
    //答案明细管理
    answerDetail: {
        queryPage: "/api_cms/questionAnswerDetail/query", // 查询
        add: "/api_cms/questionAnswerDetail/add",
        edit: "/api_cms/questionAnswerDetail/edit",
        delete: "/api_cms/questionAnswerDetail/delete",
        getBusiTopicListById: "/api_cms/questionAnswerDetail/getBusiTopicListById"
    },
    extractTag: {
        query: "/api_cms/extractTag/query",
        submitAudit: "/api_cms/extractTag/submitAudit",
        reject: "/api_cms/extractTag/reject",
        addData: '/api_cms/extractTag/add',
    },
    /**
     * 新增推送管理
     */
    busiContentPush: {
        queryPage: "/api_cms/busiContentPush/query",
        add: "/api_cms/busiContentPush/add",
        edit: "/api_cms/busiContentPush/edit",
        delete: "/api_cms/busiContentPush/delete",
        update: "/api_cms/busiContentPush/update",
        publish: "/api_cms/busiContentPush/publish",
        pushSearch: "/api_cms/busiContentPush/pushSearch",
        pushSearchId: "/api_cms/busiContentPush/pushSearchId",
        test: "/api_cms/busiContentPush/testPush",
        getArea: "/api_cms/busiContentPush/getArea",
    },

    specialApprove: {
        query: "/api_busi/BizLaborCostSpecialApprove/query",
        getAmount: "/api_busi/BizLaborCostSpecialApprove/specialApproveAmount",//获取项目金额
        detail: "/api_busi/BizLaborCostSpecialApprove/getById",//详情
        save: "/api_busi/BizLaborCostSpecialApprove/add",//保存
        saveAndSubmit: "/api_busi/BizLaborCostSpecialApprove/saveAndSubmit",//保存并提交
        submit: "/api_busi/BizLaborCostSpecialApprove/submit",//提交
        doComplete: "/api_busi/BizLaborCostSpecialApprove/doComplete",
        update: "/api_busi/BizLaborCostSpecialApprove/edit",
    },

    ecItemCat: {
        getClassificationTreeData: "/api_busi/ecItemCatAction/getByPid",//获取商品分类树结构
        getClassificationTreeDataThird: "/api_busi/ecItemCatAction/getMultilevelByPid",//获取商品分类树结构带三级分类
        query: "/api_busi/ecItemCatAction/query",//获取商品分类
        getAllSecCat: "/api_busi/ecItemCatAction/getAllSecCat",//获取all的二级分类
    },
    ecBrandCatMapping: {
        queryPage: "/api_busi/ecBrandCatMappingAction/query",
        queryList: "/api_busi/ecBrandCatMappingAction/list",//根据条件获取list
        queryBrand: "/api_busi/ecBrandCatMappingAction/queryBrandByCid",//根据条件获取list
        allBrand: "/api_busi/ecBrandCatMappingAction/allBrand",//获取全部品牌
    },
    cmdExportConfig: {
        queryPage: "/api/cmdExportConfig/query",
        add: "/api/cmdExportConfig/add",
        edit: "/api/cmdExportConfig/edit",
        delete: "/api/cmdExportConfig/delete",
        uploadTemplate: "/api/cmdExportConfig/upload",
        //exportExamples: '/api/excelAction/export',
    },
    CmdExportLog: {
        queryPage: "/api/cmdExportLog/query",
    },
    CmdImportLog: {
        queryPage: "/api/cmdImportLog/query",
    },
    cmdImportConfig: {
        queryPage: "/api/cmdImportConfig/query",
        add: "/api/cmdImportConfig/add",
        update: "/api/cmdImportConfig/update",
        delete: "/api/cmdImportConfig/delete",
        uploadTemplate: "/api/cmdImportConfig/excelImportTplUpload",//post
        downloadTemplate: "/api/cmdImportConfig/downloadImportTemplate",//get
        //exportExamples: '/api/excelAction/import',
    },
    cmdImportFieldConfig: {
        queryByImportConfigId: "/api/cmdImportFieldConfig/findCmdImportFieldConfigByImportConfigId",
        add: "/api/cmdImportFieldConfig/add",
        update: "/api/cmdImportFieldConfig/update",
        delete: "/api/cmdImportFieldConfig/delete",
    },
    CmdExportTableConfig: {
        queryPage: "/api/cmdExportTableConfig/query",
        add: "/api/cmdExportTableConfig/add",
        update: "/api/cmdExportTableConfig/update",
        findAllByTableAliasName: "/api/cmdExportTableConfig/findCmdExportTableConfigByTableAliasName",
    },
    cmdExportFieldConfig: {
        add: "/api/cmdExportFieldConfig/add",
        update: "/api/cmdExportFieldConfig/update",
        queryPage: "/api/cmdExportFieldConfig/query",
        delete: "/api/cmdExportFieldConfig/delete",
    },
    busiCustomer: {
        queryData: '/api_cms/busiCustomer/query',//查询
        addData: '/api_cms/busiCustomer/addNewCustomer',//新增
        query: '/api_cms/busiCustomer/edit', // 查询一条
        update: '/api_cms/busiCustomer/updateCustomer',//修改用户主要信息
        delete: '/api_cms/busiCustomer/delete',//删除用户
        updatePhone: '/api_cms/busiCustomer/updatePhone',//修改用户手机号
        markCustomer: '/api_cms/busiCustomer/markCustomer',//用户打标签
        fuzzyQuery: '/api_cms/busiCustomer/fuzzyQuery',//模糊查询客户姓名
        findByMobilePhone: '/api_cms/busiCustomer/findByMobilePhone',//通过手机号获取客户
    },
    busiCustomerBook: {
        queryData: '/api_cms/busiCustomerBook/query',//查询
        ignore: '/api_cms/busiCustomerBook/ignore',//忽略
        updateBookAndOnline: '/api_cms/busiCustomerBook/updateBookAndOnline',//创建资源
        getPhoneNumsByBookId: '/api_cms/busiCustomerBook/getPhoneNumsByBookId',//跟据预约id 获取 手机号 的 数量
        existCreatedBookByCustomerOrderId: '/api_cms/busiCustomerBook/existCreatedBookByCustomerOrderId',//是否存在已经创建的资源
    },
    busiCustomerRegister: {
        queryPage: "/api_cms/busiCustomerRegister/query",//查询
        addData: "/api_cms/busiCustomerRegister/add",//新增
        query: '/api_cms/busiCustomerRegister/queryOne', // 查询一条信息
        update: '/api_cms/busiCustomerRegister/updateMember',//修改用户主要信息
        delete: '/api_cms/busiCustomerRegister/delete',//删除用户
        updatePhone: '/api_cms/busiCustomerRegister/updatePhone',//修改会员手机号
        resetPassword: '/api_cms/busiCustomerRegister/resetPasswordIds',//重置会员密码
        getCusName: '/api_cms/busiCustomerRegister/getCusName',//重置会员密码
    },
    busiCustomerOrderOld: {
        query: '/api_cms/busiCustomerOrderOld/query', // 查询一条
        queryDisplay: '/api_cms/busiCustomerOrderOld/queryDisplay',//展示一条
        querySeaData: '/api_cms/busiCustomerOrderOld/querySea',//查询公海
        pondExport: '/api_cms/busiCustomerOrderOld/pondExport',//鱼塘订单导出
        seaExport: '/api_cms/busiCustomerOrderOld/seaExport',//公海订单导出
        queryPondData: '/api_cms/busiCustomerOrderOld/queryPond',//查询鱼塘
        queryAbandonData: '/api_cms/busiCustomerOrderOld/queryAbandon',//查询废单
        queryRepeat: '/api_cms/busiCustomerOrderOld/queryRepeat',//查询相同手机号订单
        addData: '/api_cms/busiCustomerOrderOld/addNewOrder',//新增
        updateNotIgnoreNull: '/api_cms/busiCustomerOrderOld/updateNotIgnoreNull',//修改订单
        improve: '/api_cms/busiCustomerOrderOld/improve',//完善
        pump: '/api_cms/busiCustomerOrderOld/pump',//撞单
        queryCustomerData: '/api_cms/busiCustomerOrderOld/query',//根据客户id分页查询
        assign: '/api_cms/busiCustomerOrderOld/assignIds',//分派订单
        queryLife: '/api_cms/busiCustomerOrderOld/queryLife',//查询客户订单及订单跟踪信息
        markOrder: '/api_cms/busiCustomerOrderOld/markOrder',//用户打标签
        abandonOrder: '/api_cms/busiCustomerOrderOld/abandonOrder',//废单
        retreatOrder: '/api_cms/busiCustomerOrderOld/retreatOrder',//退回订单
        getOrderCode: '/api_cms/busiCustomerOrderOld/getOrderCode',//获取需求订单号
        dockingOrder: '/api_cms/busiCustomerOrderOld/dockingOrder',//对接
        getUser: '/api_cms/busiCustomerOrderOld/getUser',//获取当前用户信息
        getOrderNumber: '/api_cms/busiCustomerOrderOld/getOrderNumberByMobilePhone',//根据手机号获取该手机号的客户资源数量
        queryPondByAcctId: '/api_cms/busiCustomerOrderOld/queryPondByAcctId', // 获取鱼塘用户并用销售id筛选
        audit: '/api_cms/busiCustomerOrderOld/audit',
        complete: '/api_cms/busiCustomerOrderOld/complete',
        completeChoose: '/api_cms/busiCustomerOrderOld/completeChoose',
        completeBranch: '/api_cms/busiCustomerOrderOld/completeBranch',
        completeDesigner: '/api_cms/busiCustomerOrderOld/completeDesigner',
        getAllFwAccount: '/api_cms/busiCustomerOrderOld/getAllFwAccount',
        queryBillboardNum: '/api_cms/busiCustomerOrderOld/queryBillboardNum',
        queryBillboardNumForManage: '/api_cms/busiCustomerOrderOld/queryBillboardNumForManage',
        getReport: '/api_cms/busiCustomerOrderOld/report',
        getReportDetail: '/api_cms/busiCustomerOrderOld/reportDetail'
    },
    busiCustomerOrderGround: {
        query: '/api_cms/busiCustomerOrder/query', // 查询一条
        queryDisplay: '/api_cms/busiCustomerOrder/queryDisplay',//展示一条
        queryPage: '/api_cms/busiCustomerOrder/queryPage',//查询公海
        queryPageNonGround: '/api_cms/busiCustomerOrder/queryPageNonGround',//查询非地勤
        queryExport: '/api_cms/busiCustomerOrder/queryExport',//公海订单导出
        //queryPondData: '/api_cms/busiCustomerOrder/queryPond',//查询鱼塘
        //queryAbandonData: '/api_cms/busiCustomerOrder/queryAbandon',//查询废单
        queryRepeat: '/api_cms/busiCustomerOrder/queryRepeat',//查询相同手机号订单
        addData: '/api_cms/busiCustomerOrder/addNewOrder',//新增
        updateNotIgnoreNull: '/api_cms/busiCustomerOrder/updateNotIgnoreNull',//修改订单
        improve: '/api_cms/busiCustomerOrder/improve',//完善
        pump: '/api_cms/busiCustomerOrder/pump',//撞单
        queryCustomerData: '/api_cms/busiCustomerOrder/query',//根据客户id分页查询
        assign: '/api_cms/busiCustomerOrder/assignIds',//分派订单
        queryLife: '/api_cms/busiCustomerOrder/queryLife',//查询客户订单及订单跟踪信息
        markOrder: '/api_cms/busiCustomerOrder/markOrder',//用户打标签
        abandonOrder: '/api_cms/busiCustomerOrder/abandonOrder',//废单
        retreatOrder: '/api_cms/busiCustomerOrder/retreatOrder',//退回订单
        getOrderCode: '/api_cms/busiCustomerOrder/getOrderCode',//获取需求订单号
        dockingOrder: '/api_cms/busiCustomerOrder/dockingOrder',//对接
        getUser: '/api_cms/busiCustomerOrder/getUser',//获取当前用户信息
        getOrderNumber: '/api_cms/busiCustomerOrder/getOrderNumberByMobilePhone',//根据手机号获取该手机号的客户资源数量
        queryPondByAcctId: '/api_cms/busiCustomerOrder/queryPondByAcctId', // 获取鱼塘用户并用销售id筛选
        audit: '/api_cms/busiCustomerOrder/audit',//资源派单申请
        auditNonGround: '/api_cms/busiCustomerOrder/auditNonGround',//非地勤派单申请
        complete: '/api_cms/busiCustomerOrder/complete',
        completeChoose: '/api_cms/busiCustomerOrder/completeChoose',
        completeBranch: '/api_cms/busiCustomerOrder/completeBranch',
        completeDesigner: '/api_cms/busiCustomerOrder/completeDesigner',
        getAllFwAccount: '/api_cms/busiCustomerOrder/getAllFwAccount',
        queryBillboardNum: '/api_cms/busiCustomerOrder/queryBillboardNum',
        queryBillboardNumForManage: '/api_cms/busiCustomerOrder/queryBillboardNumForManage'
    },
    busiCustomerPeopleLimit:{
        getLimitList:'/api_cms/busiCustomerPeopleLimit/getLimitList',
        saveNewLimit:'/api_cms/busiCustomerPeopleLimit/saveNewLimit',
    },
    busiCustomerOrderOnline: {
        consultationType: '/api_cms/busiCustomerOrderOnline/consultationType',
        judgment: '/api_cms/busiCustomerOrderOnline/judgment',
        judgmentCheck: '/api_cms/busiCustomerOrderOnline/judgmentCheck',
        checkoutSendOrder: '/api_cms/busiCustomerOrderOnline/checkoutSendOrder',
        getOnlineAndRelatedById: '/api_cms/busiCustomerOrderOnline/getOnlineAndRelatedById',
        transferOfOrder: '/api_cms/busiCustomerOrderOnline/transferOfOrderPC',
        changeServiceType: '/api_cms/busiCustomerOrderOnline/updateServiceClassify',// 服务分类
        updateCustomerCapital: '/api_cms/busiCustomerOrderOnline/updateCustomerCapital',// 更改客资类型
        updateCustomerDoubt: '/api_cms/busiCustomerOrderOnline/updateCustomerDoubt',// 判定有无疑惑
        updateFirstOrderSale: '/api_cms/busiCustomerOrderOnline/updateFirstSale',// 更改第一接单人
        updateCustomerService: '/api_cms/busiCustomerOrderOnline/customerServicePC',// 派在线客服
        add: '/api_cms/busiCustomerOrderOnline/addNewOrder',//新增
        queryView: '/api_cms/busiCustomerOrderOnline/queryView',//分页查询视图
        query: '/api_cms/busiCustomerOrderOnline/query', // 查询一条
        queryDisplay: '/api_cms/busiCustomerOrderOnline/queryDisplay',//展示一条
        queryPage: '/api_cms/busiCustomerOrderOnline/queryPage',//查询公海
        queryExport: '/api_cms/busiCustomerOrderOnline/queryExport',//公海订单导出
        //queryPondData: '/api_cms/busiCustomerOrderOnline/queryPond',//查询鱼塘
        //queryAbandonData: '/api_cms/busiCustomerOrderOnline/queryAbandon',//查询废单
        queryRepeat: '/api_cms/busiCustomerOrderOnline/queryRepeat',//查询相同手机号订单
        addData: '/api_cms/busiCustomerOrderOnline/addNewOrder',//新增
        updateNotIgnoreNull: '/api_cms/busiCustomerOrderOnline/updateNotIgnoreNull',//修改订单
        updateIgnoreSensitiveInformation: '/api_cms/busiCustomerOrderOnline/updateIgnoreSensitiveInformation',//强制修改订单
        improve: '/api_cms/busiCustomerOrderOnline/improve',//完善
        pump: '/api_cms/busiCustomerOrderOnline/pump',//撞单
        queryCustomerData: '/api_cms/busiCustomerOrderOnline/query',//根据客户id分页查询
        assign: '/api_cms/busiCustomerOrderOnline/assignIds',//分派订单
        queryLife: '/api_cms/busiCustomerOrderOnline/queryLife',//查询客户订单及订单跟踪信息
        markOrder: '/api_cms/busiCustomerOrderOnline/markOrder',//用户打标签
        abandonOrder: '/api_cms/busiCustomerOrderOnline/abandonOrder',//废单
        retreatOrder: '/api_cms/busiCustomerOrderOnline/retreatOrder',//退回订单
        getOrderCode: '/api_cms/busiCustomerOrderOnline/getOrderCode',//获取需求订单号
        dockingOrder: '/api_cms/busiCustomerOrderOnline/dockingOrder',//对接
        getUser: '/api_cms/busiCustomerOrderOnline/getUser',//获取当前用户信息
        getOrderNumber: '/api_cms/busiCustomerOrderOnline/getOrderNumberByMobilePhone',//根据手机号获取该手机号的客户资源数量
        queryPondByAcctId: '/api_cms/busiCustomerOrderOnline/queryPondByAcctId', // 获取鱼塘用户并用销售id筛选
        audit: '/api_cms/busiCustomerOrderOnline/audit',
        complete: '/api_cms/busiCustomerOrderOnline/complete',
        completeChoose: '/api_cms/busiCustomerOrderOnline/completeChoose',
        completeBranch: '/api_cms/busiCustomerOrderOnline/completeBranch',
        completeDesigner: '/api_cms/busiCustomerOrderOnline/completeDesigner',
        getAllFwAccount: '/api_cms/busiCustomerOrderOnline/getAllFwAccount',
        queryBillboardNum: '/api_cms/busiCustomerOrderOnline/queryBillboardNum',
        queryBillboardNumForManage: '/api_cms/busiCustomerOrderOnline/queryBillboardNumForManage',
        treeMenu: '/api_cms/busiCustomerOrderOnline/getViewTool',
        treeMenuNew: '/api_cms/busiCustomerOrderOnline/getViewToolNew',
        getOnlineReport: '/api_cms/busiCustomerOrderOnline/getOnlineReport',
        getOnlineChannel: '/api_cms/busiCustomerOrderOnline/getOnlineChannel ',//网销资源端渠道管理看板
        netPinReport: '/api_cms/busiCustomerOrderOnline/netPinReport', //网销运营数据报表接口
        getAssignment: '/api_cms/busiCustomerOrderOnline/getViewToolByAssignment/',//获取临时鱼塘列表
        assignmentSaleMan: '/api_cms/busiCustomerOrderOnline/assignmentSaleMan',
        getOnlineChannelNew: '/api_cms/busiCustomerOrderOnline/getOnlineChannelNew ',//网销资源端渠道管理看板
    },
    busiChannelOnlineReportTitle:{
        getTitleList:'/api_cms/busiChannelOnlineReportTitle/getTitleList',//获取表头
    },
    busiCustomerOrderExt: {
        submit: '/api_cms/busiCustomerOrderExt/submit',//新增
        get: '/api_cms/busiCustomerOrderExt/get',
        getByTypeAndSourceId: '/api_cms/busiCustomerOrderExt/getByTypeAndSourceId',
        add: '/api_cms/busiCustomerOrderExt/add',//新增
    },
    busiAfterSalesRepair: {
        query: '/api_cms/busiAfterSalesRepair/query',//查询全部
        updateStatus: '/api_cms/busiAfterSalesRepair/update',//处理
        designateHandler: '/api_cms/busiAfterSalesRepair/designateHandler',//指派处理人
        getLogs: '/api_cms/busiAfterSalesRepair/getLog',//操作日志
        add: '/api_cms/busiAfterSalesRepair/add',//新增
        delete: '/api_cms/busiAfterSalesRepair/delete',//删除
        edit: '/api_cms/busiAfterSalesRepair/edit',//更新
    },
    projCostManagement: {
        queryData: '/api_proj/projCostManagement/queryData',
    },
    projHouseFinanceReceiveAction: {
        queryDataWithDate: '/api_proj/projHouseFinanceReceiveAction/queryDataWithDate',
    },
    vProjHouseFinanceProjectAction: {
        query: '/api_proj/vProjHouseFinanceProjectAction/query',
        queryByType: '/api_proj/vProjHouseFinanceProjectAction/queryByType',
        queryReceivableByType: '/api_proj/vProjHouseFinanceProjectAction/queryReceivableByType',
    },
    projDeliveryDataAction: {
        list: '/api_busi/projDeliveryDataAction/list',
    },
    vProStartOperationAction: {
        query: '/api_proj/vProStartOperationAction/query',
    },
    projDeliveryTargetAction: {
        query: '/api_busi/projDeliveryTargetAction/query',
        saveOrUpdate: '/api_busi/projDeliveryTargetAction/saveOrUpdate',
        updateStatus: '/api_busi/projDeliveryTargetAction/updateStatus',
        getTargetById: '/api_busi/projDeliveryTargetAction/getTargetById',
    },
    bizGoalAttainment: {
        queryAll: "/api_busi/bizGoalAttainmentAction/getGoalAttainment",
    },

    fullCaseProductAnalysis: {
        queryAll: "/api_busi/fullCaseProductAnalysis/queryAll",
    },
    busiOperationAnalysis: {
        query: '/api_busi/busiOperationAnalysis/queryAll', // 分公司 设计中心 销售 等维度的数据查询
        queryMonitoring: '/api_busi/busiOperationAnalysis/queryAllMonitoring', // 分公司 设计中心 销售 等维度的数据查询(资源盯控)
        queryMonitoringTotal: '/api_busi/busiOperationAnalysis/total', // 分公司 设计中心 销售 等维度的数据查询(资源盯控 汇总)
        queryPersonalPage: '/api_busi/busiOperationAnalysis/queryPersonalPage', // 个人维度的数据查询
        queryPersonalMonitorPage: '/api_busi/busiOperationAnalysis/queryPersonalMonitorPage', // 个人维度的数据查询(盯控)
        queryDetail: '/api_busi/busiOperationAnalysis/queryDetail', // 查询明细
        queryPersonalDetail: '/api_busi/busiOperationAnalysis/queryPersonalDetail', // 查询个人明细
        queryMonitoringDetail: '/api_busi/busiOperationAnalysis/queryMonitoringDetail', // 查询盯控明细
        queryMonitoringTotalDetail: '/api_busi/busiOperationAnalysis/queryMonitoringTotalDetail', // 查询盯控累计明细
        queryPersonalMonitoringTotalDetail: '/api_busi/busiOperationAnalysis/queryPersonalMonitoringTotalDetail', // 查询个人累计明细
        queryPersonalMonitoringDetail: '/api_busi/busiOperationAnalysis/queryPersonalMonitoringDetail', // 查询个人本期明细
        querySaleManager: '/api_busi/busiOperationAnalysis/querySaleManager', // 营销主管查询运营分析
        queryAllMonitoringForSaleMan: '/api_busi/busiOperationAnalysis/queryAllMonitoringForSaleMan', // 营销主管查询盯控
        querySaleManagerDetail: '/api_busi/busiOperationAnalysis/querySaleManagerDetail', // 营销主管查看明细
        queryMonitoringSaleManagerDetail: '/api_busi/busiOperationAnalysis/queryMonitoringSaleManagerDetail', // 查询盯控明细
        queryMonitoringSaleManagerTotalDetail: '/api_busi/busiOperationAnalysis/queryMonitoringSaleManagerTotalDetail', // 查询盯控累计明细
        queryMarking: '/api_busi/busiOperationAnalysis/markingReport', // 查询营销数据
        areaRate: '/api_busi/busiOperationAnalysis/areaRate', // 查询面积占比
        areaRateSaleManager: '/api_busi/busiOperationAnalysis/areaRateSaleManager', // 查询面积占比-营销主管
        queryVConstructionDrawingBranchDimension: '/api_busi/vConstructionDrawingBranchDimension/query', // 图纸管理报表-分公司维度报表
        exportVConstructionDrawingBranchDimension: '/api_busi/vConstructionDrawingBranchDimension/export', // 图纸管理报表-分公司维度报表
        queryVConstructionDrawingDesignerDimension: '/api_busi/vConstructionDrawingDesignerDimension/query', // 图纸管理报表-设计师维度报表
        exportVConstructionDrawingDesignerDimension: '/api_busi/vConstructionDrawingDesignerDimension/export', // 图纸管理报表-设计师维度报表
    },
    manageOutput: {
        queryAll: '/api_busi/manageOutputValue/queryAll',// 查询主表数据
        queryDetail: '/api_busi/manageOutputValue/detail',// 查询明细
        exportExcel:'/api_busi/manageOutputValue/exportExcel',// 导出主表
    },
    projectReceiptCompletionAction: {
        queryDetail: '/api_busi/projectReceiptCompletionAction/queryDetail',
        queryAll: '/api_busi/projectReceiptCompletionAction/queryAll',
        export: '/api_busi/projectReceiptCompletionAction/export'
    },
    bizNodeInstanceDetailAction: {
        findAllByDay: '/api_busi/bizNodeInstanceDetailAction/findAllByDay',
        findUnfinishedAll: '/api_busi/bizNodeInstanceDetailAction/findUnfinishedAll',
        findFinishedAll: '/api_busi/bizNodeInstanceDetailAction/findFinishedAll',
        findListDays: '/api_busi/bizNodeInstanceDetailAction/findListDays',
        edit: '/api_busi/bizNodeInstanceDetailAction/edit',// 根据id获取单条数据的接口
        findAllCanRestartNodeByInstanceId: '/api_busi/bizNodeInstanceDetailAction/findAllCanRestartNodeByInstanceId',// 根据instanceId获取所有已完成节点
        finishNode: '/api_busi/bizNodeInstanceDetailAction/finishNode',// 提交执行完成接口
        updateResult: '/api_busi/bizNodeInstanceDetailAction/updateResult',// 更新执行结果接口
        restartNode: '/api_busi/bizNodeInstanceDetailAction/restartNode',//提交再执行接口
        restartComplete: '/api_busi/bizNodeInstanceDetailAction/restartComplete',// 再执行审批接口
        postponeNode: '/api_busi/bizNodeInstanceDetailAction/postponeNode',//提交延期接口
        postponeComplete: '/api_busi/bizNodeInstanceDetailAction/postponeComplete',// 延期审批接口
        changeExecuteIds: '/api_busi/bizNodeInstanceDetailAction/changeExecuteIds',// 更换执行人
        findListDtoByRestartFlowId: '/api_busi/bizNodeInstanceDetailAction/findListDtoByRestartFlowId',// 根据再执行flowId查询所有的再执行节点
        getMultiForm: '/api_busi/bizNodeInstanceDetailAction/getMultiForm',
    },
    bizNodePostponeRecordAction: {
        getBizNodePostponeRecordByFlowId: '/api_busi/bizNodePostponeRecordAction/getBizNodePostponeRecordByFlowId',
    },
    bizNodeExecutorRecordAction: {
        getByDetailId: '/api_busi/bizNodeExecutorRecordAction/getByDetailId'// 根据明细id获取执行人更换履历
    },
    bizNodeInstanceAction: {
        query: '/api_busi/bizNodeInstanceAction/query',
        treeTable: '/api_busi/bizNodeInstanceAction/treeTable',
        cancelBinding: '/api_busi/bizNodeInstanceAction/cancelBinding',
        getAllVersions: '/api_busi/bizNodeInstanceAction/getAllVersions',
        queryById: '/api_busi/bizNodeInstanceAction/queryById',
        getStartTime: '/api_busi/bizNodeInstanceAction/findStartTime',
        editStartTime: '/api_busi/bizNodeInstanceAction/editStartTime',
        updateStartTime: '/api_busi/bizNodeInstanceAction/updateStartTime',
        bindTemplate: '/api_busi/bizNodeInstanceAction/bindTemplate',
        queryHistory: '/api_busi/bizNodeInstanceAction/queryHistory',
        getRestartHistory: '/api_busi/bizNodeInstanceAction/getRestartHistory',
        getPostpone: '/api_busi/bizNodeInstanceAction/getPostpone',
        restartFlowDetail: '/api_busi/bizNodeInstanceAction/restartFlowDetail',
        postponeFlowDetail: '/api_busi/bizNodeInstanceAction/postponeFlowDetail',
        export: '/api_busi/bizNodeInstanceAction/export',
        queryForExecuteById: '/api_busi/bizNodeInstanceAction/queryForExecuteById',
    },
    bizNodePolicyPaperAction: {
        add: '/api_busi/bizNodePolicyPaperAction/add',
        query: '/api_busi/bizNodePolicyPaperAction/query',
        getAll: '/api_busi/bizNodePolicyPaperAction/getAll',//通过类型查找全量节点数据的接口
        delete: '/api_busi/bizNodePolicyPaperAction/delete',
        update: '/api_busi/bizNodePolicyPaperAction/update',
        edit: '/api_busi/bizNodePolicyPaperAction/edit',// 根据id获取单条数据的接口
        all: '/api_busi/bizNodePolicyPaperAction/getAll', //通过类型查找全量节点数据的接口
        findAll: '/api_busi/bizNodePolicyPaperAction/findAll', //全量数据的接口
        getAllParent: '/api_busi/bizNodePolicyPaperAction/getAllParent', //父节点
    },
    bizNodeTemplateAction: {
        add: '/api_busi/bizNodeTemplateAction/add',
        query: '/api_busi/bizNodeTemplateAction/query',
        queryForBind: '/api_busi/bizNodeTemplateAction/queryForBind',
        delete: '/api_busi/bizNodeTemplateAction/delete',
        update: '/api_busi/bizNodeTemplateAction/update',
        edit: '/api_busi/bizNodeTemplateAction/edit',// 根据id获取单条数据的接口
        updateStatus: '/api_busi/bizNodeTemplateAction/updateStatus',// 根据id获取单条数据的接口
        copyNodeTemp: '/api_busi/bizNodeTemplateAction/copyNodeTemp',// 复制模板
    },
    bizNodeRemindTempAction: {
        add: '/api_busi/bizNodeRemindTempAction/add',
        query: '/api_busi/bizNodeRemindTempAction/query',
        delete: '/api_busi/bizNodeRemindTempAction/delete',
        update: '/api_busi/bizNodeRemindTempAction/update',
        edit: '/api_busi/bizNodeRemindTempAction/edit',// 根据id获取单条数据的接口
    },
    bizContractTaxRateAction: {
        saveOrUpdate: '/api_busi/bizContractTaxRate/saveOrUpdate',
        query: '/api_busi/bizContractTaxRate/query',
        delete: '/api_busi/bizContractTaxRate/delete',
        queryById: '/api_busi/bizContractTaxRate/queryById',// 根据id获取单条数据的接口
    },
    bizNodeApplicableRulesAction: {
        add: '/api_busi/bizNodeApplicableRulesAction/add',
        query: '/api_busi/bizNodeApplicableRulesAction/query',
        delete: '/api_busi/bizNodeApplicableRulesAction/delete',
        update: '/api_busi/bizNodeApplicableRulesAction/update',
        edit: '/api_busi/bizNodeApplicableRulesAction/edit',// 根据id获取单条数据的接口
        all: "/api_busi/bizNodeApplicableRulesAction/getAll", //所有适配规则列表
    },
    vBizNodeFormAction: {
        query: '/api_busi/vBizNodeFormAction/query',
        getVBizNodeFormById: '/api_busi/vBizNodeFormAction/getVBizNodeFormById',
        getVBizNodeMultiFormPage: '/api_busi/vBizNodeFormAction/getVBizNodeMultiFormPage',
    },
    bizHistoryData: {
        annualComparison: '/api_busi/bizHistoryData/annualComparison',// 年度资源同期比
        annualComparisonForTotal: '/api_busi/bizHistoryData/annualComparisonForTotal',// 年度资源同期比合计
        queryTotalChart: '/api_busi/bizHistoryData/queryTotalChart',// 资源对比柱状图接口
        monthlyContrast: '/api_busi/bizHistoryData/monthlyContrast',// 月度资源同期比
        annualExport: '/api_busi/bizHistoryData/annualComparisonExport',// 年度导出
        monthlyExport: '/api_busi/bizHistoryData/monthlyContrastExport',// 月度导出
        backUpsHistoryData: '/api_busi/bizHistoryData/backUpsHistoryData',// 备份历史数据
    },
    bizForeseeProfitAction: {
        query: '/api_busi/bizForeseeProfitAction/query',
        export: '/api_busi/bizForeseeProfitAction/export'
    },
    bizSupplyChainReachAnalysis: {
        list: '/api_busi/bizSupplyChainReachAnalysis/list',
    },
    bizBaseWholeCase: {
        list: '/api_busi/bizBaseWholeCaseAction/list',
        detailList: '/api_busi/bizBaseWholeCaseAction/detailList',
    },
    bizMaterialOperation: {
        list: '/api_busi/bizMaterialOperationAction/list',
        detailList: '/api_busi/bizMaterialOperationAction/detailList',
    },
    bizMaterialSettleAnalysis: {
        list: '/api_busi/bizMaterialSettleAnalysisAction/list',
    },
    bizMaterialSettleCollection: {
        list: '/api_busi/bizMaterialSettleCollectionAction/list',
    },
    bizNecessaryWorks: {
        list: '/api_busi/bizNecessaryWorksAction/list',
        detailList: '/api_busi/bizNecessaryWorksAction/detailList',
    },
    bizBusinessConversionRate: {
        conversionRate: '/api_busi/bizBusinessConversionRate/conversionRate'
    },
    productDynamicAchieve: {
        getHeader: '/api_busi/bizBoardAction/treeList',
        getData: '/api_busi/bizBoardAction/allList',
        getDetailHeader: '/api_busi/bizBoardAction/treeDetailList',
        getDtailData:'/api_busi/bizBoardAction/detailList'
    },
    busiAccountsTime: {
        get: '/api_busi/bizAccountTime/getByApply',//通过客户材料结算获取设置时间列表
        editAll: '/api_busi/bizAccountTime/editAll',//通过客户材料结算获取设置时间列表
        add: '/api_busi/bizAccountTime/add',//发起结算
        launch: '/api_busi/bizAccountTime/launch',//发起结算
    },
    bizOrderGraphicDesign: {
        query: '/api_busi/bizOrderGraphicDesignAction/query',//平面设计分页查询
        get: '/api_busi/bizOrderGraphicDesignAction/get',//获取单个平面规划
        edit: '/api_busi/bizOrderGraphicDesignAction/edit',//修改平面规划
        importGraphic: '/api_busi/bizOrderGraphicDesignAction/import',//修改平面规划
    },
    bizOrderServiceBase: {
        query: '/api_busi/bizOrderServiceBaseAction/query',//基装服务订单分页查询
        get: '/api_busi/bizOrderServiceBaseAction/get',//基装服务订单根据id查询
        getForContractNew: '/api_busi/bizOrderServiceBaseAction/getForContractNew',//(新的)
    },
    bizOrderServiceDesign: {
        query: '/api_busi/bizOrderServiceDesignAction/query',//设计服务订单分页查询
        get: '/api_busi/bizOrderServiceDesignAction/get',//设计服务订单根据id查询
        getForContract: '/api_busi/bizOrderServiceDesignAction/getForContract',//通过设计服务单id查询，返回设计合同编码
        getForContractNew: '/api_busi/bizOrderServiceDesignAction/getForContractNew',//(新的)通过设计服务单id查询，返回设计合同编码
    },
    bizOrderServiceProduct: {
        query: '/api_busi/bizOrderServiceProductAction/query',//产品服务订单分页查询
        queryOne: '/api_busi/bizOrderServiceProductAction/queryOne',//产品服务订单根据ID查询
    },
    bizOrderRemind: {
        query: '/api_busi/bizOrderRemindAction/query',//查询全部
        add: '/api_busi/bizOrderRemindAction/add',//新增一条
        deleteById: '/api_busi/bizOrderRemindAction/delete',//通过id删除
        changeStatus: '/api_busi/bizOrderRemindAction/changeStatus',//改变状态
        getOrgName: '/api_busi/bizOrderRemindAction/getOrgName',//改变状态
    },
    bizOrderRemindDetail: {
        query: '/api_busi/bizOrderRemindDetailAction/query',//查询全部
        add: '/api_busi/bizOrderRemindDetailAction/add',//新增
        queryByRemindId: '/api_busi/bizOrderRemindDetailAction/queryByRemindId',//通过reminId查询
        deleteById: '/api_busi/bizOrderRemindDetailAction/delete',//删除
        update: '/api_busi/bizOrderRemindDetailAction/update',//更新

    },
    bizOrderDesignHouse: {
        query: '/api_busi/bizOrderDesignHouseRegionAction/query',//查询全部
        add: '/api_busi/bizOrderDesignHouseRegionAction/add',//新增
        queryById: '/api_busi/bizOrderDesignHouseRegionAction/queryById',//通过remainId查询
        deleteById: '/api_busi/bizOrderDesignHouseRegionAction/delete',//删除
        update: '/api_busi/bizOrderDesignHouseRegionAction/update',//更新

    },
    bizOrderDesignHouseDetail: {
        query: '/api_busi/bizOrderDesignHouseRegionDetailAction/query',//查询全部
        add: '/api_busi/bizOrderDesignHouseRegionDetailAction/add',//新增
        queryByPid: '/api_busi/bizOrderDesignHouseRegionDetailAction/getByParentId',//通过reminId查询
        queryBySid: '/api_busi/bizOrderDesignHouseRegionDetailAction/getByServiceId',//通过ServiceId查询
        deleteById: '/api_busi/bizOrderDesignHouseRegionDetailAction/delete',//删除
        update: '/api_busi/bizOrderDesignHouseRegionDetailAction/update',//更新

    },
    bizOrderDepthDesign: {
        query: '/api_busi/bizOrderDepthDesignAction/query',//深化效果分页展示
        importDesign: '/api_busi/bizOrderDepthDesignAction/import',//录入深化设计效果图
        edit: '/api_busi/bizOrderDepthDesignAction/edit',//修改深化设计效果图
        get: '/api_busi/bizOrderDepthDesignAction/get',//获取单个深化设计效果图
        reset: '/api_busi/bizOrderDepthDesignAction/reset',//重置深化设计效果图
        commit: '/api_busi/bizOrderDepthDesignAction/commit',//提交深化设计效果图
    },
    bizOrderReform: {
        queryInfo: '/api_busi/BizOrderReformServiceIdAction/query',//选择客户信息
        getForContractNew: '/api_busi/BizOrderReformServiceIdAction/getForContractNew',//(新的)通过设计服务单id查询，返回设计合同编码
        query: '/api_busi/bizContractReformAction/query',//分页展示
        add: '/api_busi/bizContractReformAction/add',//新增拆改建合同
        export: '/api_busi/bizContractReformAction/exportExcel',//导出表格
        stop: '/api_busi/bizContractReformAction/stop',//停止
        checkPrintCode: '/api_busi/bizContractReformAction/checkPrintCode',//合同印刷码是否重复
        delete: '/api_busi/bizContractReformAction/delete',//删除
        getById: '/api_busi/bizContractReformAction/get',//详情
        edit: '/api_busi/bizContractReformAction/edit',//编辑
        selectSupplier: '/api_busi/bizCollectionAccountAction/getAccountDtoByOrgId',//供应商信息
        editStopTime: '/api_busi/bizContractReformAction/editStopTime',//停止时间
        reset: '/api_busi/bizContractReformAction/reset',//重置
        updateContractPeople: '/api_busi/bizContractReformAction/updatePeople',//修改合作人员
        complete: '/api_busi/bizContractReformAction/complete',//基装合同节点完成
        audit: '/api_busi/bizContractReformAction/audit',//提交
        addAudit: '/api_busi/bizContractReformAction/addAudit',//新增审核
        updateAudit: '/api_busi/bizContractReformAction/updateAudit',//修改审核
        resignContract: '/api_busi/bizContractReformAction/resignContract',//拆改建合同重签
        resignComplete: '/api_busi/bizContractReformAction/resignComplete',//拆改建合同重签
    },
    bizCollectionAccount: {
        selectSupplier: '/api_busi/bizCollectionAccountAction/getAccountDtoByOrgId',
        query: '/api_busi/bizCollectionAccountAction/query',
        delete: '/api_busi/bizCollectionAccountAction/delete',
        getById: '/api_busi/bizCollectionAccountAction/get',
        add: '/api_busi/bizCollectionAccountAction/saveOrUpdate',
        setStatus: '/api_busi/bizCollectionAccountAction/setStatus',
    },

    bizOrderDepthDesignHistory: {
        getByDepthId: '/api_busi/bizOrderDepthDesignHistoryAction/getByDepthId',//获取单个深化设计效果图
    },
    bizOrderConstructionDesign: {
        query: '/api_busi/bizOrderConstructionDesignAction/query',//工程图分页查询
        get: '/api_busi/bizOrderConstructionDesignAction/queryOne',//获取单个工程图
        edit: '/api_busi/bizOrderConstructionDesignAction/edit',//修改工程图
        uploadConstruction: '/api_busi/bizOrderConstructionDesignAction/upload',//上传工程图
        submit: '/api_busi/bizOrderConstructionDesignAction/submit',//提交
        editCanSee:'/api_busi/bizOrderConstructionDesignAction/editCanSee',//编辑客户是否可见
        export: '/api_busi/bizOrderConstructionDesignAction/export',//导出
        getResouce: '/api_busi/bizCadAttachAction/query',//获取深化施工源文件
        getHistory: '/api_busi/bizCadAttachAction/queryHistory',//通过版本号查询历史修改记录
        addCAD: '/api_busi/bizCadAttachAction/add',//新增施工图源文件
        updateCAD: '/api_busi/bizCadAttachAction/update',//更新施工图源文件
        delCAD: '/api_busi/bizCadAttachAction/delete',//删除施工图源文件
        getGradeNew: '/api_busi/bizRatingScoreAction/query',//查询评分标准的所有问题以及订单基础信息（判断是否有历史保存数据或是否提交过）orderServiceId：服务订单id（修改）
        getGrade: '/api_busi/bizRatingScoreAction/queryHistory',//查询评分标准的所有问题以及订单基础信息（判断是否有历史保存数据）orderServiceId：服务订单id
        saveGrade: '/api_busi/bizRatingScoreAction/add',//保存(新增或修改)
        submitGrade: '/api_busi/bizRatingScoreAction/submit',//提交
    },
    drawingsManagement: {
        //图纸评分标准
        questionBank: '/api_busi/BizScaleMarks/query',//分页查询评分标准题库
        questionBankAdd: '/api_busi/BizScaleMarks/add',//新增评分标准题库
        questionBankCopy: '/api_busi/BizScaleMarks/copy',//复制评分标准题库  id：复制模板的id，还需一个body体的 {name：""}
        questionBankStatus: '/api_busi/BizScaleMarks/switch',	//启用/停用 评分标准题库
        question: '/api_busi/BizScaleMarksDetail/query',//查询模板的所有问题 marksId：模板id
        questionAdd: '/api_busi/BizScaleMarksDetail/add',//问题新增
        questionUpdate: '/api_busi/BizScaleMarksDetail/update',//问题修改
        questionDel: '/api_busi/BizScaleMarksDetail/delete',//问题删除 marksId：模板id  ， id：模板详情id

        //图纸规范知识库
        knowledgeBase: '/api_busi/bizDrawingStandard/query',//分页查询图纸规范知识库（一组内展示 is_show为1（表示展示状态）的 一个）
        knowledgeBaseAdd: '/api_busi/bizDrawingStandard/add',//新增图纸规范知识库
        knowledge: '/api_busi/bizDrawingStandard/queryHistory',//查询单组内的历史数据(包括自己)
        knowledgeBaseEdit: '/api_busi/bizDrawingStandard/update',//修改该知识库(保留原有数据 新增一个数据)
        knowledgeDetail: '/api_busi/bizDrawingStandard/queryOne',//查询单条数据(从中取下载，预览地址)
        knowledgeStatus: '/api_busi/bizDrawingStandard/updateOne',//数据的启用和禁用 id：数据的id；status：状态；groupCode分组编号
        knowledgeInfo: '/api_busi/bizDrawingStandard/updateInfo',//修改一组的描述信息 groupCode；分组编号
    },
    bizOrderBudget: {
        query: '/api_busi/bizOrderBudgetAction/query',//获取全部预核算
        export: '/api_busi/bizOrderBudgetAction/export',//导出预核算
        findById: '/api_busi/bizOrderBudgetAction/edit',//
        importBudget: '/api_busi/bizOrderBudgetDetailAction/add',//录入费率表
        queryOne: '/api_busi/bizOrderBudgetDetailFieldAction/queryAll',//
        getDetailSelection: '/api_busi/bizOrderBudgetDetailAction/getAll',//将费率表作为修改选项
        getUpdateSelection: '/api_busi/bizOrderBudgetDetailAction/getAllForUpdate',//将费率表作为option选项
        getDetailSelectionWithoutEnable: '/api_busi/bizOrderBudgetDetailAction/getAllWithoutEnable',//将费率表作为option选项
        findByBaseId: '/api_busi/bizOrderBudgetAction/findByBaseId',//通过基装合同id查找费率表
        findByCode: '/api_busi/bizOrderBudgetDetailAction/getBudgetCode',//通过费率表编码查找
        code: '/api_busi/bizOrderBudgetDetailAction/code',//生成费率表编码
        codeInfo: '/api_busi/bizOrderBudgetDetailAction/codeInfo',
        findByBudgetId: '/api_busi/bizOrderBudgetDetailAction/getByBudgetId',
        getListByServiceId: '/api_busi/bizOrderBudgetDetailAction/getByServiceId',//服务订单详情页获取预算
        assignBudgeter: '/api_busi/bizOrderBudgetAction/assignBudgeter',//指派预算员
        commitBudgete: '/api_busi/bizOrderBudgetAction/commit',//提交费率表
        updateBudget: '/api_busi/bizOrderBudgetDetailAction/edit',//修改费率表
        update: '/api_busi/bizOrderBudgetAction/edit',//修改费率表
        getOutsourceAmount: '/api_busi/bizOrderBudgetDetailFieldAction/getOutsourceAmount',//获取外包总额
        getLaborAndAuxiliary: '/api_busi/bizOrderBudgetDetailFieldAction/getLaborAndAuxiliary',//获取
        controlAdd: '/api_busi/BizOrderBudgetDetailControl/add',//内控
        report: '/api_busi/bizOrderBudgetDetailAction/report',//上报
        saveField: '/api_busi/bizOrderBudgetDetailAction/saveField',//内控Field保存
        controlReport: '/api_busi/BizOrderBudgetDetailControl/report',//内控上报
        controlSaveField: '/api_busi/BizOrderBudgetDetailControl/saveField',//内控Field保存
        fieldListMap: '/api_busi/BizOrderBudgetDetailControl/fieldListMap',//内控Field保存
        controlFindById: '/api_busi/BizOrderBudgetDetailControl/findById',//
        detailFindById: '/api_busi/bizOrderBudgetDetailAction/findById',//
        assignCommissioner: '/api_busi/bizOrderBudgetAction/assignCommissioner',//转预核算专员
    },

    budgetSoftware: {
        loginZm: '/api_busi/budgetSoftware/loginZm'
    },
    // 材料下单担保相关
    bizOrderMaterialGuarantee: {
        query: '/api_busi/bizOrderMaterialGuarantee/query',
        purchaseGuarantee: '/api_busi/bizOrderMaterialGuarantee/purchaseGuarantee', // 创建采购担保
        sendGuarantee: '/api_busi/bizOrderMaterialGuarantee/sendGuarantee', // 创建送货担保
        deleteById: '/api_busi/bizOrderMaterialGuarantee/deleteById', // 删除
        commit: '/api_busi/bizOrderMaterialGuarantee/commit', // 开启审批流
        queryOne: '/api_busi/bizOrderMaterialGuarantee/queryOne', // 根据id查找数据
    },
    // 拆改建供应商返利订单
    bizOrderReformSupplyAction: {
        queryPage: '/api_busi/bizOrderReformSupplyAction/query',
        export: '/api_busi/bizOrderReformSupplyAction/export',
        queryOne: '/api_busi/bizOrderReformSupplyAction/queryOne',
        add: '/api_busi/bizOrderReformSupplyAction/add',
        update: '/api_busi/bizOrderReformSupplyAction/update',
        delete: '/api_busi/bizOrderReformSupplyAction/delete',
        updateCalculate: '/api_busi/bizOrderReformSupplyAction/updateCalculate',
        audit: '/api_busi/bizOrderReformSupplyAction/audit',
    },
    // 拆改建供应商收退款
    bizReformSupplyReceivablesAction: {
        queryPage: '/api_busi/bizReformSupplyReceivablesAction/query',
        export: '/api_busi/bizReformSupplyReceivablesAction/export',
        queryOne: '/api_busi/bizReformSupplyReceivablesAction/queryOne',
        add: '/api_busi/bizReformSupplyReceivablesAction/add',
        update: '/api_busi/bizReformSupplyReceivablesAction/update',
        delete: '/api_busi/bizReformSupplyReceivablesAction/delete',
        updateCalculateAndCoefficient: '/api_busi/bizReformSupplyReceivablesAction/updateCalculateAndCoefficient',
        audit: '/api_busi/bizReformSupplyReceivablesAction/audit',
        findByOrderSupplyId: '/api_busi/bizReformSupplyReceivablesAction/findByOrderSupplyId', //
    },
    BizOrderMaterial: {
        saleFlow: '/api_busi/bizOrderMaterial/saleFlow',// 撤回销售订单审批流 delete接口
        returnFlow: '/api_busi/bizOrderMaterial/returnFlow',// 撤回返利订单审批流 delete接口
        customerMoney: '/api_busi/bizOrderMaterial/customerMoney',// 撤回返利订单审批流 delete接口
        query: '/api_busi/bizOrderMaterial/query',
        getById: '/api_busi/bizOrderMaterial/getById',
        getPurchaseOrderInfoById: '/api_busi/bizOrderMaterial/getPurchaseOrderInfoById',
        add: '/api_busi/bizOrderMaterial/add',
        delete: '/api_busi/bizOrderMaterial/delete',
        deleteSale: '/api_busi/bizOrderMaterial/deleteSale',
        deleteDiscount: '/api_busi/bizOrderMaterial/deleteDiscount',//优惠单删除
        saleSubmit: '/api_busi/bizOrderMaterial/saleSubmit',//销售订单提交审核
        edit: '/api_busi/bizOrderMaterial/edit',
        update: '/api_busi/bizOrderMaterial/update',
        getByCode: '/api_busi/bizOrderMaterial/getByCode',
        VsaleOrderQuery: '/api_busi/VSaleOrderQueryPageAction/query',
        queryPassed: '/api_busi/VSaleOrderQueryPageAction/queryPassed',
        export: '/api_busi/VSaleOrderQueryPageAction/export',//导出
        submitAudit: '/api_busi/bizOrderMaterial/submitAudit',
        getCustomerByServiceCode: '/api_busi/bizOrderMaterial/getCustomerByServiceCode',
        addSale: '/api_busi/bizOrderMaterial/addSale',//新增销售单
        updateSale: '/api_busi/bizOrderMaterial/updateSale',//更新销售单
        updateSubmitSale: '/api_busi/bizOrderMaterial/updateSubmitSale',//更新并提交销售单
        addAndSubmitSale: '/api_busi/bizOrderMaterial/addAndSubmitSale',//新增并提交销售单
        addDiscount: '/api_busi/bizOrderMaterial/addDiscount',//新增优惠单
        addAndSubmitDiscount: '/api_busi/bizOrderMaterial/addAndSubmitDiscount',//新增并提交优惠单
        submitDiscountCheck: '/api_busi/bizOrderMaterial/submitDiscountCheck',//优惠单提交校验
        submitDiscountEntityCheck: '/api_busi/bizOrderMaterial/submitDiscountEntityCheck',//优惠单实体校验提交校验
        submitDiscount: '/api_busi/bizOrderMaterial/discountSubmit',//优惠单提交
        toVoid: '/api_busi/bizOrderMaterial/toVoid',//完工优惠单作废
        updateDiscount: '/api_busi/bizOrderMaterial/updateDiscount',//修改优惠单
        completeAudit: '/api_busi/bizOrderMaterial/completeAudit',//材料订单节点完成
        editCalculate: '/api_busi/bizOrderMaterial/editCalculate',//材料订单节点完成
        editCoefficient: '/api_busi/bizOrderMaterial/editCoefficient',//修改返利系数
        setRebateData: '/api_busi/bizOrderMaterial/setRebateData',//设置返利系数
        updatePurchaseMoney: '/api_busi/bizOrderMaterial/updatePurchaseMoney',//修改采购金额
        updateBranchPriceCoefficient: '/api_busi/bizOrderMaterial/editBranchPriceCoefficient',//修改分公司采购价系数
        getUnPurchaseSaleByServiceId: '/api_busi/bizOrderMaterial/getUnPurchaseSaleByServiceId',//获取没有下采购的销售订单
        getReturnByServiceId: '/api_busi/bizOrderMaterial/getReturnByServiceId',//获取没有下采购的销售订单
        getDiscountBySaleId: '/api_busi/bizOrderMaterial/getDiscountBySaleId',//获取没有下采购的销售订单
        batchUpdateFile: '/api_busi/bizOrderMaterial/batchUpdateFile',//获取没有下采购的销售订单
        commonApproveFirst: '/api_busi/bizOrderMaterial/commonApproveFirst',//销售订单第一个审批节点
        commonApproveSecond: '/api_busi/bizOrderMaterial/commonApproveSecond',//销售订单第二个审批节点
        updatePeopleForOrder:'/api_busi/bizOrderMaterial/updatePeopleForOrder',

    },
    VFwAccount: {
        findVAccountInfo: '/api_busi/VFwAccountAction/findVAccountInfo'
    },
    bizSettingValueChannel: {
        submit: '/api_busi/bizSettingValueChannel/submit',
        reset: '/api_busi/bizSettingValueChannel/reset',
        queryColor: '/api_busi/bizSettingValueChannel/queryColor',
        getVersion: '/api_busi/bizSettingValueChannel/getVersion',
        checkIsExist: '/api_busi/bizSettingValueChannel/checkIsExist',
        getDetail: '/api_busi/bizSettingValueChannel/getAllData',//根据年份 渠道 和 季度 获取计划详情
        saveQuarterData: '/api_busi/bizSettingValueChannel/saveData',//保存当前季度数据
        getVersions: '/api_busi/bizSettingValueChannel/getVersion',//获得历史版本列表
        getHistoryData: '/api_busi/bizSettingValueChannel/getAllVersionData',//获取历史版本的详情数据
        submitData: '/api_busi/bizSettingValueChannel/submit',//提交数据
    },
    BizOrderMaterialDetail: {
        getById: '/api_busi/bizOrderMaterialDetail/getById',
        query: '/api_busi/bizOrderMaterialDetail/query',
        delete: '/api_busi/bizOrderMaterialDetail/delete',
        getBizOrderMaterialDetailByMaterialId: '/api_busi/bizOrderMaterialDetail/getBizOrderMaterialDetailByMaterialId',
        getBizOrderMaterialDetailsByMaterialId: '/api_busi/bizOrderMaterialDetail/getBizOrderMaterialDetailsByMaterialId',
        getBizOrderMaterialDetailListByMaterialId: '/api_busi/bizOrderMaterialDetail/getBizOrderMaterialDetailListByMaterialId',
        getPurchaseSummarys: '/api_busi/bizOrderMaterialDetail/getPurchaseSummary',
        batchEdit: '/api_busi/bizOrderMaterialDetail/batchEdit',
        batchUpdate: '/api_busi/bizOrderMaterialDetail/batchUpdate',
        summaryByMaterialId: '/api_busi/bizOrderMaterialDetail/summaryByMaterialId'
    },
    BizOrderPurchase: {
        purchaseFlow: '/api_busi/BizOrderPurchase/purchaseFlow',// 审批流的撤回
        query: '/api_busi/BizOrderPurchase/query',
        add: '/api_busi/BizOrderPurchase/add',
        edit: '/api_busi/BizOrderPurchase/edit',
        getPurchaseOrderBySaleId: '/api_busi/BizOrderPurchase/getPurchaseOrderBySaleId',
        getByPurchaseOrderCode: '/api_busi/BizOrderPurchase/getByPurchaseOrderCode',
        getById: '/api_busi/BizOrderPurchase/getById',
        getNewUUIDById: '/api_busi/BizOrderPurchase/getNewUUIDById',
        getPurchaseOrderById: '/api_busi/BizOrderPurchase/getPurchaseOrderById',
        submit: '/api_busi/BizOrderPurchase/submit',
        VPurchaseOrderQuery: '/api_busi/VPurchaseOrderQueryPageAction/query',
        export: '/api_busi/VPurchaseOrderQueryPageAction/export',//导出
        getPurchaseOrderByCode: '/api_busi/BizOrderPurchase/getPurchaseOrderByCode',
        applySettlement: '/api_busi/BizOrderPurchase/applySettlement',
        unbindPayMent: '/api_busi/BizOrderPurchase/unbindPayMent',
        endorse: '/api_busi/BizOrderPurchase/endorse',
        getByCode: '/api_busi/BizOrderPurchase/getByCode',
        completeWithJudge: '/api_busi/BizOrderPurchase/completeWithJudge',
        saveAndSubmit: '/api_busi/BizOrderPurchase/saveAndSubmit',
        editAndSubmit: '/api_busi/BizOrderPurchase/editAndSubmit',
        delete: '/api_busi/BizOrderPurchase/delete',
        getSendFile: '/api_busi/BizOrderPurchase/getSendFile',//getSendFile
        editFlowTime: '/api_busi/BizOrderPurchase/editFlowTime',
        editCalculate: '/api_busi/BizOrderPurchase/editCalculate',
        updateShop: '/api_busi/BizOrderPurchase/updateShop',
        updateArrivialDate: '/api_busi/BizOrderPurchase/updateArrivialDate',
        checkHasSend: '/api_busi/BizOrderPurchase/checkHasSend',
        supplyOrderDetail: '/api_busi/BizOrderPurchase/supplyOrderDetail',
        updateById: '/api_busi/BizOrderPurchase/updateById',
        copyFileIds: '/api_file/cmdFileManager/copyToNewBusinessId',//复制附件到新的businessId
        getDiscounts: '/api_busi/bizOrderMaterial/getDiscountBySaleId',//获得优惠单列表
        pointDesigner: '/api_busi/BizOrderPurchase/purchase',//指定定制品设计师
        specialComplete: '/api_busi/BizOrderPurchase/specialComplete',//特殊审批人审批
        updatePeopleForOrder:'/api_busi/BizOrderPurchase/updatePeopleForOrder',
    },
    bizProjectPaymentConfigAction: {
        getProjectPaymentAutoFlowMsg: '/api_busi/bizProjectPaymentConfigAction/getProjectPaymentAutoFlowMsg',
        getAreaForClean: '/api_busi/bizProjectPaymentConfigAction/getAreaForClean',
    },
    BizOrderPurchaseSummary: {
        query: '/api_busi/BizOrderPurchaseSummary/query',
        add: '/api_busi/BizOrderPurchaseSummary/add',
        edit: '/api_busi/BizOrderPurchaseSummary/edit'
    },
    BizOrderPurchaseDetail: {
        queryPurchaseDetailBackOrder: '/api_busi/BizOrderPurchaseDetail/queryPurchaseDetailBackOrder',
        query: '/api_busi/BizOrderPurchaseDetail/query',
        getById: '/api_busi/BizOrderPurchaseDetail/getById',
        update: '/api_busi/BizOrderPurchaseDetail/edit',
        batchUpdate: '/api_busi/BizOrderPurchaseDetail/batchUpdate',//批量修改
        spAudit: '/api_busi/BizOrderPurchaseDetail/spAudit',//二级供应商提交审核
        batchEdit: '/api_busi/BizOrderPurchaseDetail/batchEdit',
        batchSelectEdit: '/api_busi/BizOrderPurchaseDetail/batchSelectEdit',
        add: '/api_busi/BizOrderPurchaseDetail/add',
        updateStatusByWaitSendAmount: '/api_busi/BizOrderPurchaseDetail/updateStatusByWaitSendAmount',
        updateAlreadyBackCount: '/api_busi/BizOrderPurchaseDetail/updateAlreadyBackCount',
        backQueryPage: '/api_busi/BizOrderPurchaseDetail/backQueryPage',
        checkShopUpdate: '/api_busi/BizOrderPurchaseDetail/checkShopUpdate', // 采购单修改店铺及利润前校验
        preconditionBack: '/api_busi/BizOrderPurchaseDetail/preconditionBack', // 退货单退货前校验
        getPurchaseDetailByPurchaseId: '/api_busi/BizOrderPurchaseDetail/getPurchaseDetailByPurchaseId',
        getPurchaseDetailListByPurchaseId: '/api_busi/BizOrderPurchaseDetail/getPurchaseDetailListByPurchaseId',
        getPurchaseDetailListByPurchaseIdNew: '/api_busi/BizOrderPurchaseDetail/getPurchaseDetailListByPurchaseIdNew',
        getEditPurchasePriceByShop: '/api_busi/BizOrderPurchaseDetail/getEditPurchasePriceByShop', // 根据采购单id找到对应的明细，并且更新对应的店铺取ec找到结算价，然后修改返回值的采购价，不保存数据库
        findCanSendGoods:'/api_busi/BizOrderPurchaseDetail/findCanSendGoods?purchaseCode=',//根据采购单code获取待发货列表   
    },
    BizOrderSendLogAction: {
        query: '/api_busi/BizOrderSendLogAction/query',
    },
    BizOrderSendAction: {
        sendFlow: '/api_busi/BizOrderSendAction/sendFlow', // 审批流撤回
        query: '/api_busi/BizOrderSendAction/query',
        export: '/api_busi/BizOrderSendAction/export',
        getById: '/api_busi/BizOrderSendAction/getById',
        delete: '/api_busi/BizOrderSendAction/delete',//送货单删除
        update: '/api_busi/BizOrderSendAction/edit',
        add: '/api_busi/BizOrderSendAction/add',
        getBizOrderSendById: '/api_busi/BizOrderSendAction/getBizOrderSendById',
        vsendOrderQueryPage: '/api_busi/VSendOrderQueryPageAction/query',
        vsendOrderExport: '/api_busi/VSendOrderQueryPageAction/export',
        getBizOrderSendByCode: '/api_busi/BizOrderSendAction/getBizOrderSendByCode',
        executeDelivery: '/api_busi/BizOrderSendAction/executeDelivery',
        checkSendOrder: '/api_busi/BizOrderSendAction/checkSendOrder',
        extendAutoCheckDate: '/api_busi/BizOrderSendAction/extendAutoCheckDate',//延长自动验收日期
        submit: '/api_busi/BizOrderSendAction/submit',
        saveAndSubmit: '/api_busi/BizOrderSendAction/saveAndSubmit',
        updateAndSubmit: '/api_busi/BizOrderSendAction/updateAndSubmit',
        editFlowTime: '/api_busi/BizOrderSendAction/editFlowTime',
        updatePeopleForOrder:'/api_busi/BizOrderSendAction/updatePeopleForOrder',
    },
    BizOrderSendTempAction: {
        batchWorkFlow: '/api_busi/BizOrderSendTempAction/batchWorkFlow'
    },
    BizOrderSendDetailAction: {
        backQueryPage: '/api_busi/BizOrderSendDetailAction/backQueryPage',
        query: '/api_busi/BizOrderSendDetailAction/query'
    },
    BizOrderBackAction: {
        query: '/api_busi/BizOrderBackAction/query',
        getById: '/api_busi/BizOrderBackAction/getById',
        update: '/api_busi/BizOrderBackAction/edit',
        add: '/api_busi/BizOrderBackAction/add',
        getBizOrderBackById: '/api_busi/BizOrderBackAction/getBizOrderBackById',
        vBackOrderQueryPage: '/api_busi/VBackOrderQueryPageAction/query',
        export: '/api_busi/VBackOrderQueryPageAction/export',
        getByCode: '/api_busi/BizOrderBackAction/getByCode',
        submit: '/api_busi/BizOrderBackAction/submit',
        applySettlement: '/api_busi/BizOrderBackAction/applySettlement',
        saveAndSubmit: '/api_busi/BizOrderBackAction/saveAndSubmit',
        updateAndSubmit: '/api_busi/BizOrderBackAction/updateAndSubmit',
        getBackBySale: '/api_busi/BizOrderBackAction/getBackBySale',//根据销售单生成退货单
        getBackByPurchase: '/api_busi/BizOrderBackAction/getBackByPurchase',//根据采购单生成退货单
        getBackBySend: '/api_busi/BizOrderBackAction/getBackBySend',//根据送货单生成退货单
        delete: '/api_busi/BizOrderBackAction/delete',//删除退货单
        editFlowTime: '/api_busi/BizOrderBackAction/editFlowTime',
        supplyOrderDetail: '/api_busi/BizOrderBackAction/supplyOrderDetail',
        backFlow: '/api_busi/BizOrderBackAction/backFlow',
        updatePeopleForOrder:'/api_busi/BizOrderBackAction/updatePeopleForOrder'
    },
    productSalesAchievedDesigner: {
        categoryList: '/api_busi/productSalesAchieved/categoryOrCompany',//产品销售达成-品类
        companyList: '/api_busi/productSalesAchieved/company',//产品销售达成-分公司
        designerList: '/api_busi/productSalesAchievedDesigner/designer',//产品销售达成-设计师
        totalDesignerList: '/api_busi/productSalesAchieved/totalReachDesigner',//产品销售总达成-设计师
    },
    productPurchasing: {
        categoryList: '/api_busi/productSalesAchieved/purchase/categoryOrCompany',//产品采购达成-品类
        companyList: '/api_busi/productSalesAchieved/purchase/company',//产品采购达成-分公司
        designerList: '/api_busi/productSalesAchieved/purchase/designer',//产品采购达成-设计师
    },
    BizOrderBackDetailAction: {
        batchUpdate: '/api_busi/BizOrderBackDetailAction/batchUpdate',//批量更新

    },
    BizOrderBackTempAction: {
        batchWorkFlow: '/api_busi/BizOrderBackTempAction/batchWorkFlow'
    },
    VBusiCustomerAction: {
        getCustomerByCode: '/api_busi/vBusiCustomerAction/getCustomerByCode'
    },
    bizOrderMeasure: {
        query: '/api_busi/bizOrderMeasureAction/query',//量房记录分页展示
        isMeasureRoom: '/api_busi/bizOrderMeasureAction/isMeasureRoom',//查询该服务订单地址是否可以量房
        importDesign: '/api_busi/bizOrderMeasureAction/import',//录入量房记录
        edit: '/api_busi/bizOrderMeasureAction/edit',//修改量房记录
        get: '/api_busi/bizOrderMeasureAction/get',//获取单个量房记录
    },
    royaltyPlan: { // 提成方案
        query: '/api_busi/royaltyPlan/query',
        update: '/api_busi/royaltyPlan/add',
        delete: '/api_busi/royaltyPlan/delete',
        queryById: '/api_busi/royaltyPlan/getById',
        copy: '/api_busi/royaltyPlan/copy',
        changeStatus: '/api_busi/royaltyPlan/changeStatus',
    },
    incidentHandlingConfig: {
        query: '/api_busi/incidentHandlingConfig/query',
        add: "/api_busi/incidentHandlingConfig/add", // 新增
        getById: '/api_busi/incidentHandlingConfig/getById',
        update: '/api_busi/incidentHandlingConfig/edit',
        changeStatus: '/api_busi/incidentHandlingConfig/changeStatus',
        delete: '/api_busi/incidentHandlingConfig/delete',
        addFormula: '/api_busi/incidentHandlingConfig/addFormula',
        delFormula: '/api_busi/incidentHandlingConfig/delFormula'
    },
    triggerIncidentAction: {
        calculateAllByDate: '/api_busi/triggerIncidentAction/calculateAllByDate',// 重新计算指定日期范围内的业绩触发事件
    },
    royaltyFormula: {//设置提成方案
        query: '/api_busi/royaltyFormula/query',
        getMenu: '/api_busi/royaltyFormula/getFormulaTree',
        edit: '/api_busi/royaltyFormula/edit',
        deleteMenu: '/api_busi/royaltyFormula/delete',
        getCode: '/api_busi/royaltyFormula/getCode',
        saveOrUpdate: '/api_busi/royaltyFormula/saveOrUpdate',
        allUnSelected: '/api_busi/royaltyFormula/allUnSelected', // 查找所有没有设定的
        allSelected: '/api_busi/royaltyFormula/allSelected', // 查找所有设定的
        queryForExport: "/api_busi/royaltyFormula/export", //查询列表（导出）
    },
    orderRoyaltyData: { //详情
        detail: '/api_busi/orderRoyaltyData/findByOrderId'
    },
    privateRoyaltyData: { // 个人提成
        query: '/api_busi/privateRoyaltyData/query',
        createPayData:'/api_busi/privateRoyaltyData/createPayData'
    },
    royaltyPayData: { // 个人发放
        query: '/api_busi/royaltyPayData/query',
        detail: '/api_busi/royaltyPayData/getDetail',
        settlementDetail: '/api_busi/royaltyPayData/findSettlementDetail',
        getChangeData: '/api_busi/royaltyPayData/getChangeData',
        add: '/api_busi/royaltyPayData/addChangeData',
        update: '/api_busi/royaltyPayData/updateChangeData',
        delete: '/api_busi/royaltyPayData/delete',
        queryCompany: "/api_busi/royaltyPayData/companyGroup",//分公司维度列表查询
        queryHuman: "/api_busi/royaltyPayData/personnelGroup",//人事维度列表查询
        queryService: "/api_busi/royaltyPayData/serviceGroup",//服务订单维度列表查询
        examineCompany: "/api_busi/royaltyPayData/companyFlow",//分公司审核
        examineHuman: "/api_busi/royaltyPayData/personnelFlow",//人事审核
        submitSubManager: "/api_busi/royaltyPayData/submitManagerFlow",//提交分总
        getDetailByFlowId: "/api_busi/royaltyPayData/managerFlowDetail",//审批流获取详情
        createSettleOrder: "/api_busi/royaltyPayData/createSettlementData",//生成提成结算单
        cancelSettle: "/api_busi/royaltySettlementData/cancel",//取消结算
        exportCompany: "/api_busi/royaltyExcelOutPut/export/company",//分公司维度导出
        exportHuman: "/api_busi/royaltyExcelOutPut/export/personnel",//人事维度导出
        exportService: "/api_busi/royaltyExcelOutPut/export/service",//服务订单维度导出
        getDetailsToExamine: "/api_busi/royaltyPayData/findAllSum",//查询勾选数据的汇总金额
        changePlanDate:"/api_busi/royaltyPayData/changePlanDate", // 调整计划发放日期
        submitPlanDate:"/api_busi/royaltyPayData/submitPlanDate", // 提交审核调整计划发放日期
        cancelCompanyAudit:'/api_busi/royaltyPayData/cancelCompanyAudit',// 撤销分公司审核
        addNewData:"/api_busi/royaltyPayData/addNewData",
        adjustDate:"/api_busi/royaltyPayData/adjustDate",
        getAdjustDateFlowInfo:"/api_busi/royaltyAdjustDateFlow/getFlowInfo"
    },
    royaltySettlementData: {
        query: '/api_busi/royaltySettlementData/query',
        companyAudit: '/api_busi/royaltySettlementData/companyAudit',
        personnelCheck: '/api_busi/royaltySettlementData/personnelCheck',
        queryDetail: '/api_busi/royaltySettlementData/queryDetail'
    },
    bizOrderMeasureDetail: {
        query: '/api_busi/bizOrderMeasureDetailAction/query',//修改量房的日志分页展示
    },
    bizContractSubject: {
        add: '/api_busi/bizContractSubjectAction/add',
        query: '/api_busi/bizContractSubjectAction/query',
        deleteById: '/api_busi/bizContractSubjectAction/delete',
        queryById: '/api_busi/bizContractSubjectAction/queryById',
        update: '/api_busi/bizContractSubjectAction/update',
        get: '/api_busi/bizContractSubjectAction/get',//通过组织Id以及合同类型获取签订主体模板
        getNew: '/api_busi/bizContractSubjectAction/getNew',//通过组织Id以及合同类型获取签订主体模板
        setStatus: '/api_busi/bizContractSubjectAction/setStatus',//启用/禁用组织
    },
    configItemVariable: {
        getAll:'/api_busi/configItemVariable/listAll',// 获取变量集合
    },

    bizContractTpl: {
        add: '/api_busi/bizContractTplAction/add',
        query: '/api_busi/bizContractTplAction/query',
        deleteById: '/api_busi/bizContractTplAction/delete',
        queryById: '/api_busi/bizContractTplAction/queryById',
        update: '/api_busi/bizContractTplAction/update',
        queryByOrgIdAndType: '/api_busi/bizContractTplAction/queryByOrgIdAndType',//根据机构id和合同类型获取扩展信息
    },
    bizContractTplDetail: {
        add: '/api_busi/bizContractTplDetailAction/add',
        query: '/api_busi/bizContractTplDetailAction/query',
        deleteById: '/api_busi/bizContractTplDetailAction/delete',
        queryById: '/api_busi/bizContractTplDetailAction/queryById',
        queryByTplId: '/api_busi/bizContractTplDetailAction/queryByTplId',
        update: '/api_busi/bizContractTplDetailAction/update',
    },
    bizContractLog: {
        query: '/api_busi/bizContractLogAction/query',

    },
    taskHistory: {
        queryByTaskId: '/api_task/taskHistory/query',//通过任务id获取任务运行记录
    },
    //友链
    busiContentFriendLink: {
        query: '/api_cms/busiContentFriendLink/query',//列表分页
        add: '/api_cms/busiContentFriendLink/add',//新增
        get: '/api_cms/busiContentFriendLink/get',//按id查询
        update: '/api_cms/busiContentFriendLink/edit',//按id更新
        delete: '/api_cms/busiContentFriendLink/delete',//删除
        deleteBatch: '/api_cms/busiContentFriendLink/deleteBatch'//批量删除
    },
    //渠道费用
    busiChannelFee: {
        query: '/api_cms/busiChannelFee/query',//列表分页
        add: '/api_cms/busiChannelFee/add',//新增
        get: '/api_cms/busiChannelFee/queryChannelFee',//按id查询
        update: '/api_cms/busiChannelFee/update',//按id更新
        delete: '/api_cms/busiChannelFee/delete',//删除
        getConfigList: '/api_cms/busiChannelFee/getConfigList'//获取改人员绑定的渠道
    },
    //材料付款表
    vMateriaPaymentAction: {
        query: '/api_busi/vMateriaPaymentAction/query',
    },
    //产值中间表
    vMidBizOrderService: {
        query: '/api_busi/vMidBizOrderServiceAction/query',
        queryWithoutControl: '/api_busi/vMidBizOrderServiceAction/queryWithoutControl',
    },
    vMidBizOrderServiceScrap: {
        query: '/api_busi/vMidBizOrderServiceScrapAction/query',
        queryWithoutControl: '/api_busi/vMidBizOrderServiceScrapAction/queryWithoutControl',
    },
    vMidBizContractBaseDecorate: {
        query: '/api_busi/vMidBizContractBaseDecorateAction/query',
        queryWithoutControl: '/api_busi/vMidBizContractBaseDecorateAction/queryWithoutControl',
    },
    vMidBizContractDesign: {
        query: '/api_busi/vMidBizContractDesignAction/query',
        queryWithoutControl: '/api_busi/vMidBizContractDesignAction/queryWithoutControl',
    },
    vMidBizContractIntention: {
        query: '/api_busi/vMidBizContractIntentionAction/query',
        queryWithoutControl: '/api_busi/vMidBizContractIntentionAction/queryWithoutControl',
    },
    bizContractFlowRecord: {
        getList: "/api_busi/bizContractFlowRecord/FlowList"
    },
    bizContractWorkFlowRecord:{
        flowList:'/api_busi/bizContractWorkFlowRecord/FlowList'
    },
    vMidBizOrderMeasure: {
        query: '/api_busi/vMidBizOrderMeasureAction/query',
        queryWithoutControl: '/api_busi/vMidBizOrderMeasureAction/queryWithoutControl',
    },
    vCustomerAnalysis: {
        query: '/api_busi/vCustomerAnalysisAction/query',
        queryByServiceId: '/api_busi/vCustomerAnalysisAction/queryByServiceId',
        queryTreeByServiceId: '/api_busi/vCustomerAnalysisAction/queryTreeByServiceId',
        queryRebatesByServiceId: '/api_busi/vCustomerAnalysisAction/queryRebatesByServiceId',
    },
    // bizOutputValue: {
    //     query: '/api_busi/bizOutputValueAction/query',
    //     add: '/api_busi/bizOutputValueAction/add',
    //     update: '/api_busi/bizOutputValueAction/update',
    //     autoSave: '/api_busi/bizOutputValueAction/autoSave',
    //     findById: '/api_busi/bizOutputValueAction/findById',
    //     updateStatus: '/api_busi/bizOutputValueAction/updateStatus',
    //     makeSureMany: '/api_busi/bizOutputValueAction/makeSureMany',
    //     // autoSave:'/api_busi/bizOutputValueAction/autoSave',
    //     export: '/api_busi/bizOutputValueAction/export',
    //     queryCollect: '/api_busi/bizOutputValueAction/getBizOutputValueCollectDtos',
    //     printCollect: '/api_busi/bizOutputValueAction/printBizOutputValueCollectDtos',
    // },
    bizOutputValue: {
        query: '/api_busi/bizOutputValueActionNew/query',
        add: '/api_busi/bizOutputValueActionNew/add',
        update: '/api_busi/bizOutputValueActionNew/update',
        autoSave: '/api_busi/bizOutputValueActionNew/autoSave',
        findById: '/api_busi/bizOutputValueActionNew/findById',
        updateStatus: '/api_busi/bizOutputValueActionNew/updateStatus',
        makeSureMany: '/api_busi/bizOutputValueActionNew/makeSureMany',
        // autoSave:'/api_busi/bizOutputValueActionNew/autoSave',
        export: '/api_busi/bizOutputValueActionNew/export',
        queryCollect: '/api_busi/bizOutputValueAction/getBizOutputValueCollectDtos',
        printCollect: '/api_busi/bizOutputValueAction/printBizOutputValueCollectDtos',
    },
    vFinanceCustomerContractMaterialReceivables: {
        query: '/api_busi/vFinanceCustomerContractMaterialReceivables/query',
        export: '/api_busi/vFinanceCustomerContractMaterialReceivables/export',
        queryAll: '/api_busi/vFinanceCustomerContractMaterialReceivables/queryAll',
        update: '/api_busi/vFinanceCustomerContractMaterialReceivables/update',
    },
    VProjectOperationAnalysis: {
        query: '/api_busi/vProjectOperationAnalysis/query',
    },
    vFinanceRebateReceivables: {
        query: '/api_busi/vFinanceRebateReceivables/query',
        export: '/api_busi/vFinanceRebateReceivables/export',
        queryAll: '/api_busi/vFinanceRebateReceivables/queryAll',
    },
    //项目经理考核
    vGuaranteeInfoExamine: {
        query: '/api_busi/vGuaranteeInfoExamine/query',
        queryAll: '/api_busi/vGuaranteeInfoExamine/queryAll',
    },
    //基装收款结算
    vBizBaseContractProductionValueAction: {
        query: '/api_busi/vBizBaseContractProductionValueAction/query',
        queryAll: '/api_busi/vBizBaseContractProductionValueAction/queryAll'
    },
    // 客户基装结算报表
    vProjProjectInfoExtAction: {
        query: '/api_proj/vProjProjectInfoExtAction/query',
    },
    //商家结算分析表
    vBizFinanceSupplierSettlementAction: {
        query: '/api_busi/vBizFinanceSupplierSettlementAnalysisAction/query',
    },
    //供应商收款表
    VBizFinanceSupplierReceivables: {
        query: '/api_busi/VBizFinanceSupplierReceivablesAction/query',
    },
    //供应商基础信息表
    vBizSupplyInfoAction: {
        query: '/api_busi/vBizSupplyInfoAction/query',
    },
    //在建工地分析表
    bizBuildingAnalysis: {
        query: '/api_busi/bizBuildingAction/query',
    },
    // 销售产值报表
    bizOrderMaterialReportAction: {
        query: '/api_busi/bizOrderMaterialReportAction/query',
        export: '/api_busi/bizOrderMaterialReportAction/exportExcel',
    },
    // 销售产值SKU报表
    bizOrderMaterialSkuReportAction: {
        query: '/api_busi/bizOrderMaterialSkuReportAction/query',
        export: '/api_busi/bizOrderMaterialSkuReportAction/exportExcel',
    },
    // 采购产值报表
    vBizOrderPurchaseAction: {
        query: '/api_busi/vBizOrderPurchaseAction/query',
        export: '/api_busi/vBizOrderPurchaseAction/exportExcel',
    },
    // 采购产值报表新
    bizOrderPurchaseReportAction: {
        query: '/api_busi/bizOrderPurchaseReportAction/query',
        export: '/api_busi/bizOrderPurchaseReportAction/exportExcel',
    },
    // 采购SKU产值报表
    bizOrderPurchaseSkuReport: {
        query: '/api_busi/BizOrderPurchaseSkuReportAction/query',
        export: '/api_busi/BizOrderPurchaseSkuReportAction/exportExcel',
    },
    // 采购严选产值报表
    vBizOrderPurchaseYanXuanAction: {
        query: '/api_busi/vBizOrderPurchaseYanXuanAction/query',
    },
    // 采购单报表
    vBizOrderPurchaseReportAction: {
        query: '/api_busi/vBizOrderPurchaseReportAction/query',
    },
    // 完工结算明细表
    vProAccountAction: {
        query: '/api_busi/vProAccountAction/query',
    },
    // 完工结算明细子表
    vProAccountDetailAction: {
        query: '/api_busi/vProAccountDetailAction/query',
    },
    // 完工结算分析报表
    vBizAccountReportAnalysisAction: {
        query: '/api_busi/vBizAccountReportAnalysisAction/query',
    },
    //应付款报表
    projFinanceReceivableMid: {
        query: '/api_proj/projFinanceReceivableMid/query',
    },
    //材料合同明细表
    vBizContractMaterialDetailMasterAction: {
        query: '/api_busi/vBizContractMaterialDetailMasterAction/query',
    },
    //产品合同产值表
    vProductContractValueAction: {
        query: '/api_busi/vProductContractValueAction/query',
        export: '/api_busi/vProductContractValueAction/export',
    },
    //材料合同明细子表
    vBizContractMaterialDetailAction: {
        query: '/api_busi/vBizContractMaterialDetailAction/query',
    },
    //产品SKU管理表
    bizOrderSkuAction: {
        query: '/api_busi/bizOrderSKUAction/query',
    },
    // 返利财年维护
    bizRebateFiscalYearMaintenance: {
        query: '/api_busi/bizRebateFiscalYearMaintenance/query',
        add: '/api_busi/bizRebateFiscalYearMaintenance/add',
        edit: '/api_busi/bizRebateFiscalYearMaintenance/edit',
        delete: '/api_busi/bizRebateFiscalYearMaintenance/delete',
    },
    // 拆改建返利财年维护
    bizRebateReformYear: {
        query: '/api_busi/bizRebateReformYear/query',
        add: '/api_busi/bizRebateReformYear/add',
        edit: '/api_busi/bizRebateReformYear/edit',
        delete: '/api_busi/bizRebateReformYear/delete',
        supplyList: '/api_busi/bizReformSupplyAction/query',
    },
    // 质量汇报管理
    projQualityReport: {
        query: '/api_proj/projQualityReportAction/query',
        add: '/api_proj/projQualityReportAction/add',
        queryByCode: '/api_proj/projQualityReportAction/queryByCode',
        queryAll: '/api_proj/projQualityReportAction/queryAll',
        delete: '/api_proj/projQualityReportAction/delete',
        queryDetail: '/api_proj/projQualityReportDetailAction/query',
        addDetail: '/api_proj/projQualityReportDetailAction/addNew',
        updateDetail: '/api_proj/projQualityReportDetailAction/update',
        deleteDetail: '/api_proj/projQualityReportDetailAction/delete',
        queryOneDetail: '/api_proj/projQualityReportDetailAction/queryOne',
    },

    // 分公司价格系数维护
    bizBranchPriceCoefficientConfig: {
        query: '/api_busi/bizBranchPriceCoefficientConfigAction/query',
        add: '/api_busi/bizBranchPriceCoefficientConfigAction/add',
        edit: '/api_busi/bizBranchPriceCoefficientConfigAction/edit',
        delete: '/api_busi/bizBranchPriceCoefficientConfigAction/delete',
    },

    //工费发放周期管理
    projWagePeriod: {
        list: '/api_proj/projWagePeriod/list',//列表查询
        save: '/api_proj/projWagePeriod/save',//保存
    },
    projWageCycle: {
        query: '/api_proj/projWageCycle/query',//列表查询
        save: '/api_proj/projWageCycle/add',//保存
        getById: '/api_proj/projWageCycle/getById',//查看详情
        checkCycleByOrgId: '/api_proj/projWageCycle/checkCycleByOrgId',//检查组织下面是否存在周期表
        deleteById: '/api_proj/projWageCycle/delete',//删除
        copy: '/api_proj/projWageCycle/copy',//删除


    },
    settingTargetType: {
        query: '/api_busi/bizSettingTargetType/query',//列表查询
        save: '/api_busi/bizSettingTargetType/add',//保存
        getById: '/api_busi/bizSettingTargetType/getById',//查看详情
        deleteById: '/api_busi/bizSettingTargetType/delete',//删除
        edit: '/api_busi/bizSettingTargetType/edit',//修改
        getAllByLevel:'/api_busi/bizSettingTargetType/getAllByLevel',//获取一级分类
        changeStatus:'/api_busi/bizSettingTargetType/changeStatus',
    },
    bizContractSupplementaryTerms:{
        query: '/api_busi/bizContractSupplementaryTerms/query',//列表查询
        save: '/api_busi/bizContractSupplementaryTerms/add',//保存
        getById: '/api_busi/bizContractSupplementaryTerms/getById',//查看详情
        edit: '/api_busi/bizContractSupplementaryTerms/edit',//修改
        changeStatus:'/api_busi/bizContractSupplementaryTerms/changeStatus',
    },







    productCategory: {
        query: '/api_busi/bizProductCategory/query',//列表查询
        save: '/api_busi/bizProductCategory/add',//保存
        getById: '/api_busi/bizProductCategory/getById',//查看详情
        deleteById: '/api_busi/bizProductCategory/delete',//删除
        edit: '/api_busi/bizProductCategory/edit',//修改
        getAllByLevel2:'/api_busi/bizProductCategory/getAllByLevel2',//获取二级品类
    },

    //客户资源报表
    vCustomerOrderAction: {
        query: '/api_busi/vCustomerOrderAction/query',
        queryAll: '/api_busi/vCustomerOrderAction/queryList',
    },
    //服务订单资源报表
    vOrderServiceForMarketingAction: {
        query: '/api_busi/vOrderServiceForMarketingAction/query',
        queryAll: '/api_busi/vOrderServiceForMarketingAction/queryList',
    },
    //设计收款结算
    vBizDesignContractProductionValueAction: {
        query: '/api_busi/vBizDesignContractProductionValueAction/query',
        queryAll: '/api_busi/vBizDesignContractProductionValueAction/queryAll'
    },
    //项目预算明细报表
    vProjectBudgetDetailsAction: {
        query: '/api_proj/vProjectBudgetDetailsAction/query',
    },
    //项目内部预算
    projInternalBudgetAction: {
        query: '/api_proj/projInternalBudgetAction/query',
    },


    //工程延期信息表
    projectDelayReason: {
        query: '/api_proj/projDelayReason/query',
    },
    //交房数量报表
    vDeliveryNumAction: {
        queryList: '/api_proj/vDeliveryNumAction/queryList',
        queryByDate: '/api_proj/vDeliveryNumAction/queryByDate',
    },
    //工程实收款报表
    vProjectActualPaymentReceivedAction: {
        queryList: '/api_proj/vProjectActualPaymentReceivedAction/queryList',
        queryByDate: '/api_proj/vProjectActualPaymentReceivedAction/queryByDate',
    },
    //工程总资源报表
    vTotalEngineeringResourcesAction: {
        queryList: '/api_proj/vTotalEngineeringResourcesAction/queryList',
    },
    //工程总资源报表改造
    vProPlanProcessAction: {
        list: '/api_proj/vProPlanProcessAction/list',
    },
    //开工/完工回访报表
    afterSale: {
        query: '/api_busi/bizCustomerReturnVisitAnswer/queryAll',
        expoortExcel: '/api_busi/bizCustomerReturnVisitAnswer/exportExcel1',//开工令报表导出
        expoortExcel2: '/api_busi/bizCustomerReturnVisitAnswer/exportExcel2',//完工报表导出
        praise: '/api_busi/bizCustomerWorkOrderDetail/publicPraiseList',//口碑评价报表
        repairList: '/api_busi/bizCustomerWorkOrderDetail/repairList',//维修服务统计报表
        praiseExport: '/api_busi/bizCustomerWorkOrderDetail/publicPraiseExport',//口碑评价报表导出
        repairExport: '/api_busi/bizCustomerWorkOrderDetail/repairExport',//维修服务统计报表导出
        overallSatisfaction: '/api_busi/bizCustomerReturnVisitAnswer/querySatisfy',//满意度综合报表
        overallExport: '/api_busi/bizCustomerReturnVisitAnswer/querySatisfyExcel',//满意度综合报表导出
        queryDetail: '/api_busi/bizCustomerReturnVisitAnswer/queryAllDetail',// 查询明细的接口
        exportExcelStart: '/api_busi/bizCustomerReturnVisitAnswer/exportDetailStart',// 开工明细导出接口
        exportExcelEnd: '/api_busi/bizCustomerReturnVisitAnswer/exportDetailEnd',// 完工明细导出接口
    },
    //进度报表
    planSpeedAction: {
        list: '/api_proj/planSpeedAction/list',
    },
    planSpeedDetailAction: {
        query: '/api_proj/planSpeedDetailAction/query',
    },
    vProPlanProcessDetailAction: {
        query: '/api_proj/vProPlanProcessDetailAction/query',
    },
    vEcProductListAction: {
        query: '/api_busi/vEcProductListAction/query',
    },
    bizContractAttrValue: {
        get: '/api_busi/bizContractAttrValueAction/getAll',//根据合同的id以及合同的类型获取扩展信息
    },
    bizOrder: {
        add: '/api_busi/bizOrderAction/add',
        delete: '/api_busi/bizOrderAction/delete',
        query: '/api_busi/bizOrderAction/query',//需求服务单分页展示
        findByCode: '/api_busi/bizOrderAction/fuzzy',//根据需求订单号查询
        getPhoneCode: '/api_busi/bizOrderAction/getPhoneCode',//获取手机验证码
        bindOrder: '/api_busi/bizOrderAction/bindOrder',//绑定需求订单
    },
    bizNeededStuffConfig: {
        query: '/api_busi/bizNeededStuffConfigAction/query',//配置管理分页展示
        save: '/api_busi/bizNeededStuffConfigAction/save',//配置管理保存信息
        delete: '/api_busi/bizNeededStuffConfigAction/delete',//删除信息
        get: '/api_busi/bizNeededStuffConfigAction/get',//根据id获取信息
    },
    bizNeededStuffOrder: {
        query: '/api_busi/bizNeededStuffOrderAction/query',
        byServiceId: '/api_busi/bizNeededStuffOrderAction/byServiceId',
        byFlowId: '/api_busi/bizNeededStuffOrderAction/byFlowId',
        submit: '/api_busi/bizNeededStuffOrderAction/submit',
        complete: '/api_busi/bizNeededStuffOrderAction/complete',
    },
    bizOrderProfitSplit: {
        add: '/api_busi/bizOrderProfitSplitAction/add',
        edit: '/api_busi/bizOrderProfitSplitAction/edit',
        getBaseData: '/api_busi/bizOrderProfitSplitAction/getBaseData',
        delete: '/api_busi/bizOrderProfitSplitAction/delete',
        query: '/api_busi/bizOrderProfitSplitAction/query',
        getById: '/api_busi/bizOrderProfitSplitAction/getById',
        completeAudit: '/api_busi/bizOrderProfitSplitAction/completeAudit',
        audit: '/api_busi/bizOrderProfitSplitAction/audit',
    },
    bizMyCustomer:{
        getCustomerManagers:'/api_busi/bizOrderServiceAction/customerManagers',//客户经理模糊搜索
        getTagsView:'/api_busi/bizOrderServiceAction/tagsView',//获取快捷搜索条件树
        updateCustClassify:'/api_busi/bizOrderServiceAction/customerClassify',//变更客户类型
    },
    bizOrderService: {
        query: '/api_busi/bizOrderServiceAction/query',//服务订单分页展示
        queryWithProjAuth: '/api_busi/bizOrderServiceAction/queryWithProjAuth',//服务订单加上工程的角色权限,项目经理、项目管家
        queryForEc: '/api_busi/bizOrderServiceAction/queryForEc',//ec购物清单绑定服务订单页面查询服务订单接口
        allOrderIds: '/api_busi/bizOrderServiceAction/allOrderIds',//ec查询用户所对应的所有服务订单id
        queryByOrderId: '/api_busi/bizOrderServiceAction/queryByOrderId',//根据需求单id得到服务单
        get: '/api_busi/bizOrderServiceAction/get',//查询单条记录
        stop: '/api_busi/bizOrderServiceAction/stop',//更新服务订单状态为已终止
        blinding: '/api_busi/bizOrderServiceAction/blinding',//给服务订单绑定需求订单
        slip: '/api_busi/bizOrderServiceAction/slip',//转单
        transfer: '/api_busi/bizOrderServiceAction/transfer',//转单
        mark: '/api_busi/bizOrderServiceAction/mark',//给服务订单打标签
        quit: '/api_busi/bizOrderServiceAction/quit',//更新服务订单状态为终止中
        edit: '/api_busi/bizOrderServiceAction/edit',//修改服务订单
        updateNotIgnoreNull: '/api_busi/bizOrderServiceAction/updateNotIgnoreNull',//修改服务订单不忽略null值
        graphic: '/api_busi/bizOrderServiceAction/graphic',//根据服务订单获取平面规划图
        construction: '/api_busi/bizOrderServiceAction/construction',//根据服务订单获取施工图
        depth: '/api_busi/bizOrderServiceAction/depth',//根据服务订单获取深化设计图
        measure: '/api_busi/bizOrderServiceAction/measure',//根据服务订单获取量房
        getTags: '/api_busi/bizOrderServiceAction/markTags',//获取标签
        getByTaskId: '/api_busi/bizOrderServiceAction/getByTaskId',//根据服务订单获取深化设计图
        qrCode: '/api_busi/bizOrderServiceAction/qrCode',//模拟扫二维码
        getCusName: '/api_busi/bizOrderServiceAction/getCusName',//模拟扫二维码
        getByCustomer: '/api_busi/bizOrderServiceAction/getByCustomerOrder',//通过客户资源获取服务单
        complete: '/api_busi/bizOrderServiceAction/complete',//服务单终止审批结束节点
        completeRevive: '/api_busi/bizOrderServiceAction/completeRevive',//服务单复活审批结束节点
        getAllOrderService: '/api_busi/bizOrderServiceAction/getAllOrderService',//获取所有服务单
        docking: '/api_busi/bizOrderServiceAction/docking',//服务单对接
        revive: '/api_busi/bizOrderServiceAction/revive',//服务单复活
        export: '/api_busi/bizOrderServiceAction/export',//导出
        changeDesignCenter: '/api_busi/bizOrderServiceAction/changeDesignCenter',//转设计中心
        editSoftDesigner: '/api_busi/bizOrderServiceAction/editSoftDesigner',//编辑软装设计师
        getOrderCode: '/api_busi/bizOrderServiceAction/getOrderCode',//获取服务订单编码
        addForMaterial: '/api_busi/bizOrderServiceAction/addForMaterial',//新增服务订单
        editDockingTime: '/api_busi/bizOrderServiceAction/editDockingTime',//修改实际对接时间
        editAtjiaPhone: '/api_busi/bizOrderServiceAction/updateAtjiaPhone',//修改atjia账号
        pushMessageManually: '/api_atjia/atjiaAfterSaleQuestionnaireAction/pushMessageManually',//推送至atjia问卷
        editMarketing: '/api_busi/bizOrderServiceAction/editMarketing',//修改Marketing账号
        editPushAtjia: '/api_busi/bizOrderServiceAction/editPushAtjia',//是否推荐到atjia
        editShowProduct: '/api_busi/bizOrderServiceAction/editProductToAtjia',//是否推广产品板块
        querySoft: '/api_busi/bizOrderServiceAction/querySoft',//软装服务订单分页展示
        getSoftById: '/api_busi/bizOrderServiceAction/getSoftById',//通过id获取软装服务订单信息
        simpleQuery: '/api_busi/bizOrderServiceAction/simpleQuery',
        queryLog: '/api_busi/bizOrderServicePeopleRecordAction/transfer/query',//查询服务单对应的转单履历/{id}
        queryLogList: '/api_busi/bizOrderServicePeopleRecordAction/transfer/query',//查询所有的转单履历
        updatePeopleForService:  '/api_busi/bizOrderServiceAction/updatePeopleForService',//修改人员
        inviteInfo:'/api_busi/bizOrderServiceAction/inviteInfo',// 获取客户信息用于认证邀约
    },
    bizOrderServiceTagConfig: {
        query: '/api_busi/bizOrderServiceTagConfigAction/query',//客户标签(分页)
        list: '/api_busi/bizOrderServiceTagConfigAction/list',//客户标签list集合
        add: '/api_busi/bizOrderServiceTagConfigAction/add',//新增客户标签
        edit: '/api_busi/bizOrderServiceTagConfigAction/edit',//编辑客户标签
        delete: '/api_busi/bizOrderServiceTagConfigAction/delete',//删除客户标签
        validCode: '/api_busi/bizOrderServiceTagConfigAction/validCode',
    },
    vBizCustomerAnalysisAction: {
        queryWithProjAuth: '/api_busi/vBizCustomerAnalysisAction/queryWithProjAuth',//服务订单加上工程的角色权限,项目经理、项目管家
        get: '/api_busi/vBizCustomerAnalysisAction/get',//服务订单加上工程的角色权限,项目经理、项目管家
    },
    bizCustomerReturnVisit: {
        query: '/api_busi/bizCustomerReturnVisit/query',//分页查询
        export: '/api_busi/bizCustomerReturnVisit/export',//导出
        exportList: '/api_busi/bizCustomerReturnVisit/exportList',//开工完工回访满意度导出
        editWeChat: '/api_busi/bizCustomerReturnVisit/editWeChat',
        getInfo: '/api_busi/bizCustomerReturnVisit/edit',//分页查询
        getOrderSituation: '/api_busi/bizCustomerReturnVisit/getOrderSituation',//获取下单详情
        answerCall: '/api_busi/bizCustomerReturnVisit/commitQuestionnaire',
        querySearchHouse: '/api_cms/busiContentHouse/findHouseNameList',//搜索楼盘名
        addressBook: '/api_busi/bizReturnVisitAddressList/getAllAddressListByReturnVisitId',//通讯簿列表
        saveAddress: '/api_busi/bizReturnVisitAddressList/saveAndUpdateByReturnVisitId',//保存通讯簿

    },
    // 客户管理-满意度问卷相关
    bizCustomerQuestionnaire: {
        listPage: '/api_atjia/atjiaAfterSaleQuestionnaireAction/query',//问卷列表
        tree: '/api_atjia/atjiaAfterSaleQuestionnaireAction/getViewTool',//问卷菜单树
        detail: '/api_atjia/atjiaAfterSaleQuestionnaireAction/getQuestionnaire/',//问卷详情
        stageList: '/api_atjia/atjiaAfterSaleQuestionnaireAction/getQuestionnaireList/',//获取阶段列表
        logList: '/api_atjia/atjiaAfterSaleTrackerAction/getSystemTracker/',//获取问卷修改日志
        getRecord: '/api_atjia/atjiaAfterSaleTrackerAction/getPersonTracker/',//获取人员跟进列表
        addRecord: '/api_atjia/atjiaAfterSaleTrackerAction/saveTracker/',//添加跟进记录
        queryExport: '/api_atjia/atjiaAfterSaleQuestionnaireAction/export',//问卷列表导出
        saveRemarks: '/api_atjia/atjiaAfterSaleQuestionnaireAction/updateRemark/',//保存问卷备注
        saveAnswer: '/api_atjia/atjiaAfterSaleQuestionnaireAnswerAction/saveAnswer/',//保存问卷答案
    },
    bizCustomerWorkOrderDetail: {
        query: '/api_busi/bizCustomerWorkOrderDetail/query',//分页查询
        exportData: '/api_busi/bizCustomerWorkOrderDetail/queryExport',//导出
        audit: '/api_busi/bizCustomerWorkOrderDetail/audit',//提交
        addResponse: '/api_busi/bizCustomerWorkOrderDetail/inputTime',//录入分公司响应时间
        updateCustomer: '/api_busi/bizCustomerWorkOrderDetail/updateCustomer',//更改客服
        // export: '/api_busi/bizCustomerReturnVisit/export',//导出
        // editWeChat: '/api_busi/bizCustomerReturnVisit/editWeChat',
        // getInfo: '/api_busi/bizCustomerReturnVisit/edit',//分页查询
        // getOrderSituation: '/api_busi/bizCustomerReturnVisit/getOrderSituation',//获取下单详情
        // answerCall: '/api_busi/bizCustomerReturnVisit/commitQuestionnaire'
    },
    bizOrderServicePeopleShowAction: {
        getByServiceId: '/api_busi/bizOrderServicePeopleShowAction/getByServiceId',
        add: '/api_busi/bizOrderServicePeopleShowAction/add',
        edit: '/api_busi/bizOrderServicePeopleShowAction/edit'
    },

    //劳务合同
    bizContractLabourAction: {
        query: '/api_busi/bizContractLabourAction/query',//分页查询
        add: '/api_busi/bizContractLabourAction/add',//新增
        delete: '/api_busi/bizContractLabourAction/delete',//删除
        findById: '/api_busi/bizContractLabourAction/findById',//查询单蹦
        edit: '/api_busi/bizContractLabourAction/edit',//修改
        addAudit: '/api_busi/bizContractLabourAction/addAudit',//提交审核
    },
    bizContractBaseDecorate: {
        query: '/api_busi/bizContractBaseDecorateAction/query',//基装合同分页展示
        export: '/api_busi/bizContractBaseDecorateAction/export',//基装合同导出
        add: '/api_busi/bizContractBaseDecorateAction/add',//创建基装合同
        reset: '/api_busi/bizContractBaseDecorateAction/reset',//重置基装合同
        updateContractPeople: '/api_busi/bizContractBaseDecorateAction/updatePeople',//重置基装合同
        edit: '/api_busi/bizContractBaseDecorateAction/edit',//修改基装合同
        editStopTime: '/api_busi/bizContractBaseDecorateAction/editStopTime',//修改基装合同
        get: '/api_busi/bizContractBaseDecorateAction/get',//获取单个基装合同
        editConstruction: '/api_busi/bizContractBaseDecorateAction/updateConstruction',//修改是否期房和 工期时间范围
        delete: '/api_busi/bizContractBaseDecorateAction/delete',//删除基装合同
        audit: '/api_busi/bizContractBaseDecorateAction/audit',//提交审核
        stop: '/api_busi/bizContractBaseDecorateAction/stop',
        addAudit: '/api_busi/bizContractBaseDecorateAction/addAudit',//新增并提交审核
        updateAudit: '/api_busi/bizContractBaseDecorateAction/updateAudit',//修改并提交审核
        code: '/api_busi/bizContractBaseDecorateAction/code',//获取基装合同编码
        queryCode: '/api_busi/bizContractBaseDecorateAction/code',//获取基装合同编码
        flow: '/api_busi/bizContractBaseDecorateAction/getByFlow',//通过flowId获取合同
        complete: '/api_busi/bizContractBaseDecorateAction/complete',//基装合同节点完成

        resignComplete: '/api_busi/bizContractBaseDecorateAction/resignComplete',//基装合同重签-节点完成
        getConName: '/api_busi/bizContractBaseDecorateAction/getConName',//基装合同节点完成
        checkRepeat: '/api_busi/bizContractBaseDecorateAction/checkPrintCode',//判断合同印刷码是否重复
        getBizContractBaseDecorateMoney: '/api_busi/bizContractBaseDecorateAction/getBizContractBaseDecorateMoney',//查询基装合同签约金额（工程段用）
        judgeBaseContractIsResigned: '/api_busi/bizContractBaseDecorateAction/judgeBaseContractIsResigned',//校验合同是否重签过
        resignApply: '/api_busi/bizContractBaseDecorateAction/resignApply',// 重签申请提交

        backFlow:'/api_busi/bizContractBaseDecorateAction/backFlow', // 流程撤回
        startEsignFlow: '/api_busi/bizContractBaseDecorateAction/startEsignFlow',//开启电子签
        resetEsignFlow: '/api_busi/bizContractBaseDecorateAction/resetEsignFlow',//重置签字签
        saveAndStartEsign:'/api_busi/bizContractBaseDecorateAction/addAndStartEsignFlow', // 保存并发起电子签
        completeLegalAudit: '/api_busi/bizContractBaseDecorateAction/completeLegalAudit', //法务审核结束
        showPdf: '/api_busi/bizContractBaseDecorateAction/previewContract' //电子合同预览

    },
    bizContractDesign: {
        query: '/api_busi/bizContractDesignAction/query',//设计合同分页展示
        export: '/api_busi/bizContractDesignAction/export',//设计合同导出
        audit: '/api_busi/bizContractDesignAction/audit',//提交审核
        reset: '/api_busi/bizContractDesignAction/reset',//重置合同
        updatePeople: '/api_busi/bizContractDesignAction/updatePeople',//修改合同合作人员
        delete: '/api_busi/bizContractDesignAction/delete',//删除设计合同 软删除
        add: '/api_busi/bizContractDesignAction/add',//新增设计合同
        addAudit: '/api_busi/bizContractDesignAction/addAudit',//新增并提交审核
        get: '/api_busi/bizContractDesignAction/get',//查询单个设计合同
        edit: '/api_busi/bizContractDesignAction/edit',//修改单个设计合同
        editStopTime: '/api_busi/bizContractDesignAction/editStopTime',//修改业务终止时间
        code: '/api_busi/bizContractDesignAction/code',//获取设计合同编码
        stop: '/api_busi/bizContractDesignAction/stop',//终止设计合同
        flow: '/api_busi/bizContractDesignAction/getByFlow',//通过flowId获取合同
        complete: '/api_busi/bizContractDesignAction/complete',//设计合同节点完成
        getConDeName: '/api_busi/bizContractDesignAction/getConDeName',//设计合同节点完成
        isOnlyDesign: '/api_busi/bizContractDesignAction/getIsOnlyDesignByDesignServiceId',//校验是否为纯设计合同
        judgeBizContractDesign: '/api_busi/bizContractDesignAction/judgeBizContractDesign',//校验合同是否重签过
        resignApply: '/api_busi/bizContractDesignAction/resignApply',//重签申请
        resignComplete: '/api_busi/bizContractDesignAction/resignComplete',//基装合同重签-节点完成

        backFlow:'/api_busi/bizContractDesignAction/backFlow', // 流程撤回
        startEsignFlow: '/api_busi/bizContractDesignAction/startEsignFlow',//开启电子签
        resetEsignFlow: '/api_busi/bizContractDesignAction/resetEsignFlow',//重置签字签
        saveAndStartEsign:'/api_busi/bizContractDesignAction/addAndStartEsignFlow', // 保存并发起电子签
        completeLegalAudit: '/api_busi/bizContractDesignAction/completeLegalAudit', //法务审核结束
        showPdf: '/api_busi/bizContractDesignAction/previewContract' //电子合同预览
    },
    bizContractSplit: {
        query: '/api_busi/bizContractCooperationOrgAction/query',//分页查询
        save: '/api_busi/bizContractCooperationOrgAction/saveOrUpdate',//新增或修改
        findVersion: '/api_busi/bizContractCooperationOrgAction/findVersion',//查询版本号
        findAllByCondition: '/api_busi/bizContractCooperationOrgAction/findAllByCondition',//根据合同类型 合同id 查询
        findAllPeople: '/api_busi/bizContractCooperationOrgAction/findAllPeople',//根据合同类型 合同id 查询
    },
    bizContractSoftDesign: {
        query: '/api_busi/bizContractSoftDesignAction/query',//设计合同分页展示
        export: '/api_busi/bizContractSoftDesignAction/export',//设计合同导出
        audit: '/api_busi/bizContractSoftDesignAction/audit',//提交审核
        delete: '/api_busi/bizContractSoftDesignAction/delete',//删除设计合同 软删除
        add: '/api_busi/bizContractSoftDesignAction/add',//新增设计合同
        addAudit: '/api_busi/bizContractSoftDesignAction/addAudit',//新增并提交审核
        get: '/api_busi/bizContractSoftDesignAction/get',//查询单个设计合同
        edit: '/api_busi/bizContractSoftDesignAction/edit',//修改单个设计合同
        editStopTime: '/api_busi/bizContractSoftDesignAction/editStopTime',//修改业务终止时间
        code: '/api_busi/bizContractSoftDesignAction/code',//获取设计合同编码
        stop: '/api_busi/bizContractSoftDesignAction/stop',//终止设计合同
        flow: '/api_busi/bizContractSoftDesignAction/getByFlow',//通过flowId获取合同
        complete: '/api_busi/bizContractSoftDesignAction/complete',//设计合同节点完成
        getConDeName: '/api_busi/bizContractSoftDesignAction/getConDeName',//设计合同节点完成
        isOnlyDesign: '/api_busi/bizContractSoftDesignAction/getIsOnlyDesignByDesignServiceId',//校验是否为纯设计合同
        judgeBizContractDesign: '/api_busi/bizContractSoftDesignAction/judgeBizContractDesign',//校验合同是否重签过
        exportContractPdf: '/api_busi/bizContractSoftDesignAction/exportContractPdf',
        reset: '/api_busi/bizContractSoftDesignAction/reset',
        updatePeople: '/api_busi/bizContractSoftDesignAction/updatePeople',
    },
    bizContractPrintRecords: {
        query: '/api_busi/bizContractPrintRecordsAction/query',//打印记录查询列表
        addRecords: '/api_busi/bizContractPrintRecordsAction/addRecords',//打印记录添加
    },
    bizContractIntention: {
        query: '/api_busi/bizContractIntentionAction/query',//分页查询意向合同
        export: '/api_busi/bizContractIntentionAction/export',//意向合同导出
        add: '/api_busi/bizContractIntentionAction/add',//新增意向合同
        queryOne: '/api_busi/bizContractIntentionAction/queryOne',//查询单个意向合同
        edit: '/api_busi/bizContractIntentionAction/edit',//修改单个意向合同
        delete: '/api_busi/bizContractIntentionAction/delete',//删除单个意向合同
        approve: '/api_busi/bizContractIntentionAction/approve',//提交审核意向合同
        stop: '/api_busi/bizContractIntentionAction/stop',//终止意向合同
        code: '/api_busi/bizContractIntentionAction/code',//生成意向合同编码
        complete: '/api_busi/bizContractIntentionAction/complete',//设计合同节点完成
        saveAndAudit: '/api_busi/bizContractIntentionAction/saveAndAudit',//保存并提交审核
        getConInName: '/api_busi/bizContractIntentionAction/getConInName',//模糊搜索合同名
        getByCusName: '/api_busi/bizContractIntentionAction/getByCusName',//模糊搜索合同名
    },
    bizOrderServiceInvite:{
        save:'/api_busi/bizOrderServiceInviteAction/save',// 发起电子签邀约
        authenticationInfo:'/api_busi/bizOrderServiceInviteAction/authenticationInfo',//认证信息
    },
    bizContractMaterial: {
        query: '/api_busi/bizContractMaterialAction/query',//分页查询材料合同
        add: '/api_busi/bizContractMaterialAction/add',//新增材料合同
        queryOne: '/api_busi/bizContractMaterialAction/queryOne',//查询单个材料合同
        queryOnes: '/api_busi/bizContractMaterialAction/queryOnes',//查询单个材料合同
        edit: '/api_busi/bizContractMaterialAction/edit',//修改单个材料合同
        editStopTime: '/api_busi/bizContractMaterialAction/editStopTime',//修改业务终止时间
        delete: '/api_busi/bizContractMaterialAction/delete',//删除单个材料合同
        approve: '/api_busi/bizContractMaterialAction/approve',//提交审核材料合同
        stop: '/api_busi/bizContractMaterialAction/stop',//终止材料合同
        code: '/api_busi/bizContractMaterialAction/code',//生成材料合同编码
        queryByName: '/api_busi/bizContractMaterialAction/queryByName',//根据材料合同名称查询材料合同  Lambert_han
        complete: '/api_busi/bizContractMaterialAction/complete',//设计合同节点完成
        getConName: '/api_busi/bizContractMaterialAction/getConName',//设计合同节点完成
        saveAndAudit: '/api_busi/bizContractMaterialAction/saveAndAudit',//保存并提交审核
        queryByOrderServiceId: '/api_busi/bizContractMaterialAction/queryByOrderServiceId',//查询项目详情中所要用到的材料合同的编码
        queryByOrderServiceIdWithoutStatus: '/api_busi/bizContractMaterialAction/queryByOrderServiceIdWithoutStatus',//根据服务单id查询所有的材料合同
        getMaterialCostByServiceId: '/api_busi/bizContractMaterialAction/getMaterialCostByServiceId',//查询签约总金额
        export: '/api_busi/bizContractMaterialAction/export',//材料合同导出
        editFlowTime: '/api_busi/bizContractMaterialAction/editFlowTime',
        reset: '/api_busi/bizContractMaterialAction/reset', // 重置合同
        updatePeople: '/api_busi/bizContractMaterialAction/updatePeople', // 修改并提交分摊人员信息
        reCreatePDF:"/api_busi/bizContractMaterialAction/createPdf",
        startLegalAudit: '/api_busi/bizContractMaterialAction/startLegalAudit',//非标条款审核
        completeLegalAudit: '/api_busi/bizContractMaterialAction/completeLegalAudit',//非标条款完成节点
        addGifts:'/api_busi/bizContractMaterialAction/addGifts',
        backFlow:'/api_busi/bizContractMaterialAction/backFlow',
        startEsignFlow: '/api_busi/bizContractMaterialAction/startEsignFlow',//开启电子签
        resetEsignFlow: '/api_busi/bizContractMaterialAction/resetEsignFlow'//重置签字签

    },
    bizContractTerms:{
      getTerms:'/api_busi/bizContractTerms/getTerms',
    },
    bizContractMaterialGoodsDetail: {
        query: '/api_busi/bizContractMaterialGoodsDetailAction/query',//分页查询材料合同
        queryByContractId: '/api_busi/bizContractMaterialGoodsDetailAction/queryByContractId',//根据材料合同id获取旗下所有材料明细
        add: '/api_busi/bizContractMaterialGoodsDetailAction/add',//分页查询材料合同
        delete: '/api_busi/bizContractMaterialGoodsDetailAction/delete',//分页查询材料合同
    },
    bizContractStop: {
        queryData: '/api_busi/bizContractTerminationAgreementAction/edit',//根据合同id和类型查询合同信息
        addOrEdit: '/api_busi/bizContractTerminationAgreementAction/add',//终止协议新增/修改
        audit: '/api_busi/bizContractTerminationAgreementAction/audit/',//终止协议提交审核
        complete: '/api_busi/bizContractTerminationAgreementAction/complete',//终止协议审核接口
        getById: '/api_busi/bizContractTerminationAgreementAction/getById',//审批页面获取终止协议信息
        checkStop:'/api_busi/bizContractTerminationAgreementAction/saveBeforeCheck',//校验是否可以终止
        getByContractId:'/api_busi/bizContractTerminationAgreementAction/getByContractId',
        resetStop:"/api_busi/bizContractTerminationAgreementAction/resetStop",
        allVersions:"/api_busi/bizContractTerminationAgreementAction/allVersions",// 根据合同id 合同类型获取所有的终止协议版本，按版本倒叙的
        queryByVersion:"/api_busi/bizContractTerminationAgreementAction/findByVersion"
    },
    viewBizContract: {
        query: '/api_busi/viewBizContractAction/query',//分页查询合同视图
        queryByType: '/api_busi/viewBizContractAction/queryByType',//通过类型查询
        queryByTypeForOutPut: '/api_busi/viewBizContractAction/queryByTypeForOutPut',
        queryByTypeAndSrcServiceId: '/api_busi/viewBizContractAction/queryByTypeAndSrcServiceId',//通过类型和转出服务单id查询
        getConInName: '/api_busi/viewBizContractAction/getConInName',//通过名称和服务单id查询
        getBySidAndSecondCode: '/api_busi/viewBizContractAction/getBySidAndSecondCode',//通过服务单id和二级名称查询
        queryProjByBaseId: '/api_busi/viewBizContractAction/queryProjByBaseId',//通过服务单id查项目
        queryByContractTypeForOutPut: '/api_busi/viewBizContractAction/queryByContractTypeForOutPut',//通过产值里的合同类型来查找对应的合同
    },
    bizFinanceAccount: {
        add: '/api_busi/bizFinanceAccount/add',//新增
        update: '/api_busi/bizFinanceAccount/edit',//更新
        delete: '/api_busi/bizFinanceAccount/delete',//删除
        query: '/api_busi/bizFinanceAccount/query',//查询
        getById: '/api_busi/bizFinanceAccount/edit',//根据id查询
        getAllAccounts: '/api_busi/bizFinanceAccount/getAllAccounts',//查询所有账号
        queryByOrgId: '/api_busi/bizFinanceAccount/queryByOrgId',//根据orgId查询所有账号
        getAccountsByOrgId: '/api_busi/bizFinanceAccount/getAccountsByOrgId',//通过当前操作人的orgId获取其分公司的收款账号
        getBizFinanceAccountDtoByCustomerReceivablesId: '/api_busi/bizFinanceAccount/getByRid',//通过收款id获取主体
        getAccountsBySIdAndInvoice: '/api_busi/bizFinanceAccount/getAccountsBySIdAndInvoice',//通过主体id和开票类型获取账号（材料合同专用）
        getAccountsBySId: '/api_busi/bizFinanceAccount/getAccountsBySId',//通过主体id获取账号（软装设计合同专用）
    },
    bizFinanceInformation: {
        add: '/api_busi/BizFinanceInformationAction/create',//新增
        update: '/api_busi/BizFinanceInformationAction/edit',//更新
        batchDelete: '/api_busi/BizFinanceInformationAction/delete',//删除
        query: '/api_busi/BizFinanceInformationAction/query',//查询
        getById: '/api_busi/BizFinanceInformationAction/getById',//根据id查询
        getByAcctId: '/api_busi/BizFinanceInformationAction/getByAcctId',//根据acctId查询
    },
    bizFinanceCustomerReceivablesClaim: {
        add: '/api_busi/bizFinanceCustomerReceivablesClaim/add',//新增
        update: '/api_busi/bizFinanceCustomerReceivablesClaim/edit',//更新
        delete: '/api_busi/bizFinanceCustomerReceivablesClaim/delete',//删除
        query: '/api_busi/bizFinanceCustomerReceivablesClaim/query',//查询
        getById: '/api_busi/bizFinanceCustomerReceivablesClaim/edit',//根据id查询
        updateStatus: '/api_busi/bizFinanceCustomerReceivablesClaim/updateStatus',//更新状态
        updateHandwork: '/api_busi/bizFinanceCustomerReceivablesClaim/updateHandwork',//更新手工认领
        claimDismantle: '/api_busi/bizFinanceCustomerReceivablesClaim/claimDismantle',//分拆
        bindReceivableId: '/api_busi/bizFinanceCustomerReceivablesClaim/bindReceivableId',//绑定收款id
        getClaimsByTransferId: '/api_busi/bizFinanceCustomerReceivablesClaim/getClaimsByTransferId',//通过转款id取组织找认领数据
        getClaimsByAccountNumber: '/api_busi/bizFinanceCustomerReceivablesClaim/getClaimsByAccountNumber',//根据id查询
        printDetail: '/api_busi/bizFinanceCustomerReceivablesClaim/printDetail',// 导出PDF
    },
    bizFinanceClaimManageCashReport: {
        query: '/api_busi/bizFinanceClaimManageCashReport/query',//查询
    },
    vBizFinanceClaimHandworkReport: {
        query: '/api_busi/vBizFinanceClaimHandworkReportAction/query',//查询
    },
    bizSettleCenter: {
        query: '/api_busi/bizSettleCenterAction/query',//查询
    },
    bizOrderPurchaseStatistics: {
        query: '/api_busi/BizOrderPurchaseStatistics/query',//查询
    },
    viewBizMaterialContractOffer: {
        query: '/api_busi/viewBizMaterialContractOfferAction/query',//分页查询合同视图
        printDetail: '/api_busi/viewBizMaterialContractOfferAction/queryByContractId',//通过合同id获取报价单视图
    },
    bizOrderServicTrack: {
        query: '/api_busi/bizOrderServiceTrackAction/query',//分页查询合同视图
        add: '/api_busi/bizOrderServiceTrackAction/add',//新增跟进记录
        get: '/api_busi/bizOrderServiceTrackAction/get',//获取单条记录
        edit: '/api_busi/bizOrderServiceTrackAction/edit',//修改跟进记录
        delete: '/api_busi/bizOrderServiceTrackAction/delete',//删除跟进记录
        handle: '/api_busi/bizOrderServiceTrackAction/handle',//更新处理状态
    },

    BizOrderDesignHouseRegionDetail: {
        queryByServiceId: "/api_busi/bizOrderDesignHouseRegionDetailAction/queryByServiceId", //根据服务单id获取区域
    },
    VResourceMonitoring: {
        query: '/api_busi/vResourceMonitoringAction/sum',//分页查询
        download: '/api_busi/vResourceMonitoringAction/export',//导出
        detail: '/api_busi/vResourceMonitoringAction/queryDetail',//数据详情
        totalDetail: '/api_busi/vResourceMonitoringAction/queryTotalDetail',//累计栏数据详情
        total: '/api_busi/vResourceMonitoringAction/total',//累计栏数据
    },

    bizOrderHouseRegion: {
        add: '/api_busi/bizOrderHouseRegionAction/add',//新增房屋区域
        query: '/api_busi/bizOrderHouseRegionAction/query',//分页查询房屋区域
        queryOne: '/api_busi/bizOrderHouseRegionAction/find',//查询单条房屋区域
        remove: '/api_busi/bizOrderHouseRegionAction/delete',//删除房屋区域
        edit: '/api_busi/bizOrderHouseRegionAction/edit',//修改房屋区域
        getByPid: '/api_busi/bizOrderHouseRegionAction/getByPid',//通过父id获取房屋区域（树形结构用）
        getHouseByLevel: '/api_busi/bizOrderHouseRegionAction/getAllHouseRegionByLevelType',//通过级别获取所有二级区域
        getAllHouseRegion: '/api_busi/bizOrderHouseRegionAction/getAllHouseRegion',//通过级别获取所有区域
        getAllPid: '/api_busi/bizOrderHouseRegionAction/getAllPid',//获取所有父级id
        generateCode: '/api_busi/bizOrderHouseRegionAction/code',//获取所有父级id
    },
    bizAccountsCustomerApply: {
        query: '/api_busi/bizAccountsCustomerApply/query',//分页查询材料结算
        create: '/api_busi/bizAccountsCustomerApply/create',//创建客户结算申请
    },
    bizAccountsCustomerReport: {
        query: '/api_busi/bizAccountsCustomerReport/query',//分页查询结算单
        get: '/api_busi/bizAccountsCustomerReport/get',//获取单个结算单
        getWithOutReturn: '/api_busi/bizAccountsCustomerReport/getWithOutReturn',//获取单个结算单 排除返利
        checkReSettle: '/api_busi/bizAccountsCustomerReport/checkReSettle',//获取单个结算单 已确认的直接获取 没有确认的要重新生成最新的获取
        edit: '/api_busi/bizAccountsCustomerReport/edit',//保存结算单
        check: '/api_busi/bizAccountsCustomerReport/check',//确认结算
        reSettle: '/api_busi/bizAccountsCustomerReport/reSettle',//重新结算
        reSettleTime: '/api_busi/bizAccountsCustomerReport/reSettleTime',//根据时间重新结算
        projAccountsCustomerReportByOrderId: '/api_busi/bizAccountsCustomerReport/projAccountsCustomerReportByOrderId',//项目详情中的主材信息
        confirmTime: '/api_busi/bizAccountsCustomerReport/confirmTime',//重新结算
        complete: '/api_busi/bizAccountsCustomerReport/complete',//审批完成
        getSettCheckByProject: '/api_busi/bizAccountsCustomerReport/getSettCheckByProject',//项目经理选择check
        getAllSetting: '/api_busi/bizAccountsCustomerReport/getAllSetting',//获取该结算单和其他阶段其他结算单
    },
    bizAccountsCustomerBase: {
        query: '/api_busi/bizAccountsCustomerBase/query',//分页查询基装合同结算
    },
    bizAccountsCustomerSettle: {
        query: '/api_busi/bizAccountsCustomerSettle/query',//分页查询基装结算单
        add: '/api_busi/bizAccountsCustomerSettle/add',//增加基装结算单
        findByProjectId: '/api_busi/bizAccountsCustomerSettle/findByProjectId',//查询基装结算单首期款
        getAllBizAccountsCustomerByPid: '/api_busi/bizAccountsCustomerSettle/getAllBizAccountsCustomerByPid',//查询基装结算单
        projCustomerSettle: '/api_busi/bizAccountsCustomerSettle/projCustomerSettle',
        confirm: '/api_busi/bizAccountsCustomerSettle/confirm',//检验该阶段是否可以结算
        findPayStatusByProjectId: '/api_busi/bizAccountsCustomerSettle/findPayStatusByProjectId',//检验该阶段是否可以结算
        stage: '/api_busi/bizAccountsCustomerSettle/stage',//检验当前项目基装结算阶段

    },
    bizAccountsCustomerSettleReset: {
        submit: '/api_busi/bizAccountsCustomerSettleReset/submit',//申请重置提交审核
        getFlowData: '/api_busi/bizAccountsCustomerSettleReset/getByFlowId',//待审核信息
        historyList: '/api_busi/bizAccountsCustomerSettleReset/historyList', //查看审批流
    },
    bizFinanceManagerSettlement: {
        queryPage: '/api_busi/bizFinanceManagerSettlement/query',//项目经理结算
        queryForSpecial: '/api_busi/bizFinanceManagerSettlement/queryForSpecial',//显示 主材收入  基装收入
        add: '/api_busi/bizFinanceManagerSettlement/add',//新增
        completeFirst: '/api_busi/bizFinanceManagerSettlement/completeFirst',//审批节点1提交
        complete: '/api_busi/bizFinanceManagerSettlement/complete',//审批节点2提交
        resetCompleteFirst: '/api_busi/bizFinanceManagerSettlement/resetCompleteFirst',//重置审批节点1提交
        resetComplete: '/api_busi/bizFinanceManagerSettlement/resetComplete',//重置审批节点2提交
        edit: '/api_busi/bizFinanceManagerSettlement/edit',//修改请求
        update: '/api_busi/bizFinanceManagerSettlement/update',//修改数据
        submit: '/api_busi/bizFinanceManagerSettlement/submit',//提交
        resetSubmit: '/api_busi/bizFinanceManagerSettlement/resetSubmit',//重置提交
        byProjectId: '/api_busi/bizFinanceManagerSettlement/byProjectId',
        findByServiceId:'/api_busi/bizFinanceManagerSettlement/findByServiceId'
    },
    houseDeliveryAction:{
        queryPage:'/api_busi/bizHomeDeliveryAction/page',//获取交房列表页
        queryDeail:'/api_busi/bizHomeDeliveryAction/queryDetail/',//获取详情，+id
        queryRoyalty:'/api_busi/bizHomeDeliveryAction/queryRoyalty/',//获取倒扣利润明细+id
        resetTpl:'/api_busi/bizHomeDeliveryAction/resetTpl/',//重置模版+id
        reset:'/api_busi/bizHomeDeliveryAction/reset/',//重置特批流程+serviceId
        submitDelivery:'/api_busi/bizHomeDeliveryAction/submitDelivery/',//提交交房，+startSpecial，1是，0否。
        startSpecial:'/api_busi/bizHomeDeliveryAction/startSpecial/',//发起特批
        calculate:'/api_busi/bizHomeDeliveryAction/calculate/',//计算模版+id
        fzComplete:'/api_busi/bizHomeDeliveryAction/companyManagerFlow/',//分总审批
        complete:'/api_busi/bizHomeDeliveryAction/completeNote/',//审批
        revocation:'/api_busi/bizHomeDeliveryAction/revocation/',//审批
        export:'/api_busi/bizHomeDeliveryAction/export', // 导出接口
    },
    // 质检表单
    projProjectQualityTemplateAction:{
        getType:'/api_proj/ProjProjectQualityTemplateAction/getType',
    },

    BusiFinanceSupplierSettlementAction: {
        query: '/api_busi/BusiFinanceSupplierSettlementAction/query',
        export: '/api_busi/BusiFinanceSupplierSettlementAction/export',
        add: '/api_busi/BusiFinanceSupplierSettlementAction/add',
        edit: '/api_busi/BusiFinanceSupplierSettlementAction/edit',
        getById: '/api_busi/BusiFinanceSupplierSettlementAction/getById',
        submit: '/api_busi/BusiFinanceSupplierSettlementAction/submit',
        getBusiFinanceSupplierSettlementDetail: '/api_busi/BusiFinanceSupplierSettlementAction/getBusiFinanceSupplierSettlementDetail',
        delete: '/api_busi/BusiFinanceSupplierSettlementAction/deleteUpdate',
    },
    BusiFinanceSupplierSettlementTempAction: {
        batchWorkFlow: '/api_busi/BusiFinanceSupplierSettlementTempAction/batchWorkFlow'
    },
    bizFinanceManagerSettlementDetail: {
        getByTplId: '/api_busi/bizFinanceManagerSettlementDetail/getByTplId',//根据tplId查询（get）
        getMapByProjectId: '/api_busi/bizFinanceManagerSettlementDetail/getMapByProjectId',
        update: '/api_busi/bizFinanceManagerSettlementDetail/update',//根据tplId查询（get）
        deleteAndAdd: '/api_busi/bizFinanceManagerSettlementDetail/deleteAndAdd',//根据tplId查询（get）
        getCostData: '/api_busi/bizFinanceProjectPaymentOther/getCostData/', //打印时需要的字段
        getSettPrint: '/api_proj/projProjectChargeChange/getSettPrint/'//打印时需要的字段
    },
    bizFinanceManagerSettlementDetailHistory: {
        groupByProjectIdAndVersion: '/api_busi/bizFinanceManagerSettlementDetailHistory/groupByProjectIdAndVersion',//根据projectId查询
        getByTplIdAndVersion: '/api_busi/bizFinanceManagerSettlementDetailHistory/getByTplIdAndVersion',//根据projectId和version查询
    },
    //收付款分类设置
    busiFinancePaymentType: {
        queryPage: '/api_busi/bizFinancePaymentTypeAction/query',//分页查询
        add: '/api_busi/bizFinancePaymentTypeAction/add',//新增
        edit: '/api_busi/bizFinancePaymentTypeAction/edit',//修改
        getById: '/api_busi/bizFinancePaymentTypeAction/getById',//根据id查询
        start: '/api_busi/bizFinancePaymentTypeAction/start',//启用
        shut: '/api_busi/bizFinancePaymentTypeAction/shut',//禁用
        getByCatagory: '/api_busi/bizFinancePaymentTypeAction/getByCatagory',//根据catagory获取收付款二级分类
        getByCatagoryWithoutStatus: '/api_busi/bizFinancePaymentTypeAction/getByCatagoryWithoutStatus',//根据catagory获取所有收款类型
        getByThreeCode: '/api_busi/bizFinancePaymentTypeAction/getByThreeCode',//根据一二三级code获取对象
        getTwoByCatagory: '/api_busi/bizFinancePaymentTypeAction/getTwoByCatagory',//根据一级获取二级
        getReceiptTreeByCategory: '/api_busi/bizFinancePaymentTypeAction/getReceiptTreeByCategory',//根据一级获取二级和三级
        getThreeName: '/api_busi/bizFinancePaymentTypeAction/getThreeName',//根据一级二级获取三级
        getEntailByThreeCode: '/api_busi/bizFinancePaymentTypeAction/getEntailByThreeCode',//根据一级二级获取三级
        getL2Name: '/api_busi/bizFinancePaymentTypeAction/getL2Name',//根据一二级code获取二级name
    },
    //收付款分类设置
    busiFinanceType: {
        findAllList: '/api_busi/bizFinanceTypeAction/findList',//查询所有
    },
    //材料付款
    bizFinanceMaterialPayment: {
        queryPage: '/api_busi/bizFinanceMaterialPayment/query',//分页查询
        get: '/api_busi/bizFinanceMaterialPayment/queryOne',//查询单条信息
        add: '/api_busi/bizFinanceMaterialPayment/add',//新增
        edit: '/api_busi/bizFinanceMaterialPayment/edit',//修改
        supplierEdit: '/api_busi/bizFinanceMaterialPayment/supplierEdit/',//修改
        supplierEditAndApprove: '/api_busi/bizFinanceMaterialPayment/supplierEditAndApprove/',//修改
        code: '/api_busi/bizFinanceMaterialPayment/code',//获取付款单编码
        del: '/api_busi/bizFinanceMaterialPayment/delete',//删除
        approve: '/api_busi/bizFinanceMaterialPayment/approve',//提交审核
        complete: '/api_busi/bizFinanceMaterialPayment/complete',//审核通过
        completeCw: '/api_busi/bizFinanceMaterialPayment/completeCw',//财务审核通过
        completeFirst: '/api_busi/bizFinanceMaterialPayment/completeFirst',//审核通过
        addForSupSettlement: '/api_busi/bizFinanceMaterialPayment/addForSupSettlement',
        saveAndAudit: '/api_busi/bizFinanceMaterialPayment/saveAndAudit',//新增并审核
        writeOff: '/api_busi/bizFinanceMaterialPayment/writeOff',//冲销
        toVoid: '/api_busi/bizFinanceMaterialPayment/toVoid',//冲销
        export: '/api_busi/bizFinanceMaterialPayment/export',//导出
        delete: '/api_busi/bizFinanceMaterialPayment/deleteUpdate',//软删
        updateAmount: '/api_busi/bizFinanceMaterialPayment/updateAmount',
        updateIsConfirm: '/api_busi/bizFinanceMaterialPayment/updateIsConfirm',
        saveOrUpdateBill: '/api_busi/bizFinanceMaterialPayment/saveOrUpdateBill',
        checkBill: '/api_busi/bizFinanceMaterialPayment/checkBill',
    },
    //材料付款申请
    bizFinanceMaterialPaymentApply: {
        print: '/api_busi/financeMaterialPaymentApply/findTotalById',//打印
        detail: '/api_busi/financeMaterialPaymentApply/findDetailById',//查明细数据
        startWorkFlow: '/api_busi/financeMaterialPaymentApply/startWorkFlow',//提交审批
        addPayment: '/api_busi/financeMaterialPaymentApply/addPayment',//添加明细
        findDetailById: '/api_busi/financeMaterialPaymentApply/findDetailById',//查找有明细
        printDetail: '/api_busi/financeMaterialPaymentApply/printDetail',//下载明细的PDF
        printDetailByPaymentOrder: '/api_busi/financeMaterialPaymentApply/printDetailByPaymentOrder',//下载明细的PDF
        addAccount: '/api_busi/financeMaterialPaymentApply/addAccount',//选择收款账户
        delAccount: '/api_busi/financeMaterialPaymentApply/delAccount',//清除收款账户
        updateIsConfirm: '/api_busi/financeMaterialPaymentApply/updateIsConfirm',
        saveOrUpdateBill: '/api_busi/financeMaterialPaymentApply/saveOrUpdateBill',
        checkBill: '/api_busi/financeMaterialPaymentApply/checkBill',
    },
    bizFinanceProjectPayment: {
        queryPage: '/api_busi/bizFinanceProjectPayment/query',//分页查询
        queryThreeTypes: '/api_busi/bizFinanceProjectPayment/queryThreeTypes',//分页查询
        get: '/api_busi/bizFinanceProjectPayment/queryOne',//查询单条信息
        add: '/api_busi/bizFinanceProjectPayment/add',//手工录入
        addForAudit: '/api_busi/bizFinanceProjectPayment/addForAudit',//手工录入
        edit: '/api_busi/bizFinanceProjectPayment/edit',//修改
        findByPaymentNumber: '/api_busi/bizFinanceProjectPayment/findByPaymentNumber',//通过paymentNumber查询
        code: '/api_busi/bizFinanceProjectPayment/code',//获取付款单编码
        del: '/api_busi/bizFinanceProjectPayment/delete',//删除
        delPro: '/api_busi/bizFinanceProjectPayment/deletePro',//项目经理结算生成付款单删除
        approve: '/api_busi/bizFinanceProjectPayment/approve',//删除
        complete: '/api_busi/bizFinanceProjectPayment/complete',//审核通过
        completeFirst: '/api_busi/bizFinanceProjectPayment/completeFirst',//第一次审批
        calculate: '/api_busi/bizFinanceProjectPayment/calculateAmount',//计算金额
        saveAndAudit: '/api_busi/bizFinanceProjectPayment/saveAndAudit',//新增并审核
        saveSettlement: '/api_busi/bizFinanceProjectPayment/addForProjManagerSettlement',//项目经理结算生成付款单
        writeOff: '/api_busi/bizFinanceProjectPayment/writeOff',//冲销
        export: '/api_busi/bizFinanceProjectPayment/export',//导出
    },
    bizFinanceProjectPaymentPerson: {
        queryPage: '/api_busi/bizFinanceProjectPaymentPerson/query',//分页查询
        get: '/api_busi/bizFinanceProjectPaymentPerson/queryOne',//查询单条信息
        add: '/api_busi/bizFinanceProjectPaymentPerson/add',//手工录入
        addForAudit: '/api_busi/bizFinanceProjectPaymentPerson/addForAudit',//手工录入
        edit: '/api_busi/bizFinanceProjectPaymentPerson/edit',//修改
        findByPaymentNumber: '/api_busi/bizFinanceProjectPaymentPerson/findByPaymentNumber',//通过paymentNumber查询
        code: '/api_busi/bizFinanceProjectPaymentPerson/code',//获取付款单编码
        del: '/api_busi/bizFinanceProjectPaymentPerson/delete',//删除
        delPro: '/api_busi/bizFinanceProjectPaymentPerson/deletePro',//项目经理结算生成付款单删除
        approve: '/api_busi/bizFinanceProjectPaymentPerson/approve',//删除
        complete: '/api_busi/bizFinanceProjectPaymentPerson/complete',//审核通过
        completeComm: '/api_busi/bizFinanceProjectPaymentPerson/completeComm',//审核通过
        completeFirst: '/api_busi/bizFinanceProjectPaymentPerson/completeFirst',//第一次审批
        calculate: '/api_busi/bizFinanceProjectPaymentPerson/calculateAmount',//计算金额
        saveAndAudit: '/api_busi/bizFinanceProjectPaymentPerson/saveAndAudit',//新增并审核
        saveSettlement: '/api_busi/bizFinanceProjectPaymentPerson/addForProjManagerSettlement',//项目经理结算生成付款单
        writeOff: '/api_busi/bizFinanceProjectPaymentPerson/writeOff',//冲销
        export: '/api_busi/bizFinanceProjectPaymentPerson/export',//导出
        getByProjectThreeCode: '/api_busi/bizFinanceProjectPaymentPerson/getByProjectThreeCode',//项目
        getSubContractPrice: '/api_busi/bizFinanceProjectPaymentPerson/getSubContractPrice',
    },
    bizFinanceProjectPaymentOther: {
        queryPage: '/api_busi/bizFinanceProjectPaymentOther/query',//分页查询
        get: '/api_busi/bizFinanceProjectPaymentOther/queryOne',//查询单条信息
        add: '/api_busi/bizFinanceProjectPaymentOther/add',//手工录入
        addForAudit: '/api_busi/bizFinanceProjectPaymentOther/addForAudit',//手工录入
        edit: '/api_busi/bizFinanceProjectPaymentOther/edit',//修改
        findByPaymentNumber: '/api_busi/bizFinanceProjectPaymentOther/findByPaymentNumber',//通过paymentNumber查询
        code: '/api_busi/bizFinanceProjectPaymentOther/code',//获取付款单编码
        del: '/api_busi/bizFinanceProjectPaymentOther/delete',//删除
        delPro: '/api_busi/bizFinanceProjectPaymentOther/deletePro',//项目经理结算生成付款单删除
        approve: '/api_busi/bizFinanceProjectPaymentOther/approve',//删除
        complete: '/api_busi/bizFinanceProjectPaymentOther/complete',//审核通过
        completeComm: '/api_busi/bizFinanceProjectPaymentOther/completeComm',//审核通过
        completeFirst: '/api_busi/bizFinanceProjectPaymentOther/completeFirst',//第一次审批
        calculate: '/api_busi/bizFinanceProjectPaymentOther/calculateAmount',//计算金额
        saveAndAudit: '/api_busi/bizFinanceProjectPaymentOther/saveAndAudit',//新增并审核
        saveSettlement: '/api_busi/bizFinanceProjectPaymentOther/addForProjManagerSettlement',//项目经理结算生成付款单
        writeOff: '/api_busi/bizFinanceProjectPaymentOther/writeOff',//冲销
        export: '/api_busi/bizFinanceProjectPaymentOther/export',//导出
        getPaymentOtherByPidAndMid: '/api_busi/bizFinanceProjectPaymentOther/getPaymentOtherByPidAndMid',//获取
    },
    bizFinanceProjectPaymentManager: {
        queryPage: '/api_busi/bizFinanceProjectPaymentManager/query',//分页查询
        get: '/api_busi/bizFinanceProjectPaymentManager/queryOne',//查询单条信息
        add: '/api_busi/bizFinanceProjectPaymentManager/add',//手工录入
        addForAudit: '/api_busi/bizFinanceProjectPaymentManager/addForAudit',//手工录入
        edit: '/api_busi/bizFinanceProjectPaymentManager/edit',//修改
        findByPaymentNumber: '/api_busi/bizFinanceProjectPaymentManager/findByPaymentNumber',//通过paymentNumber查询
        code: '/api_busi/bizFinanceProjectPaymentManager/code',//获取付款单编码
        del: '/api_busi/bizFinanceProjectPaymentManager/delete',//删除
        delPro: '/api_busi/bizFinanceProjectPaymentManager/deletePro',//项目经理结算生成付款单删除
        approve: '/api_busi/bizFinanceProjectPaymentManager/approve',//删除
        complete: '/api_busi/bizFinanceProjectPaymentManager/complete',//审核通过
        completeFirst: '/api_busi/bizFinanceProjectPaymentManager/completeFirst',//第一次审批
        calculate: '/api_busi/bizFinanceProjectPaymentManager/calculateAmount',//计算金额
        saveAndAudit: '/api_busi/bizFinanceProjectPaymentManager/saveAndAudit',//新增并审核
        saveSettlement: '/api_busi/bizFinanceProjectPaymentManager/addForProjManagerSettlement',//项目经理结算生成付款单
        writeOff: '/api_busi/bizFinanceProjectPaymentManager/writeOff',//冲销
        export: '/api_busi/bizFinanceProjectPaymentManager/export',//导出
        checkResetSettlement: '/api_busi/bizFinanceProjectPaymentManager/checkResetSettlement',//通过paymentNumber查询
        queryStatusByPid: '/api_busi/bizFinanceProjectPaymentManager/queryStatusByPid',//通过项目id查询当前已有项目经理收款的状态
        getRetentionMoneyHasCost: '/api_busi/bizFinanceProjectPaymentManager/getRetentionMoneyHasCost',//通过项目id查询当前项目的累计质保金
    },
    bizFinancePaymentTypeAction: {
        getByCatagoryAndL2Code: "/api_busi/bizFinancePaymentTypeAction/getByCatagoryAndL2Code",//收付款类型的联动查询
    },
    bizReceivablesExt: {
        getByReceivables: '/api_busi/bizReceivablesExt/getByReceivables',//通过收款类型和收款id获取集合
        getByReceivablesByPid: '/api_busi/bizReceivablesExt/getByReceivablesByPid',//通过付款类型和付款id获取集合
    },

    bizShopInfoAction: {
        queryPage: '/api_busi/bizShopInfoAction/query',//分页查询
        add: '/api_busi/bizShopInfoAction/add',//新增
        get: '/api_busi/bizShopInfoAction/get',//获取
        getForRenew: '/api_busi/bizShopInfoAction/getForRenew',//获取
        update: '/api_busi/bizShopInfoAction/update',//更新
        delete: '/api_busi/bizShopInfoAction/delete',//删除
        audit: '/api_busi/bizShopInfoAction/audit',
        complete: '/api_busi/bizShopInfoAction/complete',
        stop: '/api_busi/bizShopInfoAction/stopShop',
        upTus: '/api_busi/bizShopInfoAction/upTu',
        addAndSubmit: '/api_busi/bizShopInfoAction/addAndSubmit',
        updateAndSubmit: '/api_busi/bizShopInfoAction/updateAndSubmit',
        restart: '/api_busi/bizShopInfoAction/restartShop',
        editEsign: '/api_busi/bizShopInfoAction/editEsign',
        updateSubject: '/api_busi/bizShopInfoAction/updateSubject',//更新主体
        startOtherEsignFlow: '/api_busi/bizShopInfoAction/startOtherEsignFlow',//发起其他主体
        reSign: '/api_busi/bizShopInfoAction/reSign',//重新发起
        toSupplyCheck: '/api_busi/bizShopInfoAction/toSupplyCheck',//发起供应商确认
        findAllSign: '/api_busi/bizShopInfoAction/findAllSign',//根据店铺的id查找 首签和续签 返回格式为： 首签 2020-01-03 —— 2020-12-31
        findSignSchedule: '/api_busi/bizShopInfoAction/findSignSchedule',//签署进度
        findHasSubShop: '/api_busi/bizShopInfoAction/findHasSubShop',//查看该供应商下是否有分包店铺
    },
    bizShopInfoRenewAction: {
        queryPage: '/api_busi/bizShopInfoRenewAction/query',//分页查询
        get: '/api_busi/bizShopInfoRenewAction/get',//获取
        add: '/api_busi/bizShopInfoRenewAction/add',//新增
        update: '/api_busi/bizShopInfoRenewAction/update',//更新
        addAndSubmit: '/api_busi/bizShopInfoRenewAction/addAndSubmit',
        updateAndSubmit: '/api_busi/bizShopInfoRenewAction/updateAndSubmit',
        delete: '/api_busi/bizShopInfoRenewAction/delete',//删除
        audit: '/api_busi/bizShopInfoRenewAction/audit',
        updateSubject: '/api_busi/bizShopInfoRenewAction/updateSubject',//更新主体
        startOtherEsignFlow: '/api_busi/bizShopInfoRenewAction/startOtherEsignFlow',//发起其他主体
        reSign: '/api_busi/bizShopInfoRenewAction/reSign',//重新发起
        toSupplyCheck: '/api_busi/bizShopInfoRenewAction/toSupplyCheck',//发送确认
        findSignSchedule: '/api_busi/bizShopInfoRenewAction/findSignSchedule',//签署进度
    },
    bizElectronicReceipt:{
        query:'/api_busi/bizElectronicReceipt/query',//查询收据列表
        getById:'/api_busi/bizElectronicReceipt/get/',//查询单个收据信息
        getByRedisId:'/api_busi/bizElectronicReceipt/getRedisDto/',//查询单个收据信息
        addAndSubmit:'/api_busi/bizElectronicReceipt/addAndSubmit',//新增并提交
        editAndSubmit:'/api_busi/bizElectronicReceipt/editAndSubmit/',//编辑并提交
        add:'/api_busi/bizElectronicReceipt/add',//新增
        edit:'/api_busi/bizElectronicReceipt/edit/',//修改
        invalid:'/api_busi/bizElectronicReceipt/abandon/',//作废
        sentToCus:'/api_busi/bizElectronicReceipt/send/',//发送给客户
        audit:'/api_busi/bizElectronicReceipt/audit/',//提交
        complete:'/api_busi/bizElectronicReceipt/complete/',//审核
        resetPdf:'/api_busi/bizElectronicReceipt/resetPdf',//重置Pdf

    },
    busiFinanceCustomerReceivables: {
        add: '/api_busi/bizFinanceCustomerReceivables/add',//新增
        delete: '/api_busi/bizFinanceCustomerReceivables/delete',//分页查询
        queryPage: '/api_busi/bizFinanceCustomerReceivables/query',//分页查询
        querySimplify: '/api_busi/bizFinanceCustomerReceivables/querySimplify',//优化查询
        queryBySid: '/api_busi/bizFinanceCustomerReceivables/queryBySid',//分页查询
        getAmount: '/api_busi/bizFinanceCustomerReceivables/getAmount',//查询总金额
        getByCusName: '/api_busi/bizFinanceCustomerReceivables/getByCusName',//查询总金额
        getById: '/api_busi/bizFinanceCustomerReceivables/getById',//通过id获取对象
        update: '/api_busi/bizFinanceCustomerReceivables/update',//修改更新
        getAllAmountByServiceId: '/api_busi/bizFinanceCustomerReceivables/getAllAmountByServiceId',//获取材料和软装退款时的退款上限
        getListByCid: '/api_busi/bizFinanceCustomerReceivables/getListByCid',//通过服务单id得到集合
        getAmountByCid: '/api_busi/bizFinanceCustomerReceivables/getAmountByCid',//通过服务单id得到收款数据和集合
        queryAllGroupByContract: '/api_busi/bizFinanceCustomerTransfer/queryAllGroupByContract',//通过服务订单id和转入合同类型获取材料合同信息
        getMaterAmountBySid: '/api_busi/bizFinanceCustomerReceivables/getMaterAmountBySid',//通过服务单id得到材料意向金收款金额
        getMaterPaymentAmountBySid: '/api_busi/bizFinanceCustomerReceivables/getMaterPaymentAmountBySid',//通过服务单id得到审核通过材料合同收款金额
        audit: '/api_busi/bizFinanceCustomerReceivables/audit',//开启审批流
        complete: '/api_busi/bizFinanceCustomerReceivables/complete',//完成审批流节点
        completeFirst: '/api_busi/bizFinanceCustomerReceivables/completeFirst',//完成第一步审批流节点
        getReceivablesForMaterial: '/api_busi/bizFinanceCustomerReceivables/getReceivablesForMaterial',//获取材料合同的收款单
        export: '/api_busi/bizFinanceCustomerReceivables/export',//导出
        writeOff: '/api_busi/bizFinanceCustomerReceivables/writeOff',//收款冲销
        updateSettlement: '/api_busi/bizFinanceCustomerReceivables/updateSettlement',
        addAndSubmit: '/api_busi/bizFinanceCustomerReceivables/addAndSubmit',//新增并提交
        updateAndSubmit: '/api_busi/bizFinanceCustomerReceivables/updateAndSubmit',//更新并提交
        getAllListBySid: '/api_busi/bizFinanceCustomerReceivables/getAllListBySid',//通过服务单id获取所有客户收款
        getAllPassListBySid: '/api_busi/bizFinanceCustomerReceivables/getAllPassListBySid',//通过服务单id获取所有审核通过的客户收款
        editFlowTime: '/api_busi/bizFinanceCustomerReceivables/editFlowTime',
        queryBySecondCodeAndThirdCode: '/api_busi/bizFinanceCustomerReceivables/queryBySecondCodeAndThirdCode',
        checkPayment: '/api_busi/bizFinanceCustomerReceivables/checkPayment',
        getReceiveAmount: '/api_busi/bizFinanceCustomerReceivables/getReceiveAmount',

    },
    bizFinanceCustomerTransfer: {
        add: '/api_busi/bizFinanceCustomerTransfer/add',//新增
        update: '/api_busi/bizFinanceCustomerTransfer/update',//新增
        delete: '/api_busi/bizFinanceCustomerTransfer/delete',//分页查询
        query: '/api_busi/bizFinanceCustomerTransfer/query',//分页查询
        getById: '/api_busi/bizFinanceCustomerTransfer/getById',//分页查询
        audit: '/api_busi/bizFinanceCustomerTransfer/audit',//提交审核
        complete: '/api_busi/bizFinanceCustomerTransfer/complete',//完成节点
        export: '/api_busi/bizFinanceCustomerTransfer/export',//导出
        queryAmountByRid: '/api_busi/bizFinanceCustomerTransfer/queryAmountByRid',//通过收款id查询该收款已转金额
    },
    bizFinanceSupplierReceivables: {
        add: '/api_busi/bizFinanceSupplierReceivables/add',//新增
        addAndSubmit: '/api_busi/bizFinanceSupplierReceivables/addAndSubmit',//新增并提交
        delete: '/api_busi/bizFinanceSupplierReceivables/delete',//分页查询
        queryPage: '/api_busi/bizFinanceSupplierReceivables/query',//分页查询
        getById: '/api_busi/bizFinanceSupplierReceivables/getById',//通过id获取对象
        update: '/api_busi/bizFinanceSupplierReceivables/update',//修改更新
        updateAndSubmit: '/api_busi/bizFinanceSupplierReceivables/updateAndSubmit',//修改更新并提交
        audit: '/api_busi/bizFinanceSupplierReceivables/audit',//开启审批
        complete: '/api_busi/bizFinanceSupplierReceivables/complete',//完成审批
        completeFirst: '/api_busi/bizFinanceSupplierReceivables/completeFirst',//完成审批第一个节点
        getByBidCidRname: '/api_busi/bizFinanceSupplierReceivables/getByBidCidRname',//通过商家和客户名字得到商家收款
        export: '/api_busi/bizFinanceSupplierReceivables/export',//导出商家收款
        updateSettlement: '/api_busi/bizFinanceSupplierReceivables/updateSettlement',//更新结算状态
        editFlowTime: '/api_busi/bizFinanceSupplierReceivables/editFlowTime',//更新结算状态
        updateIsCalculate: '/api_busi/bizFinanceSupplierReceivables/updateIsCalculate',//更新是否参与计算和倒推系数
        updateBranchPriceCoefficient: '/api_busi/bizFinanceSupplierReceivables/updateBranchPriceCoefficient',//更新分公司采购价系数
        checkFinances: '/api_busi/bizFinanceSupplierReceivables/checkFinances',//返利订单审核通过前判断是否有未审核通过的返利收款
    },
    //收付款模板设置
    busiFinancePaymentTpl: {
        queryPage: '/api_busi/bizFinancePaymentTplAction/query',//分页查询
        add: '/api_busi/bizFinancePaymentTplAction/add',//新增收付款模板
        edit: '/api_busi/bizFinancePaymentTplAction/edit',//修改收付款模板
        del: '/api_busi/bizFinancePaymentTplAction/delete',//删除
        getById: '/api_busi/bizFinancePaymentTplAction/getById',//根据id查询
        start: '/api_busi/bizFinancePaymentTplAction/start',//启用
        shut: '/api_busi/bizFinancePaymentTplAction/shut',//停用
    },
    workerLaborCost: {
        query: '/api_worker/workerLaborCostAction/query',//分页查询
        export: '/api_worker/workerLaborCostAction/export',//分页查询
        add: '/api_worker/workerLaborCostAction/add',//新增
        addList: '/api_worker/workerLaborCostAction/addList',//新增
        edit: '/api_worker/workerLaborCostAction/edit',//修改收付款模板
        del: '/api_worker/workerLaborCostAction/delete',//删除
        getById: '/api_worker/workerLaborCostAction/getById',//根据id查询
        calculateMoney: '/api_worker/workerLaborCostAction/calculateMoney',
        bindPayment: '/api_worker/workerLaborCostAction/bindPayment',
        unbindPayment: '/api_worker/workerLaborCostAction/unbindPayment',
        writeOff: '/api_worker/workerLaborCostAction/writeOff',
    },
    //付款单批次
    workerLaborCostApply: {
        query: '/api_worker/workerLaborCostApplyAction/query',//列表页
        submit: '/api_worker/workerLaborCostApplyAction/submitCostApplyFlow',//批次的提交
        detail: '/api_worker/workerLaborCostAction/getCostByApplyIdQuery',//工费单
        addQuery: '/api_worker/workerLaborCostAction/getCostByStatusQuery',//添加工费单列表
        detailAdd: '/api_worker/workerLaborCostAction/addWorkerLaborCostToApply',//添加工费单保存
        detailDel: '/api_worker/workerLaborCostAction/updateCostById',//删除工费单
        flow: '/api_worker/workerLaborCostApplyAction/getWorkerLaborCostApplyById',//工费批次审批流
        subFlow: '/api_worker/workerLaborCostApplyAction/costApplyFlow',//工费批次审批流提交
        exportExcel: '/api_worker/workerLaborCostApplyAction/exportExcel',//导出
        printPdf: '/api_worker/workerLaborCostApplyAction/printPdf',//打印
    },
    projectWorkReport: {
        query: '/api_worker/workerDailyAction/query',//分页查询
        add: '/api_worker/workerDailyAction/add',//新增
        get: '/api_worker/workerDailyAction/get',
    },
    projWorkPackage: {
        getAllEcItemCatDtoTree: '/api_busi/ecItemCatAction/getAllEcItemCatDtoTree',
        add: '/api_proj/projWorkPackage/add',//新增
        update: '/api_proj/projWorkPackage/edit',//更新
        delete: '/api_proj/projWorkPackage/delete',//删除
        query: '/api_proj/projWorkPackage/query',//查询
        getById: '/api_proj/projWorkPackage/edit',//根据id查询
        queryPackageByTemplate: '/api_proj/projWorkPackage/queryByTemplate',//通过模板id查询任务包
    },
    projWorkPackageCheckDetail: {
        add: '/api_proj/projWorkPackageCheckDetail/add',//新增
        update: '/api_proj/projWorkPackageCheckDetail/edit',//更新
        delete: '/api_proj/projWorkPackageCheckDetail/delete',//删除
        query: '/api_proj/projWorkPackageCheckDetail/query',//查询
        getById: '/api_proj/projWorkPackageCheckDetail/edit',//根据id查询
    },
    projWorkPackageCheckManage: {
        add: '/api_proj/projWorkPackageCheckManage/add',//新增
        update: '/api_proj/projWorkPackageCheckManage/edit',//更新
        delete: '/api_proj/projWorkPackageCheckManage/delete',//删除
        query: '/api_proj/projWorkPackageCheckManage/query',//查询
        getById: '/api_proj/projWorkPackageCheckManage/edit',//根据id查询
    },
    projPlanTemplate: {
        add: '/api_proj/projPlanTemplate/add',//新增
        update: '/api_proj/projPlanTemplate/edit',//更新
        delete: '/api_proj/projPlanTemplate/delete',//删除
        query: '/api_proj/projPlanTemplate/query',//查询
        getById: '/api_proj/projPlanTemplate/edit',//根据id查询
        changeStatus: '/api_proj/projPlanTemplate/changeStatus',//改状态
        copy: '/api_proj/projPlanTemplate/copy',//复制
    },
    projPlanInfo: {
        getById: '/api_proj/projPlanInfo/get',//根据id查询
        getSupply: '/api_proj/projPlanInfo/getPerson',//根据id查询个人任务包
        update: '/api_proj/projPlanInfo/save',//更新
        queryPage: "/api_proj/projPlanInfo/query",
        resetMaterial: '/api_proj/projPlanInfo/resetMaterial',//重置材料供应方
        getInfo: '/api_proj/projPlanInfo/getInfo',//查询进度计划基础信息
        submitProjPlanInfo: '/api_proj/projPlanInfo/submitProjPlanInfo',//查询进度计划基础信息
        submitResetProjPlanInfo: '/api_proj/projPlanInfo/submitResetProjPlanInfo',//查询进度计划基础信息
        getDetailById: '/api_proj/projPlanDetail/get',//执行时获得计划详情
        startTask: '/api_proj/projPlanInfo/start',//任务开工
        endTask: '/api_proj/projPlanInfo/end',//任务完工
        getProjectInfo: '/api_proj/projPlanInfo/getProjectInfo',//获取项目信息
        complete: '/api_proj/projPlanInfo/complete',//协议任务
        planComplete: '/api_proj/projPlanInfo/planComplete',//计划审批
        updateMandator: '/api_proj/projPlanDetail/updateMandator',//更新委托人
        submit: '/api_proj/projPlanDetail/submit',//申请更新大阶段动态计划时间
        judgeAuto: '/api_proj/projPlanDetail/checkRelation',//判断是否弹出维护自动开始/结束日期
        judgeRefresh: '/api_proj/projPlanDetail/checkIsSave',//保存前判断是否需要重新获取页面数据
        approvePackage: '/api_proj/projPlanDetail/completeStartCommand',//任务包审批(开工令)
        getByProjectId: '/api_proj/projPlanInfo/getPlanDetailByProjectId',//通过项目id查询计划详情
        getTaskPackage: '/api_proj/projPlanDetail/getTaskPackage',//查询安装令启动任务包详情
        approvePackageInstall: '/api_proj/projPlanDetail/completeInstallCommand',//任务包审批(安装令)
        judgeGuideTime: '/api_proj/projPlanInfo/judgeGuideTime',//任务包审批(安装令)
        checkExecutionDate:'/api_proj/projPlanInfo/executionDateFloat',
    },

    projPlanDetail: {
        complete: '/api_proj/projPlanDetail/complete',//审批，工程经理
        getBigNode: '/api_proj/projPlanDetail/getBigNode',//获取大节点
        completeGCZT: '/api_proj/projPlanDetail/completeGCZT',//审批，工程中台审批
        sendMessage:'/api_proj/projPlanDetail/sendAssessment',
    },

    projPlanStuffDetail: {
        get: '/api_proj/projPlanStuffDetail/get',//查询供应方维护数据
        save: '/api_proj/projPlanStuffDetail/save',//保存供应方维护数据
        saveAndSubmit: '/api_proj/projPlanStuffDetail/saveAndSubmit',//保存提交供应方维护数据
    },
    projPlanRemindTemplate: {
        query: '/api_proj/projPlanRemindTemplate/query',//查询
        add: '/api_proj/projPlanRemindTemplate/add',//查询
        get: '/api_proj/projPlanRemindTemplate/get',//查询
        edit: '/api_proj/projPlanRemindTemplate/edit',//修改
        delete: '/api_proj/projPlanRemindTemplate/delete',//修改
        newQuery: '/api_busi/bizNodeRemindTempAction/query',//查询列表
    },
    //收付款模板明细
    busiFinancePaymentTplDetail: {
        add: '/api_busi/bizFinancePaymentTplDetailAction/add',//新增
        getByTplId: '/api_busi/bizFinancePaymentTplDetailAction/getByTplId',//根据tplId查询
        del: '/api_busi/bizFinancePaymentTplDetailAction/delete',//删除收付款模板明细
    },
    //商家管理
    // supSupplierInfoAction:{
    //   queryPage:'/api_busi/supSupplierInfoAction/query',//分页查询
    //   add:'/api_busi/supSupplierInfoAction/add',//新增
    //   edit:'/api_busi/supSupplierInfoAction/edit',//修改
    //   del:'/api_busi/supSupplierInfoAction/delete',//删除
    //   getById:'/api_busi/supSupplierInfoAction/getById',//根据id查询
    //   // submit:'/api_busi/supSupplierInfoAction/submit',//提交审核
    //   start:'/api_busi/supSupplierInfoAction/start',//生效
    //   shut:'/api_busi/supSupplierInfoAction/shut',//失效
    //   getSupplierInfo:'/api_busi/supSupplierInfoAction/getSupplierInfo'//根据商家编码获取商家信息
    // },
    bizSpinOffRateAction: {
        queryPage: '/api_busi/bizSpinOffRate/query',//分页查询
        saveSpinOff: '/api_busi/bizSpinOffRate/add',//保存接口
        delete: '/api_busi/bizSpinOffRate/delete',//删除接口
        getById: '/api_busi/bizSpinOffRate/getById',//查询单个数据
        edit: '/api_busi/bizSpinOffRate/edit',//更新数据
        getSupplyList: '/api_busi/bizSupplyInfoAction/findSupplyByName',//查询供应商列表
        getShopList: '/api_busi/bizShopInfoAction/findShopByName',//查询店铺列表
        getSubject: '/api_busi/bizContractSubjectAction/getSubjectByContractType',//获取合同主体
    },
    bizSupplyInfoAction: {
        queryPage: '/api_busi/bizSupplyInfoAction/query',//分页查询
        queryForShop: '/api_busi/bizSupplyInfoAction/queryForShop',//分页查询
        add: '/api_busi/bizSupplyInfoAction/add',//新增
        saveAndSubmit: '/api_busi/bizSupplyInfoAction/saveAndSubmit',//新增
        update: '/api_busi/bizSupplyInfoAction/update',//更新
        updateAndSubmit: '/api_busi/bizSupplyInfoAction/updateAndSubmit',//更新
        get: '/api_busi/bizSupplyInfoAction/get',//获取
        getForRenew: '/api_busi/bizSupplyInfoAction/getForRenew',//获取
        delete: '/api_busi/bizSupplyInfoAction/delete',//删除
        submit: '/api_busi/bizSupplyInfoAction/submit',//提交
        complete: '/api_busi/bizSupplyInfoAction/complete',
        stop: '/api_busi/bizSupplyInfoAction/stop',//终止
        upTus: '/api_busi/bizSupplyInfoAction/upTu',
        restart: '/api_busi/bizSupplyInfoAction/restart',
        editEsign: '/api_busi/bizSupplyInfoAction/editEsign',
        updateSubject: '/api_busi/bizSupplyInfoAction/updateSubject',//更新主体
        reSign: '/api_busi/bizSupplyInfoAction/reSign',//重新发起
        startOtherEsignFlow: '/api_busi/bizSupplyInfoAction/startOtherEsignFlow',//发起其他主体
        toSupplyCheck: '/api_busi/bizSupplyInfoAction/toSupplyCheck',//发起其他主体
        findAllSign: '/api_busi/bizSupplyInfoAction/findAllSign',//根据供应商的id查找 首签和续签 返回格式为： 首签 2020-01-03 —— 2020-12-31
        findSignSchedule: '/api_busi/bizSupplyInfoAction/findSignSchedule',//查看签约进度
        addAgreement: '/api_busi/bizSupplementaryAgreementAction/add',//新增补充协议
        queryByRelevancyId: '/api_busi/bizSupplementaryAgreementAction/queryByRelevancyId',//查看补充协议
        deleteAgreement: '/api_busi/bizSupplementaryAgreementAction/delete',//删除补充协议
        findSignScheduleByESignFlowId: '/api_busi/bizSupplyInfoAction/findAllSignSchedule',//签署进度(通过eSignFlowId)
    },

    bizSupplementaryAgreementAction: {
        addAgreement: '/api_busi/bizSupplementaryAgreementAction/add',//新增补充协议
        queryByRelevancyId: '/api_busi/bizSupplementaryAgreementAction/queryByRelevancyId',//查看补充协议
        deleteAgreement: '/api_busi/bizSupplementaryAgreementAction/delete',//删除补充协议
        findSignScheduleByESignFlowId: '/api_busi/bizSupplyInfoAction/findAllSignSchedule',//签署进度(通过eSignFlowId)

        startAudit: '/api_busi/bizSupplementaryAgreementAction/startAudit',//开启审批流
        completeAudit: '/api_busi/bizSupplementaryAgreementAction/completeAudit',//审批
        getSupplyOrShop: '/api_busi/bizSupplementaryAgreementAction/getSupplyOrShop',//获取信息
        reSign: '/api_busi/bizSupplementaryAgreementAction/reSign',//重置e签宝审批流
        resend: '/api_busi/bizSupplementaryAgreementAction/resend',//重置供应商确认
    },

    bizSupplyEsignFlowAction: {
        flowList: '/api_busi/bizSupplyEsignFlowAction/flowList',//查看主体签约记录
        undoFlow: '/api_busi/bizSupplyEsignFlowAction/undoFlow',//查看主体签约记录
    },
    bizSupplyApplyAction: {
        queryPage: '/api_busi/bizSupplyApplyAction/query',
        get: '/api_busi/bizSupplyApplyAction/get',
        submit: '/api_busi/bizSupplyApplyAction/audit',
    },
    bizSupplySubjectAction: {
        queryPage: '/api_busi/bizSupplySubjectAction/query',
        add: '/api_busi/bizSupplySubjectAction/add',
        edit: '/api_busi/bizSupplySubjectAction/edit',
        get: '/api_busi/bizSupplySubjectAction/get',
    },
    bizSupplyInfoApplyAction: {
        queryPage: '/api_busi/bizSupplyApplyAction/query',//分页查询
        add: '/api_busi/bizSupplyApplyAction/add',//新增
        edit: '/api_busi/bizSupplyApplyAction/edit',//更新
        delete: '/api_busi/bizSupplyApplyAction/delete',//删除
        audit: '/api_busi/bizSupplyApplyAction/audit',
        complete: '/api_busi/bizSupplyApplyAction/complete',
        get: '/api_busi/bizSupplyApplyAction/get',//获取
        udpateOrgIdAndSupplyType: '/api_busi/bizSupplyApplyAction/udpateOrgIdAndSupplyType',//修改组织和供应商类型
    },
    bizSupplyInfoRenewAction: {
        queryPage: '/api_busi/bizSupplyInfoRenewAction/query',//分页查询
        get: '/api_busi/bizSupplyInfoRenewAction/get',//获取
        add: '/api_busi/bizSupplyInfoRenewAction/add',//新增
        update: '/api_busi/bizSupplyInfoRenewAction/update',//更新
        submit: '/api_busi/bizSupplyInfoRenewAction/submit',//提交
        delete: '/api_busi/bizSupplyInfoRenewAction/delete',//删除
        saveAndSubmit: '/api_busi/bizSupplyInfoRenewAction/saveAndSubmit',//新增
        updateAndSubmit: '/api_busi/bizSupplyInfoRenewAction/updateAndSubmit',//更新
        updateSubject: '/api_busi/bizSupplyInfoRenewAction/updateSubject',//更新主体
        reSign: '/api_busi/bizSupplyInfoRenewAction/reSign',//重新发起
        startOtherEsignFlow: '/api_busi/bizSupplyInfoRenewAction/startOtherEsignFlow',//发起其他主体
        toSupplyCheck: '/api_busi/bizSupplyInfoRenewAction/toSupplyCheck',//发送确认
        findSignSchedule: '/api_busi/bizSupplyInfoRenewAction/findSignSchedule',//签署进度
    },
    ecSellerInfoAction: {
        queryPage: '/api_busi/bizEcSellerAction/query',//分页查询
        queryBrand: '/api_busi/bizEcSellerAction/queryBrand',//商家品牌
        queryByOrg: '/api_busi/bizEcSellerAction/queryByOrg',//通过服务单组织查询商家
        queryByOrgAndScopeCooperation: '/api_busi/bizEcSellerAction/queryByOrgAndScopeCooperation',//通过服务单组织查询商家（商家组合和合作范围）
        add: '/api_busi/bizEcSellerAction/add',//新增
        edit: '/api_busi/bizEcSellerAction/edit',//修改
        del: '/api_busi/bizEcSellerAction/delete',//删除
        getById: '/api_busi/bizEcSellerAction/getById',//根据id查询
        // submit:'/api_busi/bizEcSellerAction/submit',//提交审核
        // start:'/api_busi/bizEcSellerAction/start',//生效
        // shut:'/api_busi/bizEcSellerAction/shut',//失效
        getSupplierInfo: '/api_busi/bizEcSellerAction/getEcSellerInfo',//根据商家编码获取商家信息
        getSellerByName: '/api_busi/bizEcSellerAction/getSellerByName',
        upTus: '/api_busi/bizEcSellerAction/upTu' //上传图章
    },
    ecMemberInfo: {
        queryPage: '/api_busi/bizEcMember/query',//分页查询
    },
    //店铺管理
    ecSellerShopAction: {
        // getEcSellerShopBySupplier:'/api_busi/ecSellerShopAction/getEcSellerShopBySupplier',
        // getAllEcSellerShopDto:'/api_busi/ecSellerShopAction/getEcSellerShopBySupplier',
        // queryPage: '/api_busi/bizShopAction/query', // 店铺的分页
        getById: '/api_busi/bizEcShopAction/edit',
        getEcSellerShopBySupplier: '/api_busi/bizEcShopAction/getEcSellerShopBySupplier',
        getAllEcSellerShopDto: '/api_busi/bizEcShopAction/getEcSellerShopBySupplier',
        queryPage: '/api_busi/bizEcShopAction/query', // 店铺的分页
        upTus: '/api_busi/bizEcShopAction/upTu', // 上传图章
    },
    // 拆改建供应商管理
    bizReformSupplyAction: {
        queryPage: '/api_busi/bizReformSupplyAction/query',
        add: '/api_busi/bizReformSupplyAction/add',
        update: '/api_busi/bizReformSupplyAction/update',
        queryOne: '/api_busi/bizReformSupplyAction/queryOne',
        delete: '/api_busi/bizReformSupplyAction/delete',
    },
    //供应商比率
    supplyRatioAction: {
        getById: '/api_busi/bizSupplyRatioAction/getById',
        getEcSellerShopBySupplier: '/api_busi/bizEcShopAction/getEcSellerShopBySupplier',
        getAllEcSellerShopDto: '/api_busi/bizEcShopAction/getEcSellerShopBySupplier',
        queryPage: '/api_busi/bizSupplyRatioAction/query', // 分页
        export: '/api_busi/bizSupplyRatioAction/queryExport', // 导出
        saveOrUpdate: '/api_busi/bizSupplyRatioAction/saveOrUpdate',
        del: '/api_busi/bizSupplyRatioAction/del',
        getBySupplyIdAndShopId: '/api_busi/bizSupplyRatioAction/getBySupplyIdAndShopId',
    },

    // ecSellerAction:{
    //   getSellerByName:'/api_busi/ecSellerAction/getSellerByName'
    // },
    //商家开票信息维护
    supSupplierBillInfoAction: {
        queryPage: '/api_busi/supSupplierBillInfoAction/query',//分页查询
        getById: '/api_busi/supSupplierBillInfoAction/getById',//根据Id查询
        add: '/api_busi/supSupplierBillInfoAction/add',//新增
        edit: '/api_busi/supSupplierBillInfoAction/edit',//修改
        del: '/api_busi/supSupplierBillInfoAction/delete',//删除
        start: '/api_busi/supSupplierBillInfoAction/start',//生效
        shut: '/api_busi/supSupplierBillInfoAction/shut',//失效
    },
    //商家合同信息维护
    supSupplierContractAction: {
        queryPage: '/api_busi/supSupplierContractAction/query',//分页查询
        getById: '/api_busi/supSupplierContractAction/getById',//根据Id查询
        add: '/api_busi/supSupplierContractAction/add',//新增
        edit: '/api_busi/supSupplierContractAction/edit',//修改
        start: '/api_busi/supSupplierContractAction/start',//生效
        shut: '/api_busi/supSupplierContractAction/shut',//失效
    },
    doExcel: {
        importExcel: '/api/doExcel/import',//导入excel
    },
    busiCustomerOrderTrack: {
        query: '/api_cms/busiCustomerOrderTrack/query',//查询订单的跟踪信息
        addData: '/api_cms/busiCustomerOrderTrack/add',//添加跟进记录
        update: '/api_cms/busiCustomerOrderTrack/updateOrderTrack',//修改跟进记录
        edit: '/api_cms/busiCustomerOrderTrack/edit',//查询单个跟踪信息
        delete: '/api_cms/busiCustomerOrderTrack/deleteIds',//删除跟踪信息
        deleteById: '/api_cms/busiCustomerOrderTrack/deleteById',//删除跟踪信息
        queryTrack: '/api_cms/busiCustomerOrderTrack/queryTrack',//根据orderId获取所有track信息

    },
    busiCustomerOrderConflict: {
        addData: '/api_cms/busiCustomer/order/conflict/',//创建撞单申请
        query: '/api_cms/busiCustomer/order/conflict/query',//查询撞单申请
        processed: '/api_cms/busiCustomer/order/conflict/processed',//处理撞单申请

    },
    messageTemplate: {
        query: '/api/messageTemplate/query',//查询短信模板
        edit: '/api/messageTemplate/edit',//修改短信模板
    },
    fwRegion: {
        searchChild: '/api/region/child',//根据id查询下级行政区域信息
        searchParents: '/api/region/parents',//根据id查询所有上级行政区域信息
        searchRegion: '/api/region',//根据id查询单个行政区域信息
        getAll: '/api/region/getRegionBySiteId', // 获取所有行政区域信息
        fuzzyFindByRegionName: '/api/region/fuzzy',//模糊查询行政区域信息
        findAll: '/api/region/total',
    },

    modelManage: {
        modelList: "/api_cms/modelManage/model/list",
        modelSave: "/api_cms/modelManage/model/save"
        //   edit: "/api_cms/busiContentHouse/edit",
        //   delete: "/api_cms/busiContentHouse/delete",
    },
    busiContentCarousel: {
        query: '/api_cms/busiContentCarousel/query',// 分页获取首页伦拨片数据
        add: '/api_cms/busiContentCarousel/add', // 新增轮播内容
        edit: '/api_cms/busiContentCarousel/edit', // 修改轮播内容
        delete: '/api_cms/busiContentCarousel/delete', // 删除轮播内容
        carouselStart: '/api_cms/busiContentCarousel/startCarousel', // 启用轮播内容
        carouselStop: '/api_cms/busiContentCarousel/stopCarousel', // 停用轮播内容
        queryByName: '/api_cms/busiContentCarousel/queryByName',//根据轮播分类和轮播内容模糊匹配
        getByCodeAndType: '/api_cms/busiContentCarousel/getByOrgIdAndType',// 根据组织和轮播终端获取数量
    },

    //按服务单 品牌 分类 汇总报价单
    vBizOrderOfferSumAction: {
        getList: "/api_busi/vBizOrderOfferSumAction/getList"
    },
    busiPraiseComment: {
        query: '/api_cms/busiPraiseComment/query',//分页获取数据
        startCommont: '/api_cms/busiPraiseComment/startCommont', // 审核通过
        stopCommont: '/api_cms/busiPraiseComment/stopCommont', // 审核驳回
        findBusinessIdById: '/api_cms/busiPraiseComment/findBusinessIdById',  // 根据id获取业务id
        deleteByIds: '/api_cms/busiPraiseComment/deleteByIds',//批量删除
    },
    vBusiCommentPraise: {
        queryData: '/api_cms/vBusiCommentPraise/query', // 分页获取数据
        edit: '/api_cms/vBusiCommentPraise/edit', // 针对id获取数据
    },
    //帮助信息管理
    fwHelp: {
        queryPage: '/api/fwHelp/query',//分页查询
        add: '/api/fwHelp/add',//新增
        submit: '/api/fwHelp/submit',//提交
        del: '/api/fwHelp/delete',//删除
        edit: '/api/fwHelp/edit',//修改
        getById: '/api/fwHelp/getById',//根据id查询
        getByCode: '/api/fwHelp/getByCode',//根据code查询
        getByName: '/api/fwHelp/getByName',//根据name查询
        getNewBySourceId: '/api/fwHelp/getNewBySourceId',//通过菜单id获取最新的帮助
        getBySourceId: '/api/fwHelp/getBySourceId',//通过菜单id获取启用的帮助
        start: '/api/fwHelp/startHelp',//启用
        stop: '/api/fwHelp/stopHelp',//停用
    },
    //施工计划模板
    projPlanTplNew: {
        queryPage: '/api_proj/projPlantplNew/query',//分页查询
        dele: '/api_proj/projPlantplNew/delete',//删除
        shut: '/api_proj/projPlantplNew/shutById',//停用
        start: '/api_proj/projPlantplNew/startById',//启用
        add: '/api_proj/projPlantplNew/add',//新增
        getById: '/api_proj/projPlantplNew/getById',//根据Id获取模板
        edit: '/api_proj/projPlantplNew/edit',//修改
        getList: '/api_proj/projPlantplNew/getList',//获取已启用的模板
    },
    projOutsourceCivil: {
        add: '/api_proj/projOutsourceCivil/add',//新增
        update: '/api_proj/projOutsourceCivil/edit',//更新
        delete: '/api_proj/projOutsourceCivil/delete',//删除
        query: '/api_proj/projOutsourceCivil/query',//查询
        getById: '/api_proj/projOutsourceCivil/edit',//根据id查询
        audit: '/api_proj/projOutsourceCivil/audit',//发起审核
        completeAudit: '/api_proj/projOutsourceCivil/completeAudit',//完成节点
        resetCompleteAudit: '/api_proj/projOutsourceCivil/resetCompleteAudit',//重置完成节点
        findByPid: '/api_proj/projOutsourceCivil/findByPid',//通过项目id查询是否存在
        exportExcel: '/api_proj/projOutsourceCivil/exportExcel',//外包拆改建列表增加“导出”功能
        reset: '/api_proj/projOutsourceCivil/reset', //重置
    },
    projPlanTplDetailNew: {
        list: '/api_proj/projPlantplDetailNew/list',//根据tplId查询施工项
        del: '/api_proj/projPlantplDetailNew/delete',
        saveOrUpd: '/api_proj/projPlantplDetailNew/addOrUpdate',
    },
    //施工计划模板
    projPlanTpl: {
        queryPage: '/api_proj/projPlantpl/query',//分页查询
        dele: '/api_proj/projPlantpl/delete',//删除
        shut: '/api_proj/projPlantpl/shutById',//停用
        start: '/api_proj/projPlantpl/startById',//启用
        add: '/api_proj/projPlantpl/add',//新增
        getById: '/api_proj/projPlantpl/getById',//根据Id获取模板
        edit: '/api_proj/projPlantpl/edit',//修改
        getList: '/api_proj/projPlantpl/getList',//获取已启用的模板
    },
    //施工项
    projPlanTplDetail: {
        getByTplId: '/api_proj/projPlantplDetail/getByTplId',//根据tplId查询施工项
        getByParentId: '/api_proj/projPlantplDetail/getByParentId',//根据parentId查询施工项
        getById: '/api_proj/projPlantplDetail/getById',//根据id查询
        add: '/api_proj/projPlantplDetail/add',//新增施工项
        del: '/api_proj/projPlantplDetail/delete',//删除
        edit: '/api_proj/projPlantplDetail/edit',//修改
    },
    //材料计划模板
    projMaterialPlanTplDetail: {
        getBygetByConstructionPlanDetailId: '/api_proj/projMaterialPlanTplDetail/getByConstructionPlanDetailId',//根据getByConstructionPlanDetailId查询材料
        submit: '/api_proj/projMaterialPlanTplDetail/submit',
        del: '/api_proj/projMaterialPlanTplDetail/delete'//删除
    },
    //辅材验收配置
    auxiliaryMaterialCheck:{
        queryPage: '/api_proj/auxiliaryMaterialCheckAction/query',//分页查询
        add: '/api_proj/auxiliaryMaterialCheckAction/add',//新增
        update: '/api_proj/auxiliaryMaterialCheckAction/update',//修改
        delete: '/api_proj/auxiliaryMaterialCheckAction/delete',//删除
        queryOne: '/api_proj/auxiliaryMaterialCheckAction/queryOne',//根据id查找
        branchAllocation: '/api_proj/auxiliaryMaterialCheckAction/branchAllocation',//修改分公司配置
    },
    // 人工费比例配置模板
    projLabourConfig: {
        queryPage: '/api_proj/projLabourConfigAction/query',//分页查询
        queryOne: '/api_proj/projLabourConfigAction/queryOne',//根据id查询
        add: '/api_proj/projLabourConfigAction/add',// 新增
        update: '/api_proj/projLabourConfigAction/update',// 修改
        updateStatus: '/api_proj/projLabourConfigAction/updateStatus',//启用/禁用
    },
    //预核算计划模板
    projFnanceTpl: {
        queryPage: '/api_proj/projFinanceBudgettpl/query',//分页查询
        add: '/api_proj/projFinanceBudgettpl/add',//新增模板
        edit: '/api_proj/projFinanceBudgettpl/edit',//修改
        dele: '/api_proj/projFinanceBudgettpl/delete',//删除
        start: '/api_proj/projFinanceBudgettpl/startById',//启用
        shut: '/api_proj/projFinanceBudgettpl/shutById',//停用
        getById: '/api_proj/projFinanceBudgettpl/getById',//根据Id查询
        getByTplId: '/api_proj/projFinanceBudgettplDetail/getByTplId',//根据tpl获取
        saveDetail: '/api_proj/projFinanceBudgettplDetail/saveOrUpdate',//保存明细
        del: '/api_proj/projFinanceBudgettplDetail/delete',//删除明细
        getAll: '/api_proj/projFinanceBudgettpl/getAll'
    },
    //基装变更模板
    projDecorationTpl: {
        queryPage: '/api_proj/projBaseDecorationChangetpl/query',//分页查询
        add: '/api_proj/projBaseDecorationChangetpl/add',//新增
        edit: '/api_proj/projBaseDecorationChangetpl/edit',//修改
        dele: '/api_proj/projBaseDecorationChangetpl/delete',//删除
        getById: '/api_proj/projBaseDecorationChangetpl/getById',//根据Id查询
        start: '/api_proj/projBaseDecorationChangetpl/startById',//启用
        shut: '/api_proj/projBaseDecorationChangetpl/shutById',//停用
        getByTplId: '/api_proj/projBaseDecorationChangetplDetail/getByTplId',//根据tpl获取
        saveDetail: '/api_proj/projBaseDecorationChangetplDetail/saveOrUpdate',//保存明细
        del: '/api_proj/projBaseDecorationChangetplDetail/delete'//删除明细
    },

    // 项目考核模板
    projAssessmentTpl: {
        queryPage: '/api_proj/projAssessmentTpl/query',//分页查询
        add: '/api_proj/projAssessmentTpl/add',//新增
        edit: '/api_proj/projAssessmentTpl/edit',//修改
        getById: '/api_proj/projAssessmentTpl/getById',//根据Id查询
        dele: '/api_proj/projAssessmentTpl/delete',//删除
        start: '/api_proj/projAssessmentTpl/startById',//启用
        shut: '/api_proj/projAssessmentTpl/shutById',//停用
        getmodels: '/api_proj/projAssessmentDetailTpl/getByTplId',//获取模板
        saveOupdate: '/api_proj/projAssessmentDetailTpl/add',//新增或修改模板
        getTemplatesByPid: '/api_proj/projAssessmentTpl/getProjAssessmentTemplates',//新增或修改模板
        // getList: '/api_proj/projManagerPaymentTpl/getList',//获取所有启用的模板
        queryAllByTplIdAndType: '/api_proj/projAssessmentTemplateVariableAction/queryAllByTplIdAndType',//成本核算获取所有变量
        saveVariable:'/api_proj/projAssessmentTemplateVariableAction/saveOrUpdate'
    },

    //项目经理收入模板
    projManagerPaymentTpl: {
        queryPage: '/api_proj/projManagerPaymentTpl/query',//分页查询
        add: '/api_proj/projManagerPaymentTpl/add',//新增
        edit: '/api_proj/projManagerPaymentTpl/edit',//修改
        getById: '/api_proj/projManagerPaymentTpl/getById',//根据Id查询
        dele: '/api_proj/projManagerPaymentTpl/delete',//删除
        start: '/api_proj/projManagerPaymentTpl/startById',//启用
        shut: '/api_proj/projManagerPaymentTpl/shutById',//停用
        getProjManagerPaymentTpls: '/api_proj/projManagerPaymentTpl/getProjManagerPaymentTpls',//获取启用项目经理收入模板信息
        getList: '/api_proj/projManagerPaymentTpl/getList',//获取所有启用的模板
        getProjQA: '/api_proj/projManagerPaymentTpl/getProjQA',//质保金
    },

    configComputeVariable: {
        listAll: '/api_busi/configComputeVariable/listAll',
        queryPage: '/api_busi/configComputeVariable/query',
        updateStatus: '/api_busi/configComputeVariable/updateStatus',
        getById: '/api_busi/configComputeVariable/getById',
        add: '/api_busi/configComputeVariable/add',
        edit: '/api_busi/configComputeVariable/edit',
        getAllStart: '/api_busi/configComputeVariable/getAllStart',
        getAllStartByType: '/api_busi/configComputeVariable/getAllStartByType',
        checkVariable: '/api_busi/configComputeVariable/findAllByComputeVariableList'
    },

    //项目经理收入字段
    projManagerPaymentTplDetail: {
        add: '/api_proj/projManagerPaymentTplDetail/add',//根据tplId查询
        getByTplId: '/api_proj/projManagerPaymentTplDetail/getByTplId',//根据tplId查询
        getByTplId1: '/api_proj/projManagerPaymentTplDetail/getByTplId1',//根据tplId查询（get）
        getComputeByProId: '/api_proj/projManagerPaymentTplDetail/getComputeByProId',
        saveDetail: '/api_proj/projManagerPaymentTplDetail/saveDetail',//保存字段
        del: '/api_proj/projManagerPaymentTplDetail/delete',//删除明细
    },
    //变更台账
    vChangeLedger: {
        query: '/api_proj/vChangeLedgerAction/query',
        export: '/api_proj/vChangeLedgerAction/export',
    },
    projProjectAuxiliaryReport: {
        query: '/api_proj/projProjectAuxiliaryReport/query',
    },
    vProjOutTreasuryDetail: {
        query: '/api_proj/vProjOutTreasuryDetailAction/query',
        exportExcel: '/api_proj/vProjOutTreasuryDetailAction/exportExcel',
    },
    vProjectQualityCheckAction: {
        query: '/api_proj/vProjectQualityCheckAction/query'
    },
    vProjData: {
        query: '/api_proj/vProjDataAction/query'
    },
    vHouseFinanceCount: {
        query: '/api_proj/vHouseFinanceCountAction/query',
        queryDataWithDate: '/api_proj/vHouseFinanceCountAction/queryDataWithDate',
    },
    vHouseFinanceReceive: {
        query: '/api_proj/vHouseFinanceReceiveAction/queryList',
        queryDataWithDate: '/api_proj/vHouseFinanceReceiveAction/queryDataWithDate',
    },

    directory: {
        query: '/api_file/cmdFileCatalog/query',
        add: '/api_file/cmdFileCatalog/add',
        edit: '/api_file/cmdFileCatalog/edit',
        delete: '/api_file/cmdFileCatalog/delete',
        allCatalog: '/api_file/cmdFileCatalog/getAllUserCatalog',//?path=''
        getByParent: '/api_file/cmdFileCatalog/getCategoryByPid',
    },
    files: {
        query: '/api_file/cmdFileManager/query',
        delete: '/api_file/cmdFileManager/delete',
        getNotExistBusiIds: '/api_file/cmdFileManager/getNotExistBusiIds',
        getAllByIds: '/api_file/cmdFileManager/getAllByIds',
        getUrls: '/api_file/cmdFileManager/getUrls',
        download: '/api_file/download.do',// ?id=
        upload: '/api_file/upload.do?actionMethod=process', // post,
        preview: '/api_file/preview.do', // get 预览,
        //  getByParent:'/api_file/cmdFileManager/getCategoryByPid',
    },
    video: {
        getAccessToken: 'https://openapi.iqiyi.com/api/iqiyi/authorize?client_id=9f00a5e7f9944f60be1b0de55c2c4769&client_secret=6afc49a189ce17325a77e9d5d38541b3',
        query: '/api_file/video/query',
        getFileId: 'https://upload.iqiyi.com/openupload',
        saveFileId: '/api_file/cmdFileVideoManager',
        transferFileToByte: '/api_file/cmdFileVideoManager/instream',
        edit: '/api_file/video/edit',
        delete: '/api_file/cmdFileVideoManager',
        getVideoUrl: '/api_file/cmdFileVideoManager',
        setMetaInfo: 'https://openapi.iqiyi.com/api/file/info',
        saveFileInfo: '/api_file/cmdFileVideoManager',
        uploadFinish: 'https://upload.iqiyi.com/uploadfinish',
    },
    cmdFileVod: {
        video: '/api_file/cmdFileVodManager/upload/video',
        cover: '/api_file/cmdFileVodManager/upload/cover',
        query: '/api_file/cmdFileVodManager/query',
        edit: '/api_file/cmdFileVodManager/edit',
        saveFileInfo: '/api_file/cmdFileVodManager',
    },
    bizSettingTargetWeek: {
        save: '/api_busi/bizSettingTargetWeek/save',
        list: '/api_busi/bizSettingTargetWeek/list',
        nowDate: '/api_busi/bizSettingTargetWeek/nowDate',
    },
    bizSettingTargetMonth: {
        save: '/api_busi/bizSettingTargetMonth/save',
        list: '/api_busi/bizSettingTargetMonth/list',
        nowDate: '/api_busi/bizSettingTargetMonth/nowDate',
    },
    bizSettingTargetYear: {
        getAllYear: '/api_busi/bizSettingTargetYear/getAllYear',
        findCurrentYear: '/api_busi/bizSettingTargetYear/findCurrentYear'
    },
    bizSettingValue: {
        getAllCompany: '/api_busi/bizSettingValue/getAllCompany',
        queryPage: '/api_busi/bizSettingValue/queryColor',
        //queryPage: '/api_busi/bizSettingValue/query',
        commit: '/api_busi/bizSettingValue/commit',
        delete: '/api_busi/bizSettingValue/delete',
        getTotalById: '/api_busi/bizSettingValue/getTotalById',
        getHistoryTotalById: '/api_busi/bizSettingValue/getHistoryTotalById',//获取历史版本数据
        getCompByOrgIdYear: '/api_busi/bizSettingValue/getCompByOrgIdYear',
        getVersionList: '/api_busi/bizSettingValue/getVersionNum',
        getTotalByOrgIdAndYear: '/api_busi/bizSettingValue/getTotalByOrgIdAndYear',
    },
    bizSettingValueDetail: {
        getDept: '/api_busi/bizSettingValueDetail/getDept',
        getHistoryDept: '/api_busi/bizSettingValueDetail/getHistoryDept',
        add: '/api_busi/bizSettingValueDetail/add',
        edit: '/api_busi/bizSettingValueDetail/getEdit',
        getQuarterData: '/api_busi/bizSettingValueDetail/getQuarterData',
        editQuarterData: '/api_busi/bizSettingValueDetail/editQuarterData',
    },
    onlineSettingValue: {
        queryPage: '/api_cms/busiSettingValue/queryPage',
        getPerformanceData: '/api_cms/busiSettingValue/getPerformanceStandards',
        delete: '/api_cms/busiSettingValue/delete',
        commit: '/api_cms/busiSettingValue/commit',
        getVersionList: '/api_cms/busiSettingValue/getVersionNum'
    },
    onlineSettingValueDetail: {
        getDept: '/api_cms/busiSettingValue/getTotalAndDetailById',
        getHistoryDept: '/api_cms/busiSettingValue/getHistoryListById',
        add: '/api_cms/busiSettingValueDetail/add',
        edit: '/api_cms/busiSettingValue/edit',
        getQuarterData: '/api_cms/busiSettingValueDetail/getQuarterData',
    },
    productionPlan: {
        query: '/api_busi/bizProductionPlanAction/query',// 走创建人的
        queryAll: '/api_busi/bizProductionPlanAction/queryAll',// 走组织权限的
        add: '/api_busi/bizProductionPlanAction/add',
        check: "/api_busi/bizProductionPlanAction/checkDate",
        audit: "/api_busi/bizProductionPlanAction/audit",//提交计划进行审核
        reviewSummary: "/api_busi/bizProductionPlanAction/reviewSummary",//审批流页面根据中间表id 查询数据
        complete: "/api_busi/bizProductionPlanAction/complete",//审批流页面提交
        getplan: "/api_busi/bizProductionPlanAction/getById",
        getplanDetail: '/api_busi/bizProductionPlanAction/getPlanById',
        changeState: '/api_busi/bizProductionPlanAction/edit',
        resetAll: '/api_busi/bizProductionPlanAction/reset',
        update: '/api_busi/bizProductionPlanAction/update',
        isCreateCustomer: '/api_busi/bizProductionPlanAction/createCustomer',
        getPlanReport: '/api_busi/bizProductionPlanAction/getPlanReport',
        getPlanReportByCompany: '/api_busi/bizProductionPlanAction/getPlanReportByCompany',
        bizBoardActionGroup: '/api_busi/bizBoardAction/group',
        getPlanListByYear: '/api_busi/bizProductionPlanAction/getPlanListByYear',
        getPlanReportDetail: '/api_busi/bizProductionPlanAction/getPlanReportDetail',
        addMonthPlan: '/api_busi/bizProductionPlanAction/createUser',//为选中的用户添加当月计划
    },
    productionPlanDetail: {
        findOrderByIds: '/api_busi/bizProductionPlanDetailAction/findOrderByIds', // 根据服务订单id查找数据，并组装成计划需要的结构
    },
    //网销
    marketProductionPlan: {
        query: '/api_cms/busiProductionPlanAction/query',// 走创建人的
        queryAll: '/api_cms/busiProductionPlanAction/queryAll',// 走组织权限的
        add: '/api_cms/bizProductionPlanAction/add',
        check: "/api_cms/busiProductionPlanAction/checkDate",
        getplan: "/api_cms/busiProductionPlanAction/getById",
        getplanDetail: '/api_cms/busiProductionPlanAction/getById',
        changeState: '/api_cms/busiProductionPlanAction/edit',
        resetAll: '/api_cms/busiProductionPlanAction/reset',
        update: '/api_cms/busiProductionPlanAction/update',
        isCreateCustomer: '/api_cms/busiProductionPlanAction/createCustomer',
        getPlanReport: '/api_cms/busiProductionPlanAction/getPlanReport',
        getPlanListByYear: '/api_cms/busiProductionPlanAction/getPlanListByYear',
        getPlanReportDetail: '/api_cms/busiProductionPlanAction/getPlanReportDetail',
        getDetailByStage: '/api_cms/busiProductionPlanDetailAction/getDetailByStage',
        addMonthPlan: '/api_cms/busiProductionPlanAction/createUser',//为选中的用户添加当月计划
        saveDistributionPlan:'/api_cms/busiProductionPlanAction/saveDistributionPlan',
        getDistributionPlan:'/api_cms/busiProductionPlanAction/getDistributionPlan'
    },
    /**********************************1、busi end***************************************************/

    /**********************************2、base start***************************************************/
    template: {
        queryPage: "/api_cms/baseTemplate/query",
        save_dir: "/api_cms/baseTemplate/save_dir",
    },
    dataEntity: {
        add: "/api/fwSourceEntity/add",
        queryPage: "/api/fwSourceEntity/query",
        edit: "/api/fwSourceEntity/edit",
        delete: "/api/fwSourceEntity/delete",
        getById: "/api/fwSourceEntity/getById",
        select: "/api/fwSourceEntity/public/select"
    },
    fwApplyScope: {
        query: "/api/fwApplyScope/query",
        add: "/api/fwApplyScope/add",
        edit: "/api/fwApplyScope/edit",
        getById: "/api/fwApplyScope/getById",
        delete: "/api/fwApplyScope/delete"
    },
    dataSet: {
        add: "/api/fwBusinessMap/add",
        queryPage: "/api/fwBusinessMap/query",
        edit: "/api/fwBusinessMap/edit",
        delete: "/api/fwBusinessMap/delete",
        getById: "/api/fwBusinessMap/getById"
    },
    categoryList: {
        add: "/api/category/add",
        queryPage: "/api/category/query",
        edit: "/api/category/edit",
        delete: "/api/category/delete",
        getParentCategoryName: "/api/category/getParentCategoryByParentKind",
        detail: '/api/category/getCategoryDetail',//通过kindName获取，有子字典返回子字典，不然返回子项
    },
    propertyList: {
        add: "/api/property/saveFwProperty",
        queryPage: "/api/property/query",
        edit: "/api/property/edit",
        delete: "/api/property/delete",
        getFwPropertyByCategoryId: "/api/property/getFwPropertyByCategoryId",
        getCategoryKeyByProperty: "/api/property/getCategoryKeyByProperty",
        getCategoryKeyByPropertyWithoutName: "/api/property/getCategoryKeyByPropertyWithoutName"
    },
    configList: {
        queryPage: "/api/config/query",
        edit: "/api/config/edit",
        delete: "/api/config/delete",
        add: "/api/config/add",
        queryConfig: "/api/config/queryConfig",
        checkKeyAndOrgId: "/api/config/checkKeyAndOrgId"
    },
    ViewFirstPageRecommend: {
        queryPage: "/api_cms/homePageRecommend/query",
        edit: "/api_cms/homePageRecommend/edit",
        delete: "/api_cms/homePageRecommend/delete",
        add: "/api_cms/homePageRecommend/add",
        disEnableRecommend: "/api_cms/homePageRecommend/disEnableRecommend",
        setSort: "/api_cms/homePageRecommend/setSort"
    },
    financeMaterialPaymentApply: { // 材料付款申请单
        query: '/api_busi/financeMaterialPaymentApply/query',
        addNewData: '/api_busi/financeMaterialPaymentApply/addNewData',
        delete: '/api_busi/financeMaterialPaymentApply/delete',
        deletePayment: '/api_busi/financeMaterialPaymentApply/deletePayment',
    },
    materialPaymentOrder: { // 星侠打款单
        query: '/api_busi/bizMaterialPaymentOrder/query',
        edit: '/api_busi/bizMaterialPaymentOrder//edit',
        unUse: '/api_busi/bizMaterialPaymentOrder/unUse',
        audit: '/api_busi/bizMaterialPaymentOrder/audit',
        doComplete: '/api_busi/bizMaterialPaymentOrder/complete',
        deletePayment: '/api_busi/bizMaterialPaymentOrder/delete',
        getById: '/api_busi/bizMaterialPaymentOrder/getById',
    },
    // 材料付款单收款账号管理
    bizFinancePaymentReceiptAccount: {
        queryPage: '/api_busi/bizFinancePaymentReceiptAccountAction/query',
        add: '/api_busi/bizFinancePaymentReceiptAccountAction/add',
        delete: '/api_busi/bizFinancePaymentReceiptAccountAction/delete',
        update: '/api_busi/bizFinancePaymentReceiptAccountAction/update',
        queryOne: '/api_busi/bizFinancePaymentReceiptAccountAction/queryOne',
    },
    fwAccount: {
        getUserLikeName: '/api/fwAccount/getUserLikeName',//根据用户名模糊检索
        checkIsSale: "/api/fwAccount/checkIsSale",// 检测当前用户是否有非商家角色
        getSaleLikeName: '/api/fwAccount/getSaleLikeName',//根据销售名模糊搜索
        getAll: '/api/fwAccount/getSaleLikeName',//查找所有分总
        binding: '/api/fwAccount/binding',//绑定TQ号
        unbinding: '/api/fwAccount/unbinding',//解除绑定
        findById: '/api/fwAccount/findById',
        getSupplyId: '/api/fwAccount/getSupplyId',
        getRole: '/api/fwAccount/getRole',
        getAdress: '/api/fwAccount/getAdress',
        getFwAccountSelfAndParent: '/api/fwAccount/getFwAccountSelfAndParent',
        findByOrgIdDataPage: '/api/fwAccount/findByOrgIdDataPage',
        getAccountBySupplyId: '/api/fwAccount/getAccountBySupplyId',
        getAccountByShopId: '/api/fwAccount/getAccountByShopId',
        recoverDefaultPwd: '/api/fwAccount/recoverDefaultPwd',
        forceLoginOut: '/api/fwAccount/forceLoginOut',
        findFwAccountDtoDataPage: '/api/fwAccount/findFwAccountDtoDataPage',
        getFwOrgDtoListByIdAndOrgId: '/api/fwAccount/getFwOrgDtoListByIdAndOrgId',
        getProjectManList: '/api/fwAccount/getProjectManList',
        getLevel3ByCurrentUser: '/api/fwAccount/getLevel3ByCurrentUser',
    },
    fwAccountToken: {
        query: '/api/fwAccountToken/query',//分页查询用户登录信息
        forceLoginOut: '/api/fwAccountToken/forceLoginOut',//根据ids删除用户登录信息并踢下线
    },
    fwAccountAuthLog: {
        query: '/api/fwAccountAuthLog/query',//分页查询权限操作日志
    },
    VFwAccountAuthorization: {
        query: '/api/VFwAccountAuthorizationAction/query',//分页查询
        export: '/api/VFwAccountAuthorizationAction/export',//分页查询
    },
    fwAppPhotoConfig: {
        query: '/api/fwAppPhotoConfig/query',//分页app弹窗图片配置信息
        add: '/api/fwAppPhotoConfig/add',
        delete: '/api/fwAppPhotoConfig/delete',
        update: '/api/fwAppPhotoConfig/edit',
        edit: '/api/fwAppPhotoConfig/edit',// 根据id获取单条数据的接口
    },
    fwInstrumentPanel: {
        getTree: '/api/fwInstrumentPanel/tree',
        saveOrUpdate: '/api/fwInstrumentPanel/update',
        defaultSetting: '/api/fwInstrumentPanel/defaultSetting'
    },
    busiTalkCloud: {
        fuzzy: '/api_talk/busiTalkCloud/fuzzy',
    },
    u8Log: {
        query: '/api_proj/bizU8Action/query',
        getU8LogById: '/api_proj/bizU8Action/edit',
    },
    fwAccountList: {
        queryPage: "/api/fwAccount/query",
        edit: "/api/fwAccount/edit",
        delete: "/api/fwAccount/delete",
        saveAccount: "/api/fwAccount/add", // 保存账户信息
        updateaccount: "/api/fwAccount/update", // 修改账户信息
        updateAccountSensitive: "/api/fwAccount/updateSensitive", // 批量修改账户中的敏感信息权限
        updateOrgs: "/api/fwAccount/updateOrgs", // 修改账户信息
        startAccount: "/api/fwAccount/startAccount", // 启用账户
        stopAccount: "/api/fwAccount/stopAccount", // 停用账户
        clearAccount: "/api/fwAccount/clearAccount", // 清除账户角色，视野信息
        restAccount: "/api/fwAccount/restAccount", // 重置密码
        alterAccount: "/api/fwAccount/alterAccount", // 重置密码
        alterAccountAdmin: "/api/fwAccount/alterAccountAdmin", // 重置密码
        getDoRoleToAssign: "/api/fwAccount/doSaveAssign", //保存账户的角色信息
        getAccount: "/api/fwAccount/getAccount",
        bindCustomer: "/api/fwAccount/bindCustomer", // 绑定会员信息

        queryByRoleId: "/api/fwAccount/queryByRoleId",//通过角色id获取集合
        bindSeller: "/api/fwAccount/bindSeller", // 绑定用户跟供应商
        unbindSeller: "/api/fwAccount/unbindSeller", // 解除绑定用户跟供应商
        bindShop: "/api/fwAccount/bindShop", // 绑定用户跟店铺
        unbindShop: "/api/fwAccount/unbindShop", // 绑定用户跟店铺
        bindMember: "/api/fwAccount/bindMember", // 绑定用户跟EC用户
        unBindMember: "/api/fwAccount/unBindMember", // 解除绑定用户跟EC用户
    },
    fwCustomerServiceList: {
        queryPage: "/api/fwCustomerService/query",//查询客服列表
        changeCustomerStatus: "/api/fwCustomerService/changeCustomerStatus", // 启用停用客服
        deleteCustomer: "/api/fwCustomerService/delete", // 停用客服
        acctList: "/api/fwCustomerService/getFwCustomerByOrgId",///{orgId}获取该岗位下客服人员的列表
        acctListWithOutOrgId: "/api/fwCustomerService/getFwCustomerWithOutOrgId",///{orgId}获取不加该岗位下客服人员的列表
        addFwCustomer: "/api/fwCustomerService/addCustomerByAcctId",//添加信息
        deleteFwCustomer: "/api/fwCustomerService/removeCustomerByAcctId",///移除信息
    },
    workOrderDeploy: {
        query: "/api_busi/bizCustomerWorkOrderDeploy/query",//查询客服列表
        changeStatus: "/api_busi/bizCustomerWorkOrderDeploy/changeStatus", // 启用停用客服
        getViewTool: "/api_busi/bizCustomerWorkOrderDeploy/getViewTool", // 查询左侧菜单
        saveOrderDeploy: "/api_busi/bizCustomerWorkOrderDeploy/saveOrderDeploy",//添加客服配置
        delete: "/api_busi/bizCustomerWorkOrderDeploy/delete",///移除信息
    },
    fwReportServer: {
        queryPage: "/api/fwReportServer/query",
        getById: "/api/fwReportServer/getById",
    },
    fwReportConfig: {
        queryPage: "/api/fwReportConfig/query",
        add: "/api/fwReportConfig/add",
        delete: "/api/fwReportConfig/delete",
        edit: "/api/fwReportConfig/edit",
        getById: "/api/fwReportConfig/getById",
        getByCode: "/api/fwReportConfig/getByCode",
        active:'/api/fwReportConfig/active', // 获取环境属性
    },
    // 订单是否参与计算维护
    bizClassifyCalculate: {
        queryPage: "/api_busi/bizClassifyCalculateAction/query",
        queryOne: "/api_busi/bizClassifyCalculateAction/queryOne",
        add: "/api_busi/bizClassifyCalculateAction/add",
        update: "/api_busi/bizClassifyCalculateAction/update",
        updateBatch: "/api_busi/bizClassifyCalculateAction/updateBatch",
        queryUpdate: "/api_busi/bizClassifyCalculateRecordAction/query",
        queryBatchUpdate: "/api_busi/bizOrderCalculateRecordAction/query",
    },
    fwReportSearchConfig: {
        queryPage: "/api/fwReportSearchConfig/query",
        add: "/api/fwReportSearchConfig/add",
        delete: "/api/fwReportSearchConfig/delete",
        edit: "/api/fwReportSearchConfig/edit",
        getById: "/api/fwReportSearchConfig/getById",
        getListByRId: "/api/fwReportSearchConfig/getListByRId",
    },
    fwAccountRole: {
        loadAllRoleWithAcct: '/api/fwAcctRole/assign/loadAllRoleWithAcct',// 获取制定用户的角色信息
        queryPage: '/api/fwAcctRole/query',//分页查询
        get: '/api/fwAcctRole/getSelect',//
    },
    /**新增用户组Api */
    fwRoleGroup: {
        queryPage: "/api/fwRoleGroup/query",
        edit: "/api/fwRoleGroup/edit",
        delete: "/api/fwRoleGroup/delete",
        add: "/api/fwRoleGroup/add",
        queryByParentId: "/api/fwRoleGroup/queryByParentId",
    },
    fwRoleList: {
        queryPage: "/api/fwrole/query",
        queryAll: "/api/fwrole/queryAll",
        edit: "/api/fwrole/edit",
        copy: "/api/fwrole/copy",
        delete: "/api/fwrole/delete",
        add: "/api/fwrole/add",
        rmAcctFromRole: "/api/fwrole/rmAcctFromRole",///rmAcctFromRole/{ids}/{roleId} GET
        supplySec: "/api/fwrole/supplySec",
        supplyProfitRateSec: "/api/fwrole/supplyProfitRateSec",
        branchOfficeSupplySec: "/api/fwrole/branchOfficeSupplySec",
        branchOfficeSupplyProfitRateSec: "/api/fwrole/branchOfficeSupplyProfitRateSec",
        viewSec: "/api/fwrole/viewSec",
        addrSec: "/api/fwrole/addrSec",
        updateXjSale: "/api/fwrole/updateXjSale",
        updateViewCustName: "/api/fwrole/updateViewCustName",
        updateViewHouseInfo: "/api/fwrole/updateViewHouseInfo",
        getTreeByRid: "/api/fwrole/getElMenuByRid",
        tree: "/api/fwrole/getMenuByRId",
        saveMenu: "/api/fwrole/saveRoleMenu",
        findRolePeo: "/api/fwrole/findRolePeo",
        findNoRolePeo: "/api/fwrole/findNoRolePeo",
        saveMan: "/api/fwrole/saveRoleMan",
        haveCode: "/api/fwrole/haveCode",
        loadAllRole: '/api/fwrole/public/loadAllRole', // 加载角色树形
        findRoleByCode: '/api/fwrole/findRoleByCode',// 获取销售账户
        findRoleBySaleRoleCode: '/api/fwrole/findRoleBySaleRoleCode',// 获取销售账户
        getAllProjPeople: '/api/fwrole/projectPeople',// 项目用户
        getAccountByCode: '/api/fwrole/getAccountByRoleCode',//根据某角色查询集合
        getAccountByCodeJudge: '/api/fwrole/getAccountByRoleCodeJudge',//根据某角色查询集合并对总公司不加org限制
        getNoSellerIdAccounnt: '/api/fwrole/getNoSellerIdAccounnt', // 查找为供应商用户但是为绑定用户的数据
        getNoShopIdAccounnt: '/api/fwrole/getNoShopIdAccounnt', // 查找为店铺用户但是未绑定用户的数据
        forceLoginOut: "/api/fwrole/forceLoginOut",//强制下线
        findRoleByName: "/api/fwrole/findRoleByName",
        updateReturnReceivablesView: "/api/fwrole/updateReturnReceivablesView",//修改返利收款查看权限
        updatereturnProfitRateView: "/api/fwrole/updatereturnProfitRateView",//修改返利利润率查看权限
        ecPeople: "/api/fwrole/ecPeople"//ec 使用
    },
    menuList: {
        queryPage: "/api/menu/query",
        queryRole: "/api/menu/queryRoleList",//根据sourceId查询所有的角色列表
        edit: "/api/menu/edit",
        delete: "/api/menu/delete",
        loadAllMenu: "/api/menu/public/loadAllMenu",
        loadAllMenuByName: "/api/menu/public/loadAllMenuByName",
        loadAllUserSource: "/api/menu/public/loadAllUserSource",
        getByPid: "/api/menu/resource/getByPid",
        getMenuByPid: "/api/menu/resource/getMenuByPid",
        add: "/api/menu/add",
        getById: "/api/menu/getById",
        getByList: "/api/menu/resource/getByList"
    },
    fwInstrumentPanelTemp: {
        queryPage: "/api/fwInstrumentPanelTemp/query",
        querySource: "/api/fwInstrumentPanelTemp/querySource",
        edit: "/api/fwInstrumentPanelTemp/edit",
        delete: "/api/fwInstrumentPanelTemp/delete",
        getAllTemp: "/api/fwInstrumentPanelTemp/getAllTemp",
        getByPid: "/api/fwInstrumentPanelTemp/getByPid",
        getMenuByPid: "/api/fwInstrumentPanelTemp/getMenuByPid",
        add: "/api/fwInstrumentPanelTemp/add",
    },
    fwUserTable: {
        queryPage: "/api/fwUserTable/query",
        add: "/api/fwUserTable/add",
        edit: "/api/fwUserTable/edit",
        delete: "/api/fwUserTable/delete",
        // loadAll:"api/fwUserTable/loadAll",
    },
    fwUserColumn: {
        queryPage: "/api/fwUserColumn/query",
        add: "/api/fwUserColumn/add",
        edit: "/api/fwUserColumn/edit",
        updateSystem: '/api/fwUserColumn/updateSystem',
        delete: "/api/fwUserColumn/delete",
        get: '/api/fwUserColumn/getByParentId',//查询多条记录
        getBuiltIn: '/api/fwUserColumn/getBuiltIn',//获取所有内置的字段
        save: '/api/fwUserColumn/saveColumn',//自定义数据的保存
        addList: "/api/fwUserColumn/addList",
        getColumn: '/api/fwUserColumn/getColumn',//用户获取系统内置字段
        setColumn: '/api/fwUserColumn/setColumn',//用户设置自定义列
        getCustom: '/api/fwUserColumn/getCustom',//获取页面自定义列数据或者系统内置的数据
        restore: '/api/fwUserColumn/restore',//恢复默认字段，获取系统内置字段
        same: '/api/fwUserColumn/same',//同步系统内置字段
    },
    orgList: {
        getDesignCenter: "/api/org/getAllDesignCenter",// 获取当前登录人所在组织下面的所有设计中心
        queryPage: "/api/org/query",
        edit: "/api/org/edit",
        queryById: "/api/org/getOrg",
        delete: "/api/org/delete",
        queryByParent: "/api/org/queryByParent", // 组织树结构加载
        saveOrg: "/api/org/add",// 保存组织信息
        queryName: "/api/org/queryByName", // 模糊查询上级组织
        queryAllOrg: "/api/org/queryAllOrg", // 查询所有组织
        startOrg: "/api/org/startOrg", // 启用组织
        stopOrg: "/api/org/stopOrg", // 停用组织
        updateorg: "/api/org/updateOrg", // 修改组织信息
        findAccountByOrg: "/api/org/findAccountByOrg", // 根据组织id查询是否有账户
        queryByParentViewTree: '/api/org/queryByParentViewTree',// 获取组织机构用于tree展示
        getFwOrgDto: '/api/org/getFwOrgDto', // 获取当前登录人组织机构信息
        getOneOrg: '/api/org/getOneFwOrg', // 根据id获取组织
        getOrgByName: '/api/org/getOrgByName', // 根据组织名称校验是否已存在
        getOrgShortName: '/api/org/getOrgShortName', // 根据组织简称校验是否已存在
        findChildrenOrgByParentId: '/api/org/findChildrenOrgByParentId', // 检验停用组织的下级组织是否被停用
        checkChildOrg: '/api/org/checkChildOrg',// 校验组织下是否有子组织
        findByUserOrg: '/api/org/findByUserOrg', // 根据登录用户获取组织
        findViewFwOrgInfo: '/api/org/findViewFwOrgInfo', // 获取组织信息
        getAllBranchOffice: '/api/org/getAllBranchOffice', // 获取所有二级分公司
        getAllCompany: '/api/org/getAllCompany', // 分公司
        getAllL2And3BranchOffice: '/api/org/getAllL2And3BranchOffice', // 获取所有分公司，包含上海分公司及苏州分公司
        getCompany: '/api/org/getCompany', // 获取所有sign=02的分公司
        getCompanyForApp: "/api/org/getCompanyForApp",//视野下看板组织树
        getLv3Company: "/api/org/getLv3Company",//获取所有三级分公司
        getLv3Org: "/api/org/getLv3Org",//获取所有三级组织
        getProOrgInfo: "/api/org/getProOrgInfo",//获取所有工程中心
        findByUserOrgDown: "/api/org/findByUserOrgDown",
        queryByParentCustomerTree: "/api/org/queryByParentCustomerTree" //用于客服配置的组织树显示
    },
    fwOrgMaterialTarget: {
        query: "/api/fwOrgMaterialTarget/query",
        add: "/api/fwOrgMaterialTarget/add",
        update: "/api/fwOrgMaterialTarget/update",
        get: "/api/fwOrgMaterialTarget/get",
        delete: "/api/fwOrgMaterialTarget/delete",
    },

    dept: {
        query: '/api/fwDepartment/query',
        getDepartmentByName: '/api/fwDepartment/getDepartmentByName',
        getDepartmentByOrgId: '/api/fwDepartment/getDepartmentByOrgId',
        createFwDepartment: '/api/fwDepartment/createFwDepartment',// 创建部门
        delete: '/api/fwDepartment/delete',// 删除部门
        midify: '/api/fwDepartment/edit',// 删除部门
    },
    queue: {
        queryError: '/api/QueueAction/queryError',//查询错误消息
        retry: '/api/QueueAction/retrySend',//重试
        queryConsume: '/api/QueueAction/queryConsume',//查询成功消费消息
    },
    stationList: {
        queryPage: '/api/fwStation/query', // 分页获取数据
        queryByAcct: '/api/fwStation/queryByAcct', // 分页获取数据
        queryNoAcct: '/api/fwStation/queryNoAcct', // 分页获取数据
        add: '/api/fwStation/add', // 新增
        update: '/api/fwStation/edit', // restfule风格
        delete: '/api/fwStation/delete',
        getFwAccountByStation: '/api/fwStation/getFwAccountByStation',
        addAcctToStation: '/api/fwStation/addAcctToStation', // 给账户绑定岗位
        delAcctFromStation: '/api/fwStation/delAcctFromStation', // 移除岗位人员
        updateByAcctIdAndStationIds: '/api/fwStation/updateByAcctIdAndStationIds', // 人员岗位更新
    },
    channelsList: {
        queryPage: '/api_cms/busiChannelConfig/query', // 分页获取数据
        // queryByAcct: '/api/fwStation/queryByAcct', // 分页获取数据
        // queryNoAcct: '/api/fwStation/queryNoAcct', // 分页获取数据
        add: '/api_cms/busiChannelConfig/add', // 新增
        update: '/api_cms/busiChannelConfig/update/', // restfule风格
        delete: '/api_cms/busiChannelConfig/delete/',
        //待分配人员
        getFwAccountByStation: '/api/fwAccount/findAccountOutChannel',
        //已分配
        addAcctToStation: '/api/fwAccount/findAccountInChannel', // 给账户绑定岗位


        addAcctFromStation: '/api_cms/busiChannelConfigAccount/addAccountsToChannel/', // 添加
        updateByAcctIdAndStationIds: '/api_cms/busiChannelConfigAccount/removeAccountsFromChannel/', // 移除
    },



    assessmentCategory: {
        queryPage: '/api_proj/projAssessmentCategory/query', // 分页获取数据
        add: '/api_proj/projAssessmentCategory/add', // 新增
        update: '/api_proj/projAssessmentCategory/update', // restfule风格
        delete: '/api_proj/projAssessmentCategory/delete',
        changeStatus: '/api_proj/projAssessmentCategory/changeStatus',
        //待分配人员
        getAllCategory: '/api_proj/projAssessmentCategoryDetail/queryAll', // 查询所有品类
        //已分配
        getOneCategory: '/api_proj/projAssessmentCategoryDetail/queryOne', // 查公司下的品类
        addCategory: '/api_proj/projAssessmentCategoryDetail/addCategory', // 添加
        delCategory: '/api_proj/projAssessmentCategoryDetail/delCategory', // 移除
        getSecEcCat: '/api_proj/projAssessmentCategory/getSecEcCat',
        getStuffIds : '/api_proj/projAssessmentCategory/getStuffIds',
    },
    //图像接口
    imageFile: {
        upload: "/api_file/upload.do?actionMethod=process", // post
        getImages: "/api_file/getFiles.do?actionMethod=getFiles", // get
        viewImage: "/api_file/viewOss.do", // get
        delete: "/api_file/cmdFileManager/delete",// post
        addTags: "/api_file/cmdFileManager/addTags", // post2
        viewImageOss: "/api_file/viewOss.do", // get
        remove: "/api_file/cmdFileManager/remove"
    },

    cmdFilePdf: {
        query: '/api/cmdFilePdf/query',
        edit: '/api/cmdFilePdf/edit',//修改
        add: '/api/cmdFilePdf/add',//增加
        getById: '/api/cmdFilePdf/getById',//查找
        del: '/api/cmdFilePdf/delete',//删除
    },
    budQuota: {
        query: '/api_bud/budQuotaAction/groupQueryByGroupId',
        add: '/api_bud/budQuotaAction/add',
        delete: '/api_bud/budQuotaAction/delete',
        edit: '/api_bud/budQuotaAction/edit',
        getById: '/api_bud/budQuotaAction/getById',
        stop: '/api_bud/budQuotaAction/stop',//停用
        start: '/api_bud/budQuotaAction/start',//启用
        getVersionDic: '/api/property/getDictionaryCache',//修改定额库字典
        queryVersionInfo: '/api_bud/budVersionInfoAction/query',//查询版本信息查询
        addVersionInfo: '/api_bud/budVersionInfoAction/add',//新增版本信息查询
        editVersionInfo: '/api_bud/budVersionInfoAction/edit',//修改版本信息查询
        deleteVersionInfo: '/api_bud/budVersionInfoAction/delete',//删除版本信息查询
        findLastestByOrgId: '/api_bud/budQuotaGroupAction/findLastestByOrgId',//根据分公司查询版本结束时间最晚的分组
        findByVersionId: '/api_bud/budQuotaGroupAction/findByVersionId',//根据版本查找分组
        findBudQuotaByCodeAndGroupId: '/api_bud/budQuotaAction/findBudQuotaByCodeAndGroupId',//根据定额编码取目标定额组校验是否重复
        exportQuota: '/api_bud/budBudgetInfoListAction/quotaExcel',//定额库导出
        syncQuota: '/api_bud/budQuotaAction/syncQuota',//定额同步
        coverQuota: '/api_bud/budQuotaAction/coverQuota',//定额覆盖
    },
    budQuotaGroup: {
        query: '/api_bud/budQuotaGroupAction/query',
        add: '/api_bud/budQuotaGroupAction/add',
        delete: '/api_bud/budQuotaGroupAction/delete',
        edit: '/api_bud/budQuotaGroupAction/edit',
        getById: '/api_bud/budQuotaGroupAction/getById',
        stop: '/api_bud/budQuotaGroupAction/stop',
        start: '/api_bud/budQuotaGroupAction/start',
        checkSameQuota: '/api_bud/budQuotaGroupAction/checkSameQuota',
        copyToGroup: '/api_bud/budQuotaGroupAction/copyToGroup',
    },
    budMaterial: {
        query: '/api_bud/budMaterialAction/query',
        add: '/api_bud/budMaterialAction/add',
        delete: '/api_bud/budMaterialAction/delete',
        edit: '/api_bud/budMaterialAction/edit',
        getById: '/api_bud/budMaterialAction/getById',
        stop: '/api_bud/budMaterialAction/stop',
        start: '/api_bud/budMaterialAction/start',
        editPrice:'/api_bud/budMaterialAction/budgetPrice',
        export:'/api_bud/budMaterialAction/export'
    },
    budMaterialUpdate: {
        query: '/api_bud/budMaterialUpdateAction/query',
        doUpdates: '/api_bud/budMaterialUpdateAction/doUpdates',
    },
    budMaterialLog: {
        query: '/api_bud/budMaterialLogAction/query',
    },
    vBudQuotaMaterialUpdate: {
        query: '/api_bud/vBudQuotaMaterialUpdateAction/query',
        batchEdit: '/api_bud/vBudQuotaMaterialUpdateAction/batchEdit',
    },
    budQuotaMaterialLog: {
        query: '/api_bud/budQuotaMaterialLogAction/query',
    },
    //预算管理
    budBudgetManage: {
        query: '/api_bud/budBudgetManageAction/query',
        queryVersion: '/api_bud/budBudgetManageAction/queryVersion',
        copyQuery: '/api_bud/budBudgetInfoListAction/copyQuery',//复制定额客户获取
        add: '/api_bud/budBudgetManageAction/add',
        delete: '/api_bud/budBudgetManageAction/delete',
        edit: '/api_bud/budBudgetManageAction/edit',
        excel: '/api_bud/budBudgetInfoListAction/exportComprehensiveQuotationExcel',//Excel测试
        verticalpdf: '/api_bud/budBudgetInfoListAction/exportVerticalPdf',//Pdf测试
        getById: '/api_bud/budBudgetManageAction/getById',//获取客户信息
        getByServiceId: '/api_bud/budBudgetManageAction/getByServiceId',//获取客户信息
        getBudgetListByServiceId: '/api_bud/budBudgetInfoListAction/getByServiceId',//根据serviceId 查询列表
        budgetList: '/api_bud/budBudgetInfoListAction/query',//预算列表
        publish: '/api_bud/budBudgetInfoListAction/publish',//上报预算
        unPublish: '/api_bud/budBudgetInfoListAction/unpublish',//取消发布
        internalControlPublish: '/api_bud/budBudgetInfoListAction/internalControlPublish',//上报内控 或变更
        internalControlUnPublish: '/api_bud/budBudgetInfoListAction/internalControlUnPublish',//上报内控 或变更
        addBudget: '/api_bud/budBudgetInfoListAction/addFromTemplate',//新增预算(从模板)
        addClientBudget: '/api_bud/budBudgetInfoListAction/addFromCustomer',//新增预算(从客户，含数量)
        addClientBudgetNoNum: '/api_bud/budBudgetInfoListAction/addFromCustomerNoNum',//新增预算(从客户，不含数量)
        getClientBudget: '/api_bud/budBudgetInfoListAction/queryCustomerBudgetBook',//获取客户预算
        getModelBudget: '/api_bud/budBudgetTemplateAction/limitedQuery',//获取模板预算
        editBudget: '/api_bud/budBudgetInfoListAction/edit',//修改预算
        editNameOrArea: '/api_bud/budBudgetInfoListAction/updateNameAndArea',//修改预算书名字或面积
        delBudget: '/api_bud/budBudgetInfoListAction/delete',//删除预算
        copyBudget: '/api_bud/budBudgetInfoListAction/copy',//复制预算
        proBudgetList: '/api_bud/budBudgetHouseAction/getByBookId',//工程预算列表
        recycleBin: '/api_bud/budBudgetHouseAction/getDeleteByBookId',//回收站
        comprehensiveExcel: '/api_bud/budBudgetInfoListAction/exportComprehensiveQuotationExcel',//综合报价Excel
        itemizedExcel: '/api_bud/budBudgetInfoListAction/exportItemizedQuotationExcel',//分项报价Excel
        looklogs: '/api_bud/BudBudgetLogAction/getBudBudgetLogList',//查询预算书操作日志
        getBook: '/api_bud/budBudgetInfoListAction/getById',
        getFlowById: '/api_bud/budBudgetInfoListAction/getFlowById',//获取审批信息
        reportExcel: '/api_bud/budBudgetInfoListAction/exportVerticalExcel',//导出Excel(综合报价)
        singleExcel: '/api_bud/budBudgetInfoListAction/exportExcel',//导出Excel(分项报价)
        excelNoMoney: '/api_bud/budBudgetInfoListAction/excelNoMoney',//无价格Excel
        pdf: '/api_bud/budBudgetInfoListAction/exportPdf',//Pdf生成并下载（横向分项）
        pdfCost: '/api_bud/budBudgetInfoListAction/exportReport',//Pdf生成并下载
        excelCost: '/api_bud/budBudgetInfoListAction/exportReportExcel',//excel下载
        excelCostByServiceId: '/api_bud/budBudgetInfoListAction/exportReportExcelByServiceId', //excel下载
        pdfCostByServiceId: '/api_bud/budBudgetInfoListAction/exportReportByServiceId',//Pdf生成并下载

        packageDetailPdf: '/api_bud/budBudgetPackageRemarkAction/printPackageDetail',//可选包费用打印

        pdfVertical: '/api_bud/budBudgetInfoListAction/exportVerticalPdf',//Pdf生成并下载（纵向）
        pdfNoMoney: '/api_bud/budBudgetInfoListAction/pdfNoMoney',//无价格pdf
        totalPdf: '/api_bud/budBudgetInfoListAction/tongJiPdf',//统计汇总pdf
        totalExcel: '/api_bud/budBudgetInfoListAction/tongJiExcel',//统计汇总Excel
        exportInternal: '/api_bud/budBudgetInfoListAction/exportInternal',//变更打印
        getArea: '/api_bud/budBudgetHouseAction/getById',//获取空间部位信息
        editArea: '/api_bud/budBudgetHouseAction/edit',//修改空间部位信息
        submitFlow:'/api_bud/budBudgetInfoListAction/flow',//预算优惠提交





    },
    bizOrderBudgetCommissioner:{
        query:'/api_busi/bizOrderBudgetCommissionerAction/query',
        getById:'/api_busi/bizOrderBudgetCommissionerAction/getById',
        edit:'/api_busi/bizOrderBudgetCommissionerAction/edit',
        add:'/api_busi/bizOrderBudgetCommissionerAction/add',
        deleteById:'/api_busi/bizOrderBudgetCommissionerAction/deleteById',




    },
//工程预算块儿
    projBudgetManage: {
        getHouseStruvture: '/api_bud/budBudgetHouseAction/getHouseStructure',//获取无定额的房屋结构
        getForceQuota: '/api_bud/budBudgetQuotaAction/checkForcedQuota',//查找缺少的强制定额
        getQuota: '/api_bud/budQuotaAction/groupQuery',//获取分组下的定额
        addQuota: '/api_bud/budBudgetQuotaAction/addQuota',//新增定额
        addCustomQuota: '/api_bud/budBudgetQuotaAction/addCustomQuota',//新增自定义定额
        addCustomQuotaBoth: '/api_bud/budBudgetQuotaAction/addCustomQuotaBoth',//新增自定义定额并保存
        recoverQuota: '/api_bud/budBudgetQuotaAction/recoverQuota',//恢复定额
        copyQuota: '/api_bud/budBudgetQuotaAction/copyQuota',//复制定额  不使用
        copyQuotaNoNum: '/api_bud/budBudgetQuotaAction/copyQuotaNoNum',//复制定额不含数量  不使用
        copyToSelf: '/api_bud/budBudgetQuotaAction/copy',//复制定额到自己的预算书内(含数量)   使用中
        copyWithoutNum: '/api_bud/budBudgetQuotaAction/copyWithoutNum',//复制定额到自己的预算书内(不含数量)  不使用
        getInversion: '/api_bud/budBudgetHouseAction/getByBookIdInVersion',//根据预算书id查找当前客户版本内的定额
        changeQuota: '/api_bud/budBudgetQuotaAction/changeQuota',//替换定额
        changeQuotaAll: '/api_bud/budBudgetQuotaAction/change',//批量替换定额
        deleteQuota: '/api_bud/budBudgetQuotaAction/deleteQuota',//删除定额
        batchDeleteHouse: '/api_bud/budBudgetHouseAction/batchDeleteHouse',//批量删除房间
        signQuota: '/api_bud/budBudgetQuotaAction/signQuota',//标记定额
        unsignQuota: '/api_bud/budBudgetQuotaAction/unsignQuota',//取消标记
        colorQuota: '/api_bud/budBudgetQuotaAction/colorQuota',//定额颜色
        uncolorQuota: '/api_bud/budBudgetQuotaAction/uncolorQuota',//取消颜色
        addHouse: '/api_bud/budBudgetHouseAction/add',//新增房间
        deleteHouse: '/api_bud/budBudgetHouseAction/deleteHouse',//删除房间
        saveAll: '/api_bud/budBudgetHouseAction/saveAll',//一键保存
        calculate: '/api_bud/budBudgetQuotaAction/calculate',//计算数量
        calculateInternal: '/api_bud/budBudgetQuotaAction/calculateInternal',//计算内控数量
        saveOne: '/api_bud/budBudgetHouseAction/saveOne',//修改备注
        budgetExplain: '/api_bud/budBudgetExplainAction/getByBookId',//编制/材料说明
        saveExplain: '/api_bud/budBudgetExplainAction/save',//编制/材料保存
        getSelfExplain: '/api_bud/budBudgetInfoListAction/getSelfExplain',//获取自定义编制说明
        updateSelfExplain: '/api_bud/budBudgetInfoListAction/updateSelfExplain',//修改自定义编制说明
        costAll: '/api_bud/budBudgetFormulaAction/getListByBookId',//费用组成
        packagePrice: '/api_bud/budBudgetPackageRemarkAction/getPackageDetail',//可选包费用
        savePackageRemark: '/api_bud/budBudgetPackageRemarkAction/saveRemark',//可选包备注保存
        getListByServiceId: '/api_bud/budBudgetFormulaAction/getListByServiceId',//通过服务单id获取费用组成
        costFormula: '/api_bud/budBudgetFormulaAction/edit',//费用组成编辑
        getPdfOssUrl: '/api_bud/budBudgetInfoListAction/getPdfOssUrl',//获取预览pdf接口
        editLog: '/api_bud/budBudgetQuotaLogAction/query',//修改日志
        delAll: '/api_bud/budBudgetQuotaAction/batchDeleteQuota',//批量删除定额
        addForce: '/api_bud/budBudgetQuotaAction/batchAddForcedQuota',//新增强制定额
        isRepeat: '/api_bud/budBudgetHouseAction/isRepeated',//判断某定额是否存在指定空间内
        getBudgetById: '/api_bud/budBudgetInfoListAction/getById',
        getClassify: '/api_bud/budBudgetExplainAction/getClassName',//获取模板分类
        sortAll: '/api_bud/budBudgetHouseAction/updateOrderId',//拖拽排序
        getSelfQuota: '/api_bud/budBudgetQuotaAction/getById',//获取自定义定额
        editSelfQuota: '/api_bud/budBudgetQuotaAction/updatePrivateQuota',//修改自定义定额
        syncByTemplateId:'/api_bud/budBudgetFormulaAction/syncByTemplateId',//同步费率表
        backSync:'/api_bud/budBudgetFormulaAction/backSync',//撤回同步



    },
    //预算模板
    budBudgetTemplate: {
        query: '/api_bud/budBudgetTemplateAction/query',//获取全部
        update: '/api_bud/budBudgetTemplateAction/edit', //更新信息
        add: '/api_bud/budBudgetTemplateAction/add',//新增
        getById: '/api_bud/budBudgetTemplateAction/edit',//获取单个信息
        getAreas: '/api_bud/budBudgetTemplateHouseAction/queryByHouseId',//获取房间列表
        addArea: '/api_bud/budBudgetTemplateHouseAction/addHouse',//新增房间
        editArea: '/api_bud/budBudgetTemplateHouseAction/edit',//修改房间
        delArea: '/api_bud/budBudgetTemplateHouseAction/delete',//删除房间
        sortArea: '/api_bud/budBudgetTemplateHouseAction/order',//房间排序
        getAreaQuota: '/api_bud/budBudgetTemplateQuotaAction/queryByHouseId',//获取当前房间定额
        addQuota: '/api_bud/budBudgetTemplateQuotaAction/addQuota',//新增/复制定额
        queryCost: '/api_bud/budBudgetTemplateFormulaAction/getAllInList',//根据模板查费用
        delCost: '/api_bud/budBudgetTemplateFormulaAction/delete',//删除费用
        addCost: '/api_bud/budBudgetTemplateFormulaAction/addFormula',//新增费用公式
        editCost: '/api_bud/budBudgetTemplateFormulaAction/updateFormula',//编辑费用公式
        sortCost: '/api_bud/budBudgetTemplateFormulaAction/upOrDown',//费用公式排序
        delete: '/api_bud/budBudgetTemplateAction/delete',
        copy: '/api_bud/budBudgetTemplateQuotaAction/copyQuota',
        versions: '/api_bud/budVersionInfoAction/getAll',//获取所有版本号
        copyTemplate: '/api_bud/budBudgetTemplateAction/copy',//复制模板接口
        bindExplain: '/api_bud/budBudgetTemplateAction/bindExplain',//绑定分类说明
    },
    //预算报表
    budgetStatement: {
        quotaQuery: '/api_bud/budQuotaGroupReportAction/queryByQuotaGroupId',//定额分组报表
        bookQuery: '/api_bud/budQuotaBookReportAction/queryBudgeBookReportByCustom',//预算书报表（入口-客户列表）
        bookQueryTwo: '/api_bud/budQuotaBookReportAction/queryBudgeBookReportByBookId',//预算书报表（入口-预算书列表）
        stageAnalysis: '/api_bud/VBudBookQuotaAnalysisReportAction/queryBudBookQuotaAnalysisByServiceId',//阶段分析（入口-客户列表）
        stageAnalysisTwo: '/api_bud/VBudBookQuotaAnalysisReportAction/queryBudBookQuotaAnalysisByBookId',//阶段分析（入口-预算书列表）
        export: '/api_bud/budQuotaBookReportAction/export',//导出预算书报表
        quotaExport: '/api_bud/budQuotaGroupReportAction/export',//导出定额报表
    },
    budBudgetTemplateExplain: {
        queryByOrgId: '/api_bud/budBudgetTemplateClassifyAction/query',//获取全部
        saveClassfy: '/api_bud/budBudgetTemplateClassifyAction/save', //更新信息
        delete: '/api_bud/budBudgetTemplateClassifyAction/delete', //更新信息
        queryByTemplate: '/api_bud/budBudgetTemplateExplainAction/find',//获取全部
        saveExpalin: '/api_bud/budBudgetTemplateExplainAction/save', //更新信息

        getContent: '/api_bud/budBudgetTemplateClassifyAction/getByNameAndType',//根据分类名称和说明类型查询
        getContentById: '/api_bud/budBudgetTemplateClassifyAction/getById',//通过分类id查询内容
        getAllClass: '/api_bud/budBudgetTemplateClassifyAction/getAllClassifyName',//所有分类获取
        addClass: '/api_bud/budBudgetTemplateClassifyAction/add',//新增分类
        delClass: '/api_bud/budBudgetTemplateClassifyAction/del',//删除分类
        editExpalin: '/api_bud/budBudgetTemplateClassifyAction/edit',//编辑说明
    },

    fwLoginUser: {
        query: '/api/fwLoginUser/query',
        edit: '/api/fwLoginUser/edit',//修改
        add: '/api/fwLoginUser/add',//增加
        getById: '/api/fwLoginUser/getById',//查找
        del: '/api/fwLoginUser/delete',//删除
        login: '/api/fwLoginUser/login',//假登录，测试用
    },
    bizOrderMaterialOrg: {
        query: '/api_busi/bizOrderMaterialOrg/query',
        edit: '/api_busi/bizOrderMaterialOrg/edit',//修改
        add: '/api_busi/bizOrderMaterialOrg/add',//增加
        getById: '/api_busi/bizOrderMaterialOrg/getById',//查找
        del: '/api_busi/bizOrderMaterialOrg/delete',//删除
        isDelete: '/api_busi/bizOrderMaterialOrg/isDelete',//软删除
        haveOrgId: '/api_busi/bizOrderMaterialOrg/haveOrgId',//查重

    },
    /**********************************base end***************************************************/

    /**********************************EC***************************************************/
    //EC端口
    ec: {
        queryTable: "/api_ec/prana/item/detail",//查询表格
        queryClasssify: "/api_ec/prana/itemcat/list",//查询商品分类
        queryBrand: "/api_ec/prana/itemcat/brandlist",//查询商品品牌
        chen: "/api_ec/prana/item/chen"
    },

    report: {
        query: "/api_report/cnex4ReportPreview/frameset",
    },

    /**********************************workFlow start***************************************************/
    //流程方案
    workflow_blue: {
        query: '/api_workflow/workflowBlue/query', //POST
        update: '/api_workflow/workflowBlue/edit',//GET POST
        add: '/api_workflow/workflowBlue/add',  // POST
        delete: '/api_workflow/workflowBlue/delete',  // POST
    },
    workflowDetails: {
        query: '/api_workflow/workflowDetails/query', //POST
        update: '/api_workflow/workflowDetails/edit',//GET POST
        add: '/api_workflow/workflowDetails/add',  // POST
        delete: '/api_workflow/workflowDetails/delete',  // POST
        getName: '/api_workflow/workflowDetails/getName',  // POST
    },
    //流程节点
    workflow_Node: {
        query: '/api_workflow/workflowNode/query', //POST query/{workflowBlueId}
        update: '/api_workflow/workflowNode/edit',//GET POST
        getAllNodeKey: '/api_workflow/workflowNode/processDefinedKey',// POST
        add: '/api_workflow/workflowNode/add',  // POST
        refresh: '/api_workflow/workflowNode/refresh',  // POST /refresh/{workflowBlueId}
        delete: '/api_workflow/workflowNode/delete',  // POST
        code: '/api_workflow/workflowNode/code',  // GET
    },
    // 流程节点授权
    workflow_node_Authorized: {
        query: '/api_workflow/workflowNodeAuthority/query', //POST query/{workflowNodeId}
        queryRule: '/api_workflow/workflowNodeAuthority/queryRule',  // POST
        update: '/api_workflow/workflowNodeAuthority/edit',//GET POST
        getAllNodeKey: '/api_workflow/workflowNodeAuthority/processDefinedKey',// POST
        add: '/api_workflow/workflowNodeAuthority/add',  // POST
        addPerson: '/api_workflow/workflowNodeAuthority/addPerson',////addPerson/{workflowNodeId}
        addGroup: '/api_workflow/workflowNodeAuthority/addGroup',//addGroup/{workflowNodeId}
        addRule: '/api_workflow/workflowNodeAuthority/addRule',// addGroup/{workflowBlueId}
        saveScope: '/api_workflow/workflowNodeAuthority/saveScope',///saveScope/{workflowNodeId}
        delete: '/api_workflow/workflowNodeAuthority/delete',  // POST RequestBody ids
        code: '/api_workflow/workflowNodeAuthority/code',  // GET
    },
    //流程授权
    workflow_Authorized: {
        query: '/api_workflow/workflowAuthority/query', // POST /query/{workflowBlueId}
        update: '/api_workflow/workflowAuthority/edit',// GET POST
        add: '/api_workflow/workflowAuthority/add',  // POST
        queryPerson: '/api_workflow/workflowAuthority/queryPerson',  // POST
        queryGroup: '/api_workflow/workflowAuthority/queryGroup',  // POST
        addPerson: '/api_workflow/workflowAuthority/addPerson',// addPerson/{workflowBlueId}
        addGroup: '/api_workflow/workflowAuthority/addGroup',// addGroup/{workflowBlueId}
        delete: '/api_workflow/workflowAuthority/delete',  //  POST RequestBody ids
        code: '/api_workflow/workflowAuthority/code',  // GET
    },
    //流程定义
    workflow_define: {
        query: '/api_workflow/workflowModel/query', //POST
        update: '/api_workflow/workflowModel/edit',//GET POST
        add: '/api_workflow/workflowModel/add',  // POST
        delete: '/api_workflow/workflowModel/delete',  // POST
        deploy: '/api_workflow/workflowModel/deploy',  // POST PathVariable
        export: '/api_workflow/workflowModel/export',  // GET PathVariable ids[]
        import: '/api_workflow/workflowModel/import',  // POST PathVariable id
        code: '/api_workflow/workflowModel/code',  // GET PathVariable id
    },
    workflowRule: {
        query: '/api_workflow/workflowNodeAuthorityRule/query', //POST
    },
    workflowApi: {
        getProcessVariablesByprocessInstanceId: '/api_workflow/workflowApi/getProcessVariablesByprocessInstanceId',
        getProcessVariablesByTaskId: '/api_workflow/workflowApi/getProcessVariablesByTaskId',
        getProcessAndHistoricVariablesByTaskId: '/api_workflow/workflowApi/getProcessAndHistoricVariablesByTaskId',
    },
    projAssessmentRule: {
        query: '/api_workflow/projAssessmentRule/query',
        del: '/api_workflow/projAssessmentRule/delete',
        add: '/api_workflow/projAssessmentRule/add',
        queryOne: '/api_workflow/projAssessmentRule/queryOne',
        update: '/api_workflow/projAssessmentRule/edit',
    },
    workerCostApplyRule: {
        query: '/api_workflow/workerCostApplyRule/query',
        del: '/api_workflow/workerCostApplyRule/delete',
        add: '/api_workflow/workerCostApplyRule/add',
        queryOne: '/api_workflow/workerCostApplyRule/queryOne',
        update: '/api_workflow/workerCostApplyRule/edit',
    },
    projectCheckRule: {
        query: '/api_workflow/projectCheckRule/query',
        del: '/api_workflow/projectCheckRule/delete',
        add: '/api_workflow/projectCheckRule/add',
        queryOne: '/api_workflow/projectCheckRule/queryOne',
        update: '/api_workflow/projectCheckRule/edit',
    },
    expectedDeliveryRule: {
        query: '/api_workflow/planExpectedDeliveryRule/query',
        del: '/api_workflow/planExpectedDeliveryRule/delete',
        add: '/api_workflow/planExpectedDeliveryRule/add',
        queryOne: '/api_workflow/planExpectedDeliveryRule/queryOne',
        update: '/api_workflow/planExpectedDeliveryRule/edit',
    },
    materialContractRule: {
        query: '/api_workflow/contractMaterialRule/query',
        del: '/api_workflow/contractMaterialRule/delete',
        add: '/api_workflow/contractMaterialRule/add',
        queryOne: '/api_workflow/contractMaterialRule/queryOne',
        update: '/api_workflow/contractMaterialRule/edit',
    },
    contractSoftDesignRule: {
        query: '/api_workflow/contractSoftDesignRule/query',
        del: '/api_workflow/contractSoftDesignRule/delete',
        add: '/api_workflow/contractSoftDesignRule/add',
        queryOne: '/api_workflow/contractSoftDesignRule/queryOne',
        update: '/api_workflow/contractSoftDesignRule/edit',
    },
    bizNodePostponeRule: {
        query: '/api_workflow/bizNodePostponeRule/query',
        del: '/api_workflow/bizNodePostponeRule/delete',
        add: '/api_workflow/bizNodePostponeRule/add',
        queryOne: '/api_workflow/bizNodePostponeRule/queryOne',
        update: '/api_workflow/bizNodePostponeRule/edit',
    },
    bizNodeRestartRule: {
        query: '/api_workflow/bizNodeRestartRule/query',
        del: '/api_workflow/bizNodeRestartRule/delete',
        add: '/api_workflow/bizNodeRestartRule/add',
        queryOne: '/api_workflow/bizNodeRestartRule/queryOne',
        update: '/api_workflow/bizNodeRestartRule/edit',
    },
    profitSplitRule: {
        query: '/api_workflow/profitSplitRule/query',
        del: '/api_workflow/profitSplitRule/delete',
        add: '/api_workflow/profitSplitRule/add',
        queryOne: '/api_workflow/profitSplitRule/queryOne',
        update: '/api_workflow/profitSplitRule/edit',
    },
    commonUseRule: {
        query: '/api_workflow/commonUseRule/query',
        del: '/api_workflow/commonUseRule/delete',
        add: '/api_workflow/commonUseRule/add',
        queryOne: '/api_workflow/commonUseRule/queryOne',
        update: '/api_workflow/commonUseRule/edit',
    },
    projectPaymentRule: {
        query: '/api_workflow/projectPaymentRule/query',
        del: '/api_workflow/projectPaymentRule/delete',
        add: '/api_workflow/projectPaymentRule/add',
        queryOne: '/api_workflow/projectPaymentRule/queryOne',
        update: '/api_workflow/projectPaymentRule/edit',
    },
    customerWorkOrderRule: {
        query: '/api_workflow/customerWorkOrderRule/query',
        del: '/api_workflow/customerWorkOrderRule/delete',
        add: '/api_workflow/customerWorkOrderRule/add',
        queryOne: '/api_workflow/customerWorkOrderRule/queryOne',
        update: '/api_workflow/customerWorkOrderRule/edit',
    },
    contractBaseRule: {
        query: '/api_workflow/bizContractBaseRule/query',
        del: '/api_workflow/bizContractBaseRule/delete',
        add: '/api_workflow/bizContractBaseRule/add',
        queryOne: '/api_workflow/bizContractBaseRule/queryOne',
        update: '/api_workflow/bizContractBaseRule/edit',
    },
    bizOrderServiceStopRule: {
        query: '/api_workflow/bizOrderServiceStopRule/query',
        del: '/api_workflow/bizOrderServiceStopRule/delete',
        add: '/api_workflow/bizOrderServiceStopRule/add',
        queryOne: '/api_workflow/bizOrderServiceStopRule/queryOne',
        update: '/api_workflow/bizOrderServiceStopRule/edit',
    },
    projSpecialApproveRule: {
        query: '/api_workflow/projSpecialApproveRuleAction/query',
        delete: '/api_workflow/projSpecialApproveRuleAction/delete',
        add: '/api_workflow/projSpecialApproveRuleAction/add',
        queryOne: '/api_workflow/projSpecialApproveRuleAction/queryOne',
        update: '/api_workflow/projSpecialApproveRuleAction/update',
    },
    contractDesignRule: {
        query: '/api_workflow/bizContractDesignRule/query',
        del: '/api_workflow/bizContractDesignRule/delete',
        add: '/api_workflow/bizContractDesignRule/add',
        queryOne: '/api_workflow/bizContractDesignRule/queryOne',
        update: '/api_workflow/bizContractDesignRule/edit',
    },
    reformRebateRule: {
        query: '/api_workflow/bizReformRebateRule/query',
        del: '/api_workflow/bizReformRebateRule/delete',
        add: '/api_workflow/bizReformRebateRule/add',
        queryOne: '/api_workflow/bizReformRebateRule/queryOne',
        update: '/api_workflow/bizReformRebateRule/edit',
    },
    reformRebateRefundRule: {
        query: '/api_workflow/bizReformRebateRefundRule/query',
        del: '/api_workflow/bizReformRebateRefundRule/delete',
        add: '/api_workflow/bizReformRebateRefundRule/add',
        queryOne: '/api_workflow/bizReformRebateRefundRule/queryOne',
        update: '/api_workflow/bizReformRebateRefundRule/edit',
    },
    targetCompanyRule: {
        query: '/api_workflow/bizTargetCompanyRule/query',
        del: '/api_workflow/bizTargetCompanyRule/delete',
        add: '/api_workflow/bizTargetCompanyRule/add',
        queryOne: '/api_workflow/bizTargetCompanyRule/queryOne',
        update: '/api_workflow/bizTargetCompanyRule/edit',
    },
    contractReformRule: {
        query: '/api_workflow/bizContractReformRule/query',
        del: '/api_workflow/bizContractReformRule/delete',
        add: '/api_workflow/bizContractReformRule/add',
        queryOne: '/api_workflow/bizContractReformRule/queryOne',
        update: '/api_workflow/bizContractReformRule/edit',
    },
    materialPaymentOrderRule: {
        query: '/api_workflow/bizMaterialPaymentOrderRule/query',
        del: '/api_workflow/bizMaterialPaymentOrderRule/delete',
        add: '/api_workflow/bizMaterialPaymentOrderRule/add',
        queryOne: '/api_workflow/bizMaterialPaymentOrderRule/queryOne',
        update: '/api_workflow/bizMaterialPaymentOrderRule/edit',
    },
    contractReformResignRule: {
        query: '/api_workflow/bizContractReformResignRule/query',
        del: '/api_workflow/bizContractReformResignRule/delete',
        add: '/api_workflow/bizContractReformResignRule/add',
        queryOne: '/api_workflow/bizContractReformResignRule/queryOne',
        update: '/api_workflow/bizContractReformResignRule/edit',
    },
    bizElectronicReceiptRule: {
        query: '/api_workflow/bizElectronicReceiptRule/query',
        del: '/api_workflow/bizElectronicReceiptRule/delete',
        add: '/api_workflow/bizElectronicReceiptRule/add',
        queryOne: '/api_workflow/bizElectronicReceiptRule/queryOne',
        update: '/api_workflow/bizElectronicReceiptRule/edit',
    },


    contractDesignResignRule: {
        query: '/api_workflow/bizContractDesignResignRule/query',
        del: '/api_workflow/bizContractDesignResignRule/delete',
        add: '/api_workflow/bizContractDesignResignRule/add',
        queryOne: '/api_workflow/bizContractDesignResignRule/queryOne',
        update: '/api_workflow/bizContractDesignResignRule/edit',
    },



    contractBaseResignRule: {
        query: '/api_workflow/bizContractBaseResignRule/query',
        del: '/api_workflow/bizContractBaseResignRule/delete',
        add: '/api_workflow/bizContractBaseResignRule/add',
        queryOne:'/api_workflow/bizContractBaseResignRule/queryOne',
        update: '/api_workflow/bizContractBaseResignRule/edit',
    },
    materialPaymentRule: {
        query: '/api_workflow/materialPaymentRule/query',
        del: '/api_workflow/materialPaymentRule/delete',
        add: '/api_workflow/materialPaymentRule/add',
        queryOne: '/api_workflow/materialPaymentRule/queryOne',
        update: '/api_workflow/materialPaymentRule/edit',
    },
    backOrderRule: {
        query: '/api_workflow/backOrderRule/query',
        get: '/api_workflow/backOrderRule/edit',
        add: '/api_workflow/backOrderRule/add',
        edit: '/api_workflow/backOrderRule/edit',
        del: '/api_workflow/backOrderRule/delete',
    },
    saleOrderRule: {
        query: '/api_workflow/saleOrderRule/query',
        get: '/api_workflow/saleOrderRule/edit',
        add: '/api_workflow/saleOrderRule/add',
        edit: '/api_workflow/saleOrderRule/edit',
        del: '/api_workflow/saleOrderRule/delete',
    },
    discountOrderRule: {
        query: '/api_workflow/discountOrderRule/query',
        get: '/api_workflow/discountOrderRule/edit',
        add: '/api_workflow/discountOrderRule/add',
        edit: '/api_workflow/discountOrderRule/edit',
        del: '/api_workflow/discountOrderRule/delete',
    },
    sendOrderRule: {
        query: '/api_workflow/sendOrderRule/query',
        get: '/api_workflow/sendOrderRule/edit',
        add: '/api_workflow/sendOrderRule/add',
        edit: '/api_workflow/sendOrderRule/edit',
        del: '/api_workflow/sendOrderRule/delete',
    },
    bizNeededStuffOrderRule: {
        query: '/api_workflow/bizNeededStuffOrderRule/query',
        edit: '/api_workflow/bizNeededStuffOrderRule/edit',
        add: '/api_workflow/bizNeededStuffOrderRule/add',
        get: '/api_workflow/bizNeededStuffOrderRule/get',
        del: '/api_workflow/bizNeededStuffOrderRule/delete',
    },
    purchaseOrderRule: {
        query: '/api_workflow/purchaseOrderRule/query',
        get: '/api_workflow/purchaseOrderRule/edit',
        add: '/api_workflow/purchaseOrderRule/add',
        edit: '/api_workflow/purchaseOrderRule/edit',
        del: '/api_workflow/purchaseOrderRule/delete',
    },
    returnOrderRule: {
        query: '/api_workflow/returnOrderRule/query',
        get: '/api_workflow/returnOrderRule/edit',
        add: '/api_workflow/returnOrderRule/add',
        edit: '/api_workflow/returnOrderRule/edit',
        del: '/api_workflow/returnOrderRule/delete',
    },
    supplierSettlementRule: {
        query: '/api_workflow/supplierSettlementRule/query',
        get: '/api_workflow/supplierSettlementRule/edit',
        add: '/api_workflow/supplierSettlementRule/add',
        edit: '/api_workflow/supplierSettlementRule/edit',
        del: '/api_workflow/supplierSettlementRule/delete',
    },
    financeAuditRule: {
        query: '/api_workflow/financeAuditRule/query',
        add: '/api_workflow/financeAuditRule/add',
        update: '/api_workflow/financeAuditRule/update',
        del: '/api_workflow/financeAuditRule/delete',
        getById: '/api_workflow/financeAuditRule/getById',
    },
    busiCustomerOrderRule: {
        query: '/api_workflow/busiCustomerOrderRuleAction/query',
        add: '/api_workflow/busiCustomerOrderRuleAction/add',
        update: '/api_workflow/busiCustomerOrderRuleAction/update',
        del: '/api_workflow/busiCustomerOrderRuleAction/delete',
        getById: '/api_workflow/busiCustomerOrderRuleAction/getById',
    },
    projectStartWorkAuditRule: {
        query: '/api_workflow/projectStartWorkAuditRule/query',
        get: '/api_workflow/projectStartWorkAuditRule/edit',
        add: '/api_workflow/projectStartWorkAuditRule/add',
        edit: '/api_workflow/projectStartWorkAuditRule/edit',
        del: '/api_workflow/projectStartWorkAuditRule/delete',
    },
    GuaranteeInfoRule: {
        query: '/api_workflow/GuaranteeInfoRule/query',
        get: '/api_workflow/GuaranteeInfoRule/edit',
        add: '/api_workflow/GuaranteeInfoRule/add',
        edit: '/api_workflow/GuaranteeInfoRule/edit',
        del: '/api_workflow/GuaranteeInfoRule/delete',
    },
    GuaranteeInfoResetRule: {
        query: '/api_workflow/GuaranteeInfoResetRule/query',
        get: '/api_workflow/GuaranteeInfoResetRule/edit',
        add: '/api_workflow/GuaranteeInfoResetRule/add',
        edit: '/api_workflow/GuaranteeInfoResetRule/edit',
        del: '/api_workflow/GuaranteeInfoResetRule/delete',
    },

    bizContractTerminationRule: {
        query: '/api_workflow/bizContractTerminationRule/query',
        get: '/api_workflow/bizContractTerminationRule/queryOne',
        add: '/api_workflow/bizContractTerminationRule/add',
        edit: '/api_workflow/bizContractTerminationRule/edit',
        del: '/api_workflow/bizContractTerminationRule/delete',
    },

    projectManagerRule: {
        query: '/api_workflow/projectManagerRule/query',
        get: '/api_workflow/projectManagerRule/edit',
        add: '/api_workflow/projectManagerRule/add',
        edit: '/api_workflow/projectManagerRule/edit',
        del: '/api_workflow/projectManagerRule/delete',
    },
    projectManagerResetRule: {
        query: '/api_workflow/projectManagerResetRule/query',
        get: '/api_workflow/projectManagerResetRule/edit',
        add: '/api_workflow/projectManagerResetRule/add',
        edit: '/api_workflow/projectManagerResetRule/edit',
        del: '/api_workflow/projectManagerResetRule/delete',
    },
    customerMaterialReportRule: {
        query: '/api_workflow/customerMaterialReportRule/query',
        get: '/api_workflow/customerMaterialReportRule/edit',
        add: '/api_workflow/customerMaterialReportRule/add',
        edit: '/api_workflow/customerMaterialReportRule/edit',
        del: '/api_workflow/customerMaterialReportRule/delete',
    },
    workbench:{
        getUserConfig:'/api/fwUserHomePageAction/userConfig',//首页工作台获取用户配置
        updateUserConfig:'/api/fwUserHomePageAction/updateUserConfig',//更新用户首页配置
        getProjectDynamic:'/api_busi/vBizOrderProjectDynamicAction/query',//获取项目动态接口
        getPersonalPerformanceData:'/api_busi/busiOperationAnalysis/getPersonalPerformanceData',//个人业绩 首页查询接口
        getPersonalPerformanceDataDetail:'/api_busi/busiOperationAnalysis/getPersonalPerformanceDataDetail',//个人业绩 下钻明细
        queryStorePersonalMonitor:'/api_busi/busiOperationAnalysis/queryStorePersonalMonitor',//资源盯控 首页查询接口
        queryPersonalMonitoringDetail:'/api_busi/busiOperationAnalysis/queryPersonalMonitoringDetail',//资源盯控 下钻明细
    },
    myjob: {
        toDolist: '/api_workflow/myjob/toDolist', //POST
        doneList: '/api_workflow/myjob/doneList', //POST
        mySubmit: '/api_workflow/myjob/mySubmit', //POST
        toDo: '/api_workflow/myjob/toDo', //POST
        print: '/api_workflow/myjob/toPrint', //POST
        delegation: '/api_workflow/myjob/setPerson', //POST {id}/{userId} PathVariable 委派
        procPic: '/api_workflow/myjob/procPic', // /procPic/{processInstanceId} 进度图片 POST
        dueList: '/api_workflow/myjob/dueList', // /dueList/{processInstanceId}  进度列表 get
        toDetail: '/api_workflow/myjob/toDetail', // POST: PathVariable:id
        setPerson: '/api_workflow/myjob/setPerson', // POST: PathVariable:{id}/{userId}


        batchApprove: '/api_workflow/myjob/batchApprove', //POST  RequestBody： taskIds result resultMessage
        commonApprove: '/api_workflow/myjob/commonApprove', //POST  PathVariable： taskId  resultMessage  RequestBody：result resultMessage
        printNodeList: '/api_workflow/myjob/printNodeList', //GET  PathVariable： processInstanceId
        canNotic: '/api_workflow/myjob/canNotic', //GET  PathVariable： processInstanceId
        reject: '/api_workflow/myjob/canNotic', //POST   ids[] 拒绝
        widthdraw: '/api_workflow/myjob/widthdraw', //POST PathVariable： taskId 撤回
        getCount: "/api_workflow/myjob/getCount",
        allList: '/api_workflow/myjob/allList',
    },
    /**********************************4、以下为添加的选材报价的方法跳转*******************************/
    bizOrderOffer: {
        queryPage: "/api_busi/bizOrderOffer/query",//列表查询报价单
        queryById: "/api_busi/bizOrderOffer/getOrder", //根据id获取报价单
        add: "/api_busi/bizOrderOffer/add",  //报价单新增
        update: "/api_busi/bizOrderOffer/edit", //修改报价单
        updates: "/api_busi/bizOrderOffer/updates", //修改报价单
        delete: "/api_busi/bizOrderOffer/delete", //删除报价单
        deleteOffeByIsShow: "/api_busi/bizOrderOffer/deleteOffeByIsShow", //删除报价单脏数据
        refer: "/api_busi/bizOrderOffer/refer",//提交报价单
        queryByServiceId: "/api_busi/bizOrderOffer/getOfferByServiceId",//根据serviceId查询报价单
        queryByProductId: "/api_busi/bizOrderOffer/getOfferByProductId",//根据productid(产品服务订单)查询正常报价单
        confirmOffer: "/api_busi/bizOrderOffer/confirmOffer",//确认报价单
        confirmOfferNew: "/api_busi/bizOrderOffer/confirmOfferNew",//星杰确认报价单
        confirmCustomer: "/api_busi/bizOrderOffer/confirmCustomer",//客户确认报价单
        changeStatus: "/api_busi/bizOrderOffer/changeStatus", //修改报价单状态为报价中
        getBizOrderOfferVersion: "/api_busi/bizOrderOffer/getBizOrderOfferVersion",//获取报价单版本
        addOfferAndDetails: "/api_busi/bizOrderOffer/addOfferAndDetails",//保存报价单及明细
        bindingOrUnbindingOffer: "/api_busi/bizOrderOffer/bindingOrUnbindingOffer",//材料合同关联/取关报价单
        getFloorCode: "/api_busi/bizOrderOffer/getOrAddFloorCode",//获取楼层区域编码
        getAll: "/api_busi/bizOrderOffer/getAllFloorName",//获取所有楼层区域
    },
    bizOrderOfferGoodsDetail: {
        changeGoodStatus: "/api_busi/bizOrderOfferGoodsDetail/changeGoodStatus",//修改产品状态
        query: "/api_busi/bizOrderOfferGoodsDetail/query",//查询商品
        queryAll: '/api_busi/bizOrderOfferGoodsDetail/queryAll',//查询所有商品
        queryByStatus: "/api_busi/bizOrderOfferGoodsDetail/queryByStatus",//查询报价中商品
        delete: "/api_busi/bizOrderOfferGoodsDetail/delete",//根据商品id删除商品
        queryTableTree: "/api_busi/bizOrderOfferGoodsDetail/queryTableTree",//查询商品tableTree
        queryTableTree1: "/api_busi/bizOrderOfferGoodsDetail/queryTableTree1",//查询商品tableTree
        add: "/api_busi/bizOrderOfferGoodsDetail/add",//新增所选商品
        queryById: "/api_busi/bizOrderOfferGoodsDetail/edit",//根据商品id查询商品
        batchSave: "/api_busi/bizOrderOfferGoodsDetail/batchSave",//批量保存商品
        batchDelete: "/api_busi/bizOrderOfferGoodsDetail/deleteByOfferId",//根据offerId批量删除商品
        queryByOffer: "/api_busi/bizOrderOfferGoodsDetail/findOfferByOfferId",//根据offerId查询商品list
        findOfferByOfferIdAndParentId: "/api_busi/bizOrderOfferGoodsDetail/findOfferByOfferIdAndParentId",//根据offerId查询非自购商品list
        queryBySupply: "/api_busi/bizOrderOfferGoodsDetail/findSupplyByOfferId",//根据offerId查询供应商list
        findOfferByBrandId: "/api_busi/bizOrderOfferGoodsDetail/findOfferByBrandId",//材料合同汇总列表获取
        findOfferByBrandIdAndOfferId: "/api_busi/bizOrderOfferGoodsDetail/findOfferByBrandIdAndOfferId",//材料合同汇总列表获取
        updateData: "/api_busi/bizOrderOfferGoodsDetail/sumData",//修改星杰报价，数量
        confirmPrice: "/api_busi/bizOrderOfferGoodsDetail/confirmPrice",//确认报价
        confirmPriceNew: "/api_busi/bizOrderOfferGoodsDetail/confirmPriceNew",//新流程确认报价
        submit: "/api_busi/bizOrderOfferGoodsDetail/submit",//产品提交
        removeProduct: "/api_busi/bizOrderOfferGoodsDetail/removeProduct",//移除商品
        queryByOfferAndStuff: "/api_busi/bizOrderOfferGoodsDetail/queryByOfferAndStuff",//根据报价单id和分类查询自购商品
        queryByOfferAndfl: "/api_busi/bizOrderOfferGoodsDetail/queryByOfferAndfl",//根据报价单id和分类信息查寻商品
        queryGoodDetail: "/api_busi/bizOrderOfferGoodsDetail/queryGoodDetail",//商品详情页查询方法
        getDetailsSum: "/api_busi/bizOrderOfferGoodsDetail/getDetailsSum",//获取商品汇总
        updateOfferDetails: "/api_busi/bizOrderOfferGoodsDetail/updateOfferDetails",//更新报价单明细
        requote: "/api_busi/bizOrderOfferGoodsDetail/requote",//重新报价
        getByContractId: "/api_busi/bizOrderOfferGoodsDetail/getByContractId",//通过合同id 获取报价单明细
    },
    vBizOrderOfferGoodsDetailSum: {
        query: '/api_busi/vBizOrderOfferGoodsDetailSumAction/query',//报价单详情汇总视图查询
    },
    busiOprationPromotion: {
        query: '/api_cms/promotion/query',//分页查询
        add: '/api_cms/promotion/add',//新增
        findById: '/api_cms/promotion/findById',//根据id查询
        edit: '/api_cms/promotion/edit',//修改
        delete: '/api_cms/promotion/delete',//删除
        start: '/api_cms/promotion/startPromotion',//启用
        stop: '/api_cms/promotion/stopPromotion',//停用
        getByCodeAndType: '/api_cms/promotion/getByOrgIdAndType',//根据组织和轮播终端获取数量
    },
    bizOrderServiceBusinessPeople: {
        add: '/api_busi/bizOrderServiceBusinessPeople/add',

    },
    vWorkerProjectInfoAction: {
        query: '/api_worker/vWorkerProjectInfoAction/query',
        getById: '/api_worker/vWorkerProjectInfoAction/getById',
    },
    workerProjectDispatchMappingAction: {
        query: '/api_worker/workerProjectDispatchMappingAction/query',
        queryByProjectIdAndWorkStage: '/api_worker/workerProjectDispatchMappingAction/queryByProjectIdAndWorkStage',
        getWorkerStageAndType: '/api_worker/workerProjectDispatchMappingAction/getWorkerStageAndType',
        add: '/api_worker/workerProjectDispatchMappingAction/add',
        cancelBind: '/api_worker/workerProjectDispatchMappingAction/cancelBind',
    },
    workerManagerMappingAction: {
        query: '/api_worker/workerManagerMappingAction/query',
    },


    esignAccount: {
        query: '/api_busi/bizEsignAccount/query',//认证账号分页查询
        add: '/api_busi/bizEsignAccount/add',//认证账号添加
        delete: '/api_busi/bizEsignAccount/delete',//认证企业账号删除
        getPhoneCode: '/api_busi/bizEsignAccount/getPhoneCode',//短信
        addSupplyPersonSign: '/api_busi/bizEsignAccount/addSupplyPersonSign',//新增供应商个人账号
        getBySupplyPerson: '/api_busi/bizEsignAccount/getBySupplyPerson',//查询当前人账号
        getEsignAccountById:'/api_busi/bizEsignAccount/getEsignAccountById'//
    },
    esignOrgAccount: {
        query: '/api_busi/bizEsignOrgAccount/query',//认证企业账号分页查询
        add: '/api_busi/bizEsignOrgAccount/add',//认证企业账号添加
        delete: '/api_busi/bizEsignOrgAccount/deleteEsignOrg',//认证企业账号删除
        addSupplyOrg: '/api_busi/bizEsignOrgAccount/addSupplyOrg',//认证企业账号添加
        getBySupplyOrg: '/api_busi/bizEsignOrgAccount/getBySupplyOrg',//认证企业账号添加
    },

    bizContractEsign:{
        getByContractIdAndType:'/api_busi/bizContractEsign/findEfficientByContractIdAndContractTypeAndType',
    },
    workerAccount: {
        query: '/api_worker/workerInfoAction/query',//工人分页查询
        queryForPm: '/api_worker/workerInfoAction/queryForPm',//工人分页查询
        add: '/api_worker/workerInfoAction/add',//工人增加
        get: '/api_worker/workerInfoAction/get',//工人查询
        edit: '/api_worker/workerInfoAction/edit',//工人编辑
        updateWorkerStatus: '/api_worker/workerInfoAction/updateWorkerStatus',//工人查询
    },
    workerGuaranteeInfo: {
        query: '/api_worker/workerGuaranteeInfoAction/query',//担保分页查询
        add: '/api_worker/workerGuaranteeInfoAction/add',//担保增加
        get: '/api_worker/workerGuaranteeInfoAction/edit',//担保查询
        edit: '/api_worker/workerGuaranteeInfoAction/edit',//担保编辑
        validPhone: '/api_worker/workerGuaranteeInfoAction/validPhone',//手机号校验
    },
    workerGuaranteeAmountConfigManager: {
        query: '/api_worker/workerGuaranteeAmountConfigAction/query',//担保配置分页查询
        add: '/api_worker/workerGuaranteeAmountConfigAction/add',//担保配置增加
        get: '/api_worker/workerGuaranteeAmountConfigAction/edit',//担保配置查询
        edit: '/api_worker/workerGuaranteeAmountConfigAction/edit',//担保配置编辑
        amount: '/api_worker/workerGuaranteeAmountConfigAction/amount',//查询
        delete: '/api_worker/workerGuaranteeAmountConfigAction/delete',//担保配置编辑
    },
    VBizOrderBudgetDetailList: {
        query: '/api_busi/VBizOrderBudgetDetailList/query',
    },
    jcChannelExt: {
        delete: '/api_cms/jcChannelExt/delete',//删除
    },
    jcChannel: {
        delete: '/api_cms/jcChannel/delete',//删除
    },
    bdBankTypeAction: {
        getBdBankTypes: '/api_nc/bdBankTypeAction/getBdBankTypes',
    },
    atjiaFeedback: {
        query: '/api_atjia/atjiaFeedback/query'
    },
    atjiaReportForms: {
        getCompanyReport: '/api_atjia/reportForms/getCompanyReport',
        detailReport: '/api_atjia/reportForms/detailReport',
        loginLogReport: '/api_atjia/admin/vAccessLog/query',
        dayReport: '/api_atjia/reportForms/getDayReport',
        versionReport: '/api_atjia/reportForms/getVersionReport',
    },
    // atjia满意度调查相关
    atjiaQuestionnaire: {
        queryPage: '/api_atjia/admin/questionnaire/query',
        add: '/api_atjia/admin/questionnaire/addNew',
        edit: '/api_atjia/admin/questionnaire/update',
        updateStatus: '/api_atjia/admin/questionnaire/updateStatus',
        updateSendConfig: '/api_atjia/admin/questionnaire/updateSendConfig',
        hasUnAutoSatisfactionQuestionnaire: '/api_atjia/admin/questionnaire/hasUnAutoSatisfactionQuestionnaire'
    },
    questionnaireList: {
        queryList: '/api_atjia/admin/questionnaireList/query',
        findById: '/api_atjia/admin/questionnaireList/findById'
    },
    imPromptStatement: {
        query: '/api_atjia/admin/imPrompt/query',
        add: '/api_atjia/admin/imPrompt/add',
        update: '/api_atjia/admin/imPrompt/update',
        deleteImPro: '/api_atjia/admin/imPrompt/delete',
        changeStatus: '/api_atjia/admin/imPrompt/changeStatus',
        getById: '/api_atjia/admin/imPrompt/getById'
    },
    accessLog: {
        query: '/api_atjia/admin/accessLogOrderDetail/query',
    },
    orderAccessLogDay: {
        query: '/api_atjia/admin/orderAccessLogDay/query',
    },

    VCompletionSatisfactionScoreAction: {
        query: '/api_proj/VCompletionSatisfactionScoreAction/queryPage',
        save: '/api_proj/VCompletionSatisfactionScoreAction/inputScore',
        export:'/api_proj/VCompletionSatisfactionScoreAction/export'
    },
    /**********************************workFlow end***************************************************/


    /**********************************3、以下为添加的cms的方法跳转 start***************************************************/
    bsaeUpload: '/api/member/upload/o_upload',//普通文件上传
    userLogin: '/api/front/user/login',//登录
    getPerms: '/api/admin/user/getPerms',// 获取用户权限
    loginOut: '/api/member/user/logout',//退出登录
    personalGet: '/api/personal/get',//获取个人资料详情

    contentTxt: setAdminApi('jcContentTxt/edit'),//获取软文正文内容
    // contentAddTags: setAdminApi('content/addTags'),// 软文打标签
    contentAddTags: setAdminApi('vCmsSoftTextAction/addTags'),// 软文打标签
    orgId: setAdminApi('jcContent/getOrgIdById'),//获取orgId
    validateName: setAdminApi('member/check_name'),//
    groupList: setAdminApi('group/list'),//会员组列表接口
    groupGet: setAdminApi('group/get'),//会员组详情接口
    groupSave: setAdminApi('group/save'),//新增会员组接口
    groupUpdate: setAdminApi('group/update'),//修改会员组接口
    groupDelete: setAdminApi('group/delete'),//删除会员组接口
    groupPriority: setAdminApi('group/priority'),//批量保存会员组接口
    memberList: setAdminApi('member/list'),//会员分页列表接口
    memberGet: setAdminApi('member/get'),//会员详情接口
    memberSave: setAdminApi('member/save'),//会员添加接口
    memberUpdate: setAdminApi('member/update'),//会员详情修改
    memberDelete: setAdminApi('member/delete'),//会员详情删除
    memberCheck: setAdminApi('member/check'),//会员详情审核
    roleList: setAdminApi('role/list'),//角色列表
    roleGet: setAdminApi('role/get'),//角色信息
    roleSave: setAdminApi('role/save'),//角色添加
    roleUpdate: setAdminApi('role/update'),//角色更新
    roleDelete: setAdminApi('role/delete'),//角色删除
    roleMembers: setAdminApi('role/member_list'),//角色成员
    roleMembersDelete: setAdminApi('role/member_delete'),//角色成员
    accountList: setAdminApi('account/list'),//1）账户列表接口
    accountDelete: setAdminApi('account/delete'),//2）删除账户接口
    adminGlobleList: setAdminApi('admin/global_list'),//管理员列表(全站)
    adminGlobleDelete: setAdminApi('admin/global_delete'),//管理员删除(全站)
    adminGlobleGet: setAdminApi('admin/global_get'),//管理员详情(全站)
    adminGlobleUpdate: setAdminApi('admin/global_update'),//管理员编辑提交(全站)
    adminGlobleSave: setAdminApi('admin/global_save'),//管理员添加提交(全站)
    adminGlocalList: setAdminApi('admin/local_list'),//管理员添加提交(本站)
    adminGlocalGet: setAdminApi('admin/local_get'),//管理员添加详情(本站)
    adminGlocalSave: setAdminApi('admin/local_save'),//管理员添加提交(本站)
    adminGlocalUpdate: setAdminApi('admin/local_update'),//管理员修改提交(本站)
    adminGlocalDelete: setAdminApi('admin/local_delete'),//管理员删除提交(本站)
    adminValRank: setAdminApi('admin/val_rank'),//校验管理员等级信息
    // contentTree: setAdminApi('content/tree'),//内容栏目树接口
    contentTree: setAdminApi('vCmsSoftTextAction/channelList'),//内容栏目树接口
    contentList: setAdminApi('vCmsSoftTextAction/query'),//nei内容列表接口
    // contentList: setAdminApi('content/list'),//nei内容列表接口
// modelList: setAdminApi('model/list'),//1)    模型管理列表接口
    modelList: setAdminApi('jcChannel/edit'),//1)    模型管理列表接口
    modelListAll: setAdminApi('jcModelAction/query'),//1)    模型管理列表接口
    contentPage: setAdminApi('content/page'),//分页数据接口
    contentShareTree: setAdminApi('content/share_tree'),//共享tree接口
    fullTextSearchChannelList: setAdminApi('vCmsSoftTextAction/channelList'),//全文检索获取栏目下拉列表
    fullTextSearchCreate: setAdminApi('lucene/create'),//生成索引
    siteTree: setAdminApi('site/tree'),//获取站点树结构
    siteList: setAdminApi('site/list'),//站点管理列表接口
    siteGet: setAdminApi('site/get'),//获取站点管理详情
    siteSave: setAdminApi('site/save'),//添加站点管理
    siteUpdate: setAdminApi('site/update'),//修改站点管理
    siteDelete: setAdminApi('site/delete'),//删除站点管理
    siteCheckMaster: setAdminApi('site/check_master'),//验证是否为主站
    siteCheckAccessPath: setAdminApi('site/check_accessPath'),//验证访问路径是否可用
    siteCheckDomain: setAdminApi('site/check_domain'),//验证域名是否可用

    contentRenuseList: setAdminApi('content/reuse_list'),//获取内容复用信息列表
    contentRenusePage: setAdminApi('content/reuse_page'),//获取内容复用分页信息
    logList: setAdminApi('log/operating_list'),//后台操作日志列表接口
    messageList: setAdminApi('message/list'),//站内信列表接口
    messageGet: setAdminApi('message/get'),//2)  站内信详情接口
    messageRead: setAdminApi('message/read'),//  阅读站内信详细信息
    messageSend: setAdminApi('message/send'),//3)    发送消息接口
    messageSave: setAdminApi('message/save'),//4)    保存草稿接口
    messageToSend: setAdminApi('message/tosend'),//5)    选择发送接口
    messageUpdate: setAdminApi('message/update'),//6)    修改消息接口
    messageForward: setAdminApi('message/forward'),//7)   任意消息详情
    messageReply: setAdminApi('message/reply'),//8)  回复消息详情
    messageTrash: setAdminApi('message/trash'),//9)  移除至回收站接口
    messageRevert: setAdminApi('message/revert'),//10)   还原消息接口
    messageEmpty: setAdminApi('message/empty'),//11) 清空消息接口
    memberCheckName: setAdminApi('member/check_name'),//7）校验用户名接
    siteConfigGet: setAdminApi('site_config/base_get'),//1）站点详情接口
    siteConfigUpdate: setAdminApi('site_config/base_update'),//站点修改接口
    ftpList: setAdminApi('ftp/list'),//FTP管理列表接口
    ossList: setAdminApi('oss/list'),//oss云储存列表
    tplList: setAdminApi('tpl/list'),//首页模板列表
    // tplModelList: setAdminApi('tpl/model_list'),//所有的模版列表
    tplModelList: setAdminApi('jcModelAction/modelList'),//所有的模版列表
    ftpGet: setAdminApi('ftp/get'),//2）FTP管理详情接口
    ftpSave: setAdminApi('ftp/save'),//3）FTP管理添加接口
    ftpUpdate: setAdminApi('ftp/update'),//4）FTP管理修改接口
    ftpDelete: setAdminApi('ftp/delete'),//5）FTP管理删除接口
    typeList: setAdminApi('type/list'),//1)  内容类型列表接口
    typeGet: setAdminApi('type/get'),//1)    2)  内容类型详情接口
    typeSave: setAdminApi('type/save'),//1)      添加内容类型接口
    typeUpdate: setAdminApi('type/update'),//    内容类型详情接口
    typeDelete: setAdminApi('type/delete'),//    删除内容类型接口
    typeCheckId: setAdminApi('type/check_id'),// 内容类型ID校验
    modelGet: setAdminApi('jcModelAction/edit'),//    模型管理详情接口
    modelSave: setAdminApi('jcModelAction/add'),//3)    添加模型管理接口
    modelUpdate: setAdminApi('jcModelAction/update'),//修改模型管理接口
    modelDelete: setAdminApi('jcModelAction/delete'),//删除模型管理接口
    modelPriority: setAdminApi('model/priority'),//批量保存模型管理接口
    modelCheckId: setAdminApi('jcModelAction/checkId'),//验证模型ID是否可用
    itemList: setAdminApi('jcModelItemAction/list'),//获取模型项列表信息
    // itemList: setAdminApi('item/list'),//获取模型项列表信息
    itemGet: setAdminApi('jcModelItemAction/edit'),//获取模型项详细信息
    itemSave: setAdminApi('jcModelItemAction/add'),//添加模型项信息
    itemUpdate: setAdminApi('jcModelItemAction/update'),//修改模型项信息
    itemDelete: setAdminApi('jcModelItemAction/delete'),//删除模型项信息
    itemPriority: setAdminApi('jcModelItemAction/priority'),//批量保存模型项信息
    itemListSave: setAdminApi('item/list_save'),//批量保存模型项信息
    itemCheckField: setAdminApi('item/check_field'),//模型项字段校验接口

    configGet: setAdminApi('config/get'),//获取登录设置详情
    configSystemUpdate: setAdminApi('config/system_update'),//系统设置修改接口
    configLoginGet: setAdminApi('config/login_get'),//获取登录设置详情
    configLoginUpdate: setAdminApi('config/login_update'),//修改登录设置信息，所有数据以JSON格式返回
    configMemberGet: setAdminApi('config/member_get'),//获取会员设置详情
    configMemberUpdate: setAdminApi('config/member_update'),//修改会员设置信息，所有数据以JSON格式返回
    configRegisterItemList: setAdminApi('config/register_item_list'),//获取会员注册模型列表信息，所有数据以JSON格式返回
    configRegisterItemGet: setAdminApi('config/register_item_get'),//获取会员注册模型详细信息，所有数据以JSON格式返回
    configRegisterItemSave: setAdminApi('config/register_item_save'),//添加会员注册模型信息，所有数据以JSON格式返回
    configRegisterItemUpdate: setAdminApi('config/register_item_update'),//修改会员注册模型信息
    configRegisterItemDelete: setAdminApi('config/register_item_delete'),//删除会员注册模型信息
    configRegisterItemPriority: setAdminApi('config/register_item_priority'),//批量保存会员注册模型信息
    configMarkGet: setAdminApi('config/mark_get'),//获取水印设置详情
    configMarkUpdate: setAdminApi('config/mark_update'),//修改水印设置信息
    configFirewallGet: setAdminApi('config/firewall_get'),//获取网站防火墙设置详情
    configFirewallUpdate: setAdminApi('config/firewall_update'),//修改网站防火墙设置信息
    configContentChargeGet: setAdminApi('config/content_charge_get'),//获取内容佣金设置详情
    configContentChargeUpdate: setAdminApi('config/content_charge_update'),//内容佣金信息修改
    configCompanyGet: setAdminApi('site_config/company_get'),//获取机构信息设置详情deleteBatch
    configCompanyUpdate: setAdminApi('site_config/company_update'),//获取机构信息设置修改
    configAttrGet: setAdminApi('config/attr_get'),//获取其他设置详情
    configAttrUpdate: setAdminApi('config/attr_update'),//其他配置修改
    configAttrClear: setAdminApi('config/attr_clear'),//清除内存缓存

    dictionaryList: setAdminApi('dictionary/list'),//按类型获取字典列表接口
    dictionaryGet: setAdminApi('dictionary/get'),//获取字典详情信息
    dictionarySave: setAdminApi('dictionary/save'),//字典添加
    dictionaryUpdate: setAdminApi('dictionary/update'),//字典修改
    dictionaryDelete: setAdminApi('dictionary/delete'),//字典删除
    dictionaryCheckValue: setAdminApi('dictionary/check_value'),//校验字典名称与值
    dictionaryType: setAdminApi('dictionary/type'),//获取字典类型信息
    apiGet: setAdminApi('config/api_get'),//获取接口设置详情
    apiUpdate: setAdminApi('config/api_update'),//修改会员设置信息
    apiSSOGet: setAdminApi('config/sso_get'),//获取单点登录认证设置详情
    apiSSOupdate: setAdminApi('config/sso_update'),//修改会员设置信息
    apiWebserviceList: setAdminApi('webservice/list'),//接口管理列表
    apiWebserviceGet: setAdminApi('webservice/get'),//获取接口管理详细信息
    apiWebserviceSave: setAdminApi('webservice/save'),//添加接口管理详细信息
    apiWebserviceUpdate: setAdminApi('webservice/update'),//修改接口管理详细信息
    apiWebserviceDelete: setAdminApi('webservice/delete'),//删除接口管理详细信息
    apiWebserviceAuthList: setAdminApi('webservice/auth_list'),//接口用户管理列表
    apiWebserviceAuthGet: setAdminApi('webservice/auth_get'),//获取接口用户管理详细信息
    apiWebserviceAuthSave: setAdminApi('webservice/auth_save'),//添加接口用户管理详细信息
    apiWebserviceAuthUpdate: setAdminApi('webservice/auth_update'),//修改接口用户管理详细信息
    apiWebserviceAuthDelete: setAdminApi('webservice/auth_delete'),//删除接口用户管理详细信息
    apiWebserviceRecordList: setAdminApi('webservice/record_list'),//获取接口调用记录列表信息
    apiWebserviceRecordDelete: setAdminApi('webservice/record_delete'),//删除接口调用记录详细信息
    apiRecordList: setAdminApi('apiRecord/list'),//获取API接口记录列表信息
    apiRecordDelete: setAdminApi('apiRecord/delete'),//API接口记录删除接口
    apiInfoList: setAdminApi('info/list'),//获取API管理列表信息
    apiInfoGet: setAdminApi('info/get'),//获取API管理详细信息
    apiInfoUpdate: setAdminApi('info/update'),//修改API管理详细信息
    apiInfoSave: setAdminApi('info/save'),//添加API管理详细信息
    apiInfoDelete: setAdminApi('info/delete'),//删除API管理详细信息
    apiAccountList: setAdminApi('apiAccount/list'),//API接口账户管理列表信息
    apiAccountGet: setAdminApi('apiAccount/get'),//API接口账户管理详细信息
    apiAccountSave: setAdminApi('apiAccount/save'),//API接口账户管理添加
    apiAccountValPwd: setAdminApi('apiAccount/val_pwd'),//校验独立密码
    apiAccountPwdUpdate: setAdminApi('apiAccount/pwd_update'),//修改独立密码
    // channelCreatPath: setAdminApi('channel/create_path'),//获取拼音
    channelCreatPath: setAdminApi('vCmsSoftTextAction/createPath'),//获取拼音
    // tplSelectContentModel: setAdminApi('tpl/select_content_model'),//模型模版
    tplSelectContentModel: setAdminApi('tpl/select_content_model'),//模型模版
    commentList: setAdminApi('comment/list'),//获取评论管理列表信息
    commentGet: setAdminApi('comment/get'),//获取评论管理详细信息
    commentUpdate: setAdminApi('comment/update'),//修改评论信息
    commentDelete: setAdminApi('comment/delete'),//删除评论管理信息
    commentCheck: setAdminApi('comment/check'),//审核评论管理信息
    commentCancelCheck: setAdminApi('comment/cancelCheck'),//取消审核评论管理信息
    wordTagList: setAdminApi('tag/list'),//获取TAG列表信息
    wordTagGet: setAdminApi('tag/get'),//获取TAG详情
    wordTagSave: setAdminApi('tag/save'),//保存TAG信息
    wordTagUpdate: setAdminApi('tag/update'),//修改TAG信息
    wordTagDelete: setAdminApi('tag/delete'),//删除TAG信息
    wordTagCheckName: setAdminApi('tag/check_name'),//校验TAG名称是否可用
    wordSensitivityList: setAdminApi('sensitivity/list'),//获取敏感词列表信息
    wordSensitivityGet: setAdminApi('sensitivity/get'),//获取敏感词详情信息
    wordSensitivityUpdate: setAdminApi('sensitivity/update'),//修改敏感词信息
    wordSensitivitySave: setAdminApi('sensitivity/save'),//保存敏感词信息
    wordSensitivityDelete: setAdminApi('sensitivity/delete'),//删除敏感词信息
    wordKeywordList: setAdminApi('keyword/list'),//关键词管理列表
    wordKeywordGet: setAdminApi('keyword/get'),//关键词管理详情
    wordKeywordSave: setAdminApi('keyword/save'),//保存关键词
    wordKeywordUpdate: setAdminApi('keyword/update'),//修改关键词
    wordKeywordDelete: setAdminApi('keyword/delete'),//删除关键词
    wordOriginList: setAdminApi('origin/list'),//获取来源管理列表信息
    wordOriginGet: setAdminApi('origin/get'),//获取来源管理信息
    wordOriginSave: setAdminApi('origin/save'),//保存来源管理信息
    wordOriginUpdate: setAdminApi('origin/update'),//修改来源管理信息
    wordOriginDelete: setAdminApi('origin/delete'),//删除来源管理信息
    wordSearchwordsList: setAdminApi('searchwords/list'),//热词管理列表
    wordSearchwordsGet: setAdminApi('searchwords/get'),//热词管理详情
    wordSearchwordsSave: setAdminApi('searchwords/save'),//热词管理保存
    wordSearchwordsUpdate: setAdminApi('searchwords/update'),//热词管理修改
    wordSearchwordsDelete: setAdminApi('searchwords/delete'),//热词管理删除
    contentBuyUserOrderList: setAdminApi('contentBuy/user_order_list'),//获取内容购买记录列表信息
    contentBuyUserAccountList: setAdminApi('contentBuy/user_account_list'),//获取用户账户统计列表信息
    contentBuyChargeList: setAdminApi('contentBuy/charge_list'),//内容收费统计
    contentBuyCommissionStatic: setAdminApi('contentBuy/commissionStatic'),//2）平台佣金所得统计接口

    accountPayList: setAdminApi('accountPay/list'),//获取转账列表信息
    accountPayPayByWX: setAdminApi('accountPay/payByWX'),//转账
    accountPayPayByWXGet: setAdminApi('accountPay/draw_apply_get'),//详情

    accountPayDelete: setAdminApi('accountPay/delete'),//删除转账信息
    accountPayDrawApplyList: setAdminApi('accountPay/draw_apply_list'),//获取提现列表信息
    accountPayDrawApplyCheck: setAdminApi('accountPay/draw_apply_check'),//审核/退回
    accountPayDrawApplyDelete: setAdminApi('accountPay/draw_apply_delete'),//删除提现信息
    dimensioncodeCreate: setAdminApi('dimensioncode/create'),//生成二维码
    scoregroupList: setAdminApi('scoregroup/list'),//获取评分组列表信息
    scoregroupGet: setAdminApi('scoregroup/get'),//获取评分组详情信息
    scoregroupSave: setAdminApi('scoregroup/save'),//保存评分组信息
    scoregroupUpdate: setAdminApi('scoregroup/update'),//修改评分组信息
    scoregroupDelete: setAdminApi('scoregroup/delete'),//删除评分组信息
    scoreitemList: setAdminApi('scoreitem/list'),//获取评分项列表信息
    scoreitemGet: setAdminApi('scoreitem/get'),//获取评分项信息
    scoreitemSave: setAdminApi('scoreitem/save'),//保存评分项信息
    scoreitemUpdate: setAdminApi('scoreitem/update'),//修改评分项信息
    scoreitemDelete: setAdminApi('scoreitem/delete'),//删除评分项信息
    contentCycleRecycle: setAdminApi('content/cycle_recycle'),//回收内容信息
    contentCycleDelete: setAdminApi('content/cycle_delete'),//删除内容信息

    globalStatistic: setAdminApi('global/statistic'),//获取全局统计信息
    statisticMemberList: setAdminApi('statistic/member/list'),//获取会员注册数
    channelByCid: setAdminApi('channel/channelByCid'),// 判断该栏目是否是父栏目
    channelCopy: setAdminApi('channel/copy'),//栏目复制
    channelTree: setAdminApi('channel/tree'),//栏目树
    // channelGet: setAdminApi('channel/get'),//栏目信息获取
    channelGet: setAdminApi('jcChannel/edit'),//栏目信息获取
    // channelList: setAdminApi('channel/list'),//获取栏目信息
    channelList: setAdminApi('vCmsSoftTextAction/channelList'),//获取栏目信息
    channelDelete: setAdminApi('jcChannelExt/delete'),//删除栏目
    channelPriority: setAdminApi('channel/priority'),//栏目排序
    // channelSave: setAdminApi('channel/save'),//栏目添加
    channelSave: setAdminApi('jcChannelExt/add'),//栏目添加
    // channelUpdate: setAdminApi('channel/update'),//栏目修改
    channelUpdate: setAdminApi('jcChannelExt/update'),//栏目修改
    channelCheckPath: setAdminApi('jcChannel/checkPath'), //验证栏目路径是否为重复
    // contentGet: setAdminApi('content/get'),//获取内容
    contentGet: setAdminApi('vCmsSoftTextAction/get'),//获取内容
    contentSave: setAdminApi('vCmsSoftTextAction/add'),//发布内容接口
    // contentSave: setAdminApi('content/save'),//发布内容接口
    // contentSubmitXia: setAdminApi('content/submitXia'), // 软文提交审核接口
    contentSubmitXia: setAdminApi('vCmsSoftTextAction/unShelve'), // 软文提交审核接口
    // contentSubmitPublic: setAdminApi('content/contentSubmitPublic'), // 软文提交审核接口
    contentSubmitPublic: setAdminApi('vCmsSoftTextAction/submit'), // 软文提交审核接口
    contentView: setAdminApi('content/view'),//查看内容接口
    // contentUpdate: setAdminApi('content/update'),//修改内容接口
    contentUpdate: setAdminApi('vCmsSoftTextAction/update'),//修改内容接口
    // contentDelete: setAdminApi('content/delete'),//删除内容接口
    contentDelete: setAdminApi('vCmsSoftTextAction/delete'),//删除内容接口
    // contentRecommend: setAdminApi('content/recommend'),//推荐
    contentRecommend: setAdminApi('vCmsSoftTextAction/recommend'),//推荐
    // contentSubmit: setAdminApi('content/submit'),//内容提交
    contentSubmit: setAdminApi('vCmsSoftTextAction/check'),//内容提交
    contentChannelList: setAdminApi('vCmsSoftTextAction/channelList'),//通过parentId获取所有子栏目
    // contentpigeonholes:setAdminApi('content/submitGui'),//归档
    contentpigeonholes: setAdminApi('vCmsSoftTextAction/archived'),//归档
    contentRecord: setAdminApi('content/record/list'),//操作记录接口
    contentMove: setAdminApi('content/move'),//移动接口
    // contentCopy: setAdminApi('content/copy'),//内容复制
    contentCopy: setAdminApi('vCmsSoftTextAction/copy'),//内容复制
    contentCheck: setAdminApi('content/check'),//内容审核
    contentReject: setAdminApi('content/reject'),//内容退回
    contentSendToWeixin: setAdminApi('content/send_to_weixin'),
    contentSend: setAdminApi('content/send_to_topic'),//推送至专题接口
    contentStatic: setAdminApi('content/static'),//生成静态页
    contentPriority: setAdminApi('content/priority'),//保存固顶接口
    contentPush: setAdminApi('content/push'),//推送接口
    contentPigeonhole: setAdminApi('content/pigeonhole'),//归档接口
    contentUnpigeonhole: setAdminApi('content/unpigeonhole'),//出档接口
    contentRefer: setAdminApi('content/refer'),//内容引用
    topicListAll: setAdminApi('topic/by_channel'),//专题列表
    topicList: setAdminApi('topic/list'),//专题列表，分页
    topicGet: setAdminApi('topic/get'),//专题获取
    topicSave: setAdminApi('topic/save'),//专题添加
    topicDelete: setAdminApi('topic/delete'),//专题删除
    topicUpdate: setAdminApi('topic/update'),//专题更新
    topicPriority: setAdminApi('topic/priority'),//专题排序
    topicTplList: setAdminApi('topic/tpl_list'),//专题模版
    crontabList: setAdminApi('task/list'),//定时任务列表
    crontabGet: setAdminApi('task/get'),//定时任务获取详情
    crontabSave: setAdminApi('task/save'),//定时任务保存
    crontabUpdate: setAdminApi('task/update'),//定时任务修改
    crontabDelete: setAdminApi('task/delete'),//定时任务删除
    acquisitionList: setAdminApi('acquisition/list'),//采集列表
    workflowList: setAdminApi('workflow/list'),//工作流列表
    workflowGet: setAdminApi('workflow/get'),//工作流详情
    workflowSave: setAdminApi('workflow/save'),//工作流保存
    workflowUpdate: setAdminApi('workflow/update'),//工作流修改
    workflowDelete: setAdminApi('workflow/delete'),//工作流删除
    workflowPriority: setAdminApi('workflow/priority'),//工作流保存排序

    linkList: setAdminApi('friendlink/list'),   //友情链接列表
    linkGet: setAdminApi('friendlink/get'),     //友情链接详情
    linkSave: setAdminApi('friendlink/save'),   //友情链接保存
    linkUpdate: setAdminApi('friendlink/update'),//友情链接修改
    linkDelete: setAdminApi('friendlink/delete'),//友情链接删除
    linkPriority: setAdminApi('friendlink/priority'),//友情链接修改排序
    linkTypeList: setAdminApi('friendlink/ctg_list'),//友情链接类别列表
    linkTypeGet: setAdminApi('friendlink/ctg_get'),  //有情链接类别详情
    linkTypeSave: setAdminApi('friendlink/ctg_save'), //友情链接列表保存
    linkTypeUpdate: setAdminApi('friendlink/ctg_priority'),//友情链接修改
    linkTypeDelete: setAdminApi('friendlink/ctg_delete'),//友情链接删除
    adSpaceList: setAdminApi('advertising/space_list'),//广告版位列表
    adSpaceGet: setAdminApi('advertising/space_get'),//广告版位详情
    adSpaceSave: setAdminApi('advertising/space_save'),//广告版位新增
    adSpaceUpdate: setAdminApi('advertising/space_update'),//广告版位修改
    adSpaceDelete: setAdminApi('advertising/space_delete'),//广告版位删除
    adList: setAdminApi('advertising/list'),//广告列表
    adGet: setAdminApi('advertising/get'),//广告详情
    adSave: setAdminApi('advertising/save'),//广告新增
    adUpdate: setAdminApi('advertising/update'),//广告修改
    adDelete: setAdminApi('advertising/delete'),//广告删除
    fileList: setAdminApi('file/list'),//附件列表
    fileDelete: setAdminApi('file/delete'),//删除附件
    fileInvalid: setAdminApi('file/freefiles_delete'),//标志原有附件失效
    fileEffective: setAdminApi('file/flag'),//标志原有附件有效
    contentShareList: setAdminApi('content/share_list'),//共享管理列表
    contentShareAduit: setAdminApi('content/share_check'),//共享信息审核
    contentShareDelete: setAdminApi('content/share_delete'),//共享信息删除
    flowPvList: setAdminApi('flow/pv/list'),//趋势分析统计
    flowSourceList: setAdminApi('flow/source/list'),//来源来源、来访域名、搜索词统计
    flowPagesList: setAdminApi('flow/pages/list'),//受访页面统计
    flowAreaList: setAdminApi('flow/area/list'),//来访地区
    flowEnterpageList: setAdminApi('flow/enterpage/list'),//入口页面统计
    statisticChannelList: setAdminApi('statistic/channel/list'),//栏目访问量统计
    statisticContentList: setAdminApi('statistic/content/list'),//获取内容发布统计信息
    statisticWorkloadList: setAdminApi('statistic/workload/list'),//获取工作量统计信息
    localAll: setAdminApi('admin/local_all'),//获取所有管理员
    statisticCommentList: setAdminApi('statistic/comment/list'),//获取评论统计信息
    statisticGuestbookList: setAdminApi('statistic/guestbook/list'),//获取留言统计信息
    commentRecommend: setAdminApi('comment/recommend'),//评论推荐
    commentReply: setAdminApi('comment/reply'),//评论回复
    commentItemList: setAdminApi('comment/list_by_content'),//内容评论管理列表
    voteList: setAdminApi('vote_topic/list'),    //问卷调查列表
    voteGet: setAdminApi('vote_topic/get'),     //问卷调查详情
    voteSave: setAdminApi('vote_topic/save'),    //问卷调查新增
    voteUpdate: setAdminApi('vote_topic/update'),  //问卷调查修改
    voteDelete: setAdminApi('vote_topic/delete'),  //问卷调查删除
    voteSaveContent: setAdminApi('vote_topic/priority'),//调查问卷保存内容

    guestbookList: setAdminApi('guestbook/list'), //留言列表
    guestbookSave: setAdminApi('guestbook/save'), //留言添加
    guestbookGet: setAdminApi('guestbook/get'),//留言详情
    guestbookUpdate: setAdminApi('guestbook/update'), //留言修改
    guestbookDelete: setAdminApi('guestbook/delete'), //留言删除
    guestbookCheck: setAdminApi('guestbook/check'), //留言审核/取消审核
    guestbookRecommend: setAdminApi('guestbook/recommend'),//留言推荐/取消推荐
    guestbookTypeList: setAdminApi('guestbook_ctg/list'),//留言类型列表
    guestbookTypeGet: setAdminApi('guestbook_ctg/get'),// 留言类型详情
    guestbookTypeSave: setAdminApi('guestbook_ctg/save'),//留言类型新增
    guestbookTypeUpdate: setAdminApi('guestbook_ctg/update'),//留言类型修改
    guestbookTypeDelete: setAdminApi('guestbook_ctg/delete'),//留言类型删除

    weixinGet: setAdminApi('weixin/get'),//获取公众号详情
    weixinConfig: setAdminApi('weixin/config'),//设置公众号
    weixinMenuList: setAdminApi('weixinMenu/list'),//获取自定义菜单列表信息
    weixinMenuGet: setAdminApi('weixinMenu/get'),//获取自定义菜单详情信息
    weixinMenuSave: setAdminApi('weixinMenu/save'),//添加自定义菜单信息
    weixinMenuUpdate: setAdminApi('weixinMenu/update'),//修改自定义菜单信息
    weixinMenuDelete: setAdminApi('weixinMenu/delete'),//删除自定义菜单信息
    weixinMessageList: setAdminApi('weixinMessage/list'),//获取回复列表信息
    weixinMessageGet: setAdminApi('weixinMessage/get'),//获取回复详细信息
    weixinMessageSave: setAdminApi('weixinMessage/save'),//添加回复
    weixinMessageUpdate: setAdminApi('weixinMessage/update'),//修改回复
    weixinMessageDelete: setAdminApi('weixinMessage/delete'),//删除回复
    weixinMessageDefaultGet: setAdminApi('weixinMessage/default_get'),//获取默认回复详细信息
    weixinMenuOMenu: setAdminApi('weixinMenu/o_menu'),//修改自定义菜单信息
    ossGet: setAdminApi('oss/get'),//获取云存储oss信息
    ossSave: setAdminApi('oss/save'),//保存oss信息
    ossUpdate: setAdminApi('oss/update'),//修改oss信息
    ossDelete: setAdminApi('oss/delete'),//删除oss信息
    flowVisitorList: setAdminApi('flow/visitor/list'),//忠诚度统计
    staticIndex: setAdminApi('static/index'),//首页静态化
    staticChannel: setAdminApi('static/channel'),//栏目静态化
    staticContent: setAdminApi('static/content'),//内容静态化
    staticProgress: setAdminApi('static/progress'),//查看进度
    staticIndexRemove: setAdminApi('static/index_remove'),//8）静态化首页删除
    jobapplyList: setAdminApi('jobapply/list'),//获取职位申请列表信息
    jobapplyDelete: setAdminApi('jobapply/delete'),//28）职位申请删除接口
    jobapplyView: setAdminApi('jobapply/view'),//简历查看接口
    frameGetDB: setAdminApi('frame/getDB'),//获取数据库类型名称
    mysqlDataList: setAdminApi('mysql/data/list'),//备份数据表列表 mysql
    oracleDataList: setAdminApi('oracle/data/list'),//备份数据表列表 oracle
    sqlserverDataList: setAdminApi('sqlserver/data/list'),//备份数据表列表 sqlserver
    db2DataList: setAdminApi('db2/data/list'),//备份数据表列表 db2
    mysqlDataListfields: setAdminApi('mysql/data/listfields'),//备份数据表详情信息
    oracleDataListfields: setAdminApi('oracle/data/listfields'),//备份数据表详情信息
    sqlserverDataListfields: setAdminApi('sqlserver/data/listfields'),//备份数据表详情信息
    db2DataListfields: setAdminApi('db2/data/listfields'),//备份数据表详情信息
    mysqlDataBackup: setAdminApi('mysql/data/backup'),//备份数据
    oracleDataBackup: setAdminApi('oracle/data/backup'),//备份数据
    sqlserverDataBackup: setAdminApi('sqlserver/data/backup'),//备份数据
    db2DataBackup: setAdminApi('db2/data/backup'),//备份数据

    //数据库恢复
    mysqlDataFiles: setAdminApi('mysql/data/files'),//获取数据库文件列表信息
    oracleDataFiles: setAdminApi('oracle/data/files'),//获取数据库文件列表信息
    sqlserverDataFiles: setAdminApi('sqlserver/data/files'),//获取数据库文件列表信息
    db2DataFiles: setAdminApi('db2/data/files'),//获取数据库文件列表信息
    mysqlDataListDataBases: setAdminApi('mysql/data/listDataBases'),//获取数据库列表信息
    sqlserverDataListDataBases: setAdminApi('sqlserver/data/listDataBases'),//获取数据库列表信息
    mysqlDataRevert: setAdminApi('mysql/data/revert'),//恢复数据库
    oracleDataRevert: setAdminApi('oracle/data/revert'),//恢复数据库
    sqlserverDataRevert: setAdminApi('sqlserver/data/revert'),//恢复数据库
    db2DataRevert: setAdminApi('db2/data/revert'),//恢复数据库

    mysqlDataOrigName: setAdminApi('mysql/data/origName'),//截取原文件名
    oracleDataOrigName: setAdminApi('oracle/data/origName'),//截取原文件名
    sqlserverDataOrigName: setAdminApi('sqlserver/data/origName'),//截取原文件名
    db2DataOrigName: setAdminApi('db2/data/origName'),//截取原文件名
    mysqlDataRename: setAdminApi('mysql/data/rename'),//文件重命名
    oracleDataRename: setAdminApi('oracle/data/rename'),//文件重命名
    sqlserverDataRename: setAdminApi('sqlserver/data/rename'),//文件重命名
    db2DataRename: setAdminApi('db2/data/rename'),//文件重命名
    mysqlDataExport: setAdminApi('mysql/data/export'),//下载文件
    oracleDataExport: setAdminApi('oracle/data/export'),//下载文件
    sqlserverDataExport: setAdminApi('sqlserver/data/export'),//下载文件
    db2DataExport: setAdminApi('db2/data/export'),//下载文件
    mysqlDataDelete: setAdminApi('mysql/data/delete'),//删除文件
    oracleDataDelete: setAdminApi('oracle/data/delete'),//删除文件
    sqlserverDataDelete: setAdminApi('sqlserver/data/delete'),//删除文件
    db2DataDelete: setAdminApi('db2/data/delete'),//删除文件
    mysqlDataDefaultCatalog: setAdminApi('mysql/data/defaultCatalog'),//获取默认数据库名称
    sqlserverDataDefaultCatalog: setAdminApi('sqlserver/data/defaultCatalog'),//获取默认数据库名称
    //标签向导
    directiveList: setAdminApi('directive/list'),//获取标签向导列表信息
    directiveGet: setAdminApi('directive/get'),//获取标签向导详情信息
    directiveSave: setAdminApi('directive/save'),//添加标签向导详情信息
    directiveUpdate: setAdminApi('directive/update'),//修改标签向导详情信息
    directiveDelete: setAdminApi('directive/delete'),//删除标签向导详情信息

    collectList: setAdminApi('acquisition/list'), //采集任务列表
    collectGet: setAdminApi('acquisition/get'), //采集任务详情
    collectSave: setAdminApi('acquisition/save'),//采集任务新增
    collectUpdate: setAdminApi('acquisition/update'),//采集任务修改
    collectDelete: setAdminApi('acquisition/delete'),//采集任务删除
    collectStart: setAdminApi('acquisition/start'),//采集任务开始
    collectEnd: setAdminApi('acquisition/end'),//采集任务停止
    collectPause: setAdminApi('acquisition/pause'),//采集任务暂停
    collectCancel: setAdminApi('acquisition/cancel'),//采集任务取消
    collectHistoryLIst: setAdminApi('acquisition/history'),//采集历史列表
    collectSpeedData: setAdminApi('acquisition/progress_data'),//查看采集进度
    collectHistoryDelete: setAdminApi('acquisition/history_delete'),//采集历史删除
    departmentList: setAdminApi('department/list'),//部门列表
    departmentGet: setAdminApi('department/get'),//部门详情
    departmentSave: setAdminApi('department/save'),//部门添加
    departmentUpdate: setAdminApi('department/update'),//部门修改
    departmentDelete: setAdminApi('department/delete'),//部门删除
    departmentCheckName: setAdminApi('department/check_name'),//部门名称校验
    departmentPriority: setAdminApi('department/priority'),//部门保存排序
    departmentMemberList: setAdminApi('department/member_list'),//部门成员列表
    departmentTree: setAdminApi('department/tree'),//部门树
    getAllChannel: setAdminApi('channel/all'),//获取全站栏目数据


    getTemplateInfo: setAdminApi('template/get'),
    deleteTemplate: setAdminApi('template/delete'),
    creatTemplateFile: setAdminApi('template/dir_save'),
    templateReName: setAdminApi('template/rename'),
    updateResourceInfo: setAdminApi('template/update'),
    addTemplateInfo: setAdminApi('template/save'),
    getTemplateTree: setAdminApi('template/tree'),
    getTemplateList: setAdminApi('template/list'),
    getSolutions: setAdminApi('template/getSolutions'),
    setSolutions: setAdminApi('template/solutionupdate'),





    /**********************************3、以下为添加的cms的方法跳转 end***************************************************/


}

export default api;


